{
  "level": "hp01",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:hp01",
    "objects": "AREAS.E3:hp01.e3",
    "mesh": "TREES.E3:hp01.e3"
  },
  "spawn_point": {
    "position": [
      1514.309451852826,
      596.0903850577026,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1514.309451852826,
      696.0903850577026,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3714.042724609375,
      -4714.78125,
      -300.0
    ],
    "bbox_max": [
      3100.0,
      1221.72412109375,
      1493.904296875
    ],
    "vertex_count": 1589,
    "vertices": [
      [
        -3000.0,
        -3565.30615234375,
        1052.5999755859375
      ],
      [
        -3000.0,
        -3408.73486328125,
        667.6585693359375
      ],
      [
        -3000.0,
        -4714.78125,
        1390.1104736328125
      ],
      [
        -3000.0,
        -4650.2626953125,
        1191.9580078125
      ],
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -800.0,
        -1452.5167236328125,
        0.0
      ],
      [
        -800.0,
        -1855.504150390625,
        287.160888671875
      ],
      [
        -800.0,
        -2100.0,
        508.155517578125
      ],
      [
        -800.0,
        -1855.504150390625,
        287.1609191894531
      ],
      [
        2400.0,
        -796.68505859375,
        0.0
      ],
      [
        2400.0,
        -696.68505859375,
        -300.0
      ],
      [
        2400.0,
        -1246.4334716796875,
        296.4333801269531
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        2400.0,
        -1546.88427734375,
        433.001953125
      ],
      [
        3100.0,
        680.8695678710938,
        242.60870361328125
      ],
      [
        3100.0,
        1221.72412109375,
        266.89654541015625
      ],
      [
        3100.0,
        630.8695678710938,
        177.3913116455078
      ],
      [
        3100.0,
        663.0787963867188,
        241.80979919433594
      ],
      [
        3100.0,
        663.478271484375,
        242.60870361328125
      ],
      [
        3100.0,
        680.8695678710938,
        242.60870361328125
      ],
      [
        3100.0,
        663.478271484375,
        242.60870361328125
      ],
      [
        2955.16357421875,
        668.6530151367188,
        64.04100799560547
      ],
      [
        3100.0,
        663.0787963867188,
        241.80979919433594
      ],
      [
        1910.0,
        670.0,
        149.0
      ],
      [
        1905.0,
        670.0,
        149.0
      ],
      [
        1770.0,
        420.0,
        80.0
      ],
      [
        1770.0,
        420.0,
        140.0
      ],
      [
        1770.0,
        420.0,
        80.0
      ],
      [
        1770.0,
        420.0,
        140.0
      ],
      [
        1770.0,
        -80.0,
        370.0
      ],
      [
        1770.0,
        -80.0,
        140.0
      ],
      [
        1770.0,
        570.0,
        69.9788818359375
      ],
      [
        1770.0,
        636.6666870117188,
        63.31221389770508
      ],
      [
        1770.0,
        420.0,
        80.0
      ],
      [
        1770.0,
        469.78875732421875,
        80.0
      ],
      [
        1770.0,
        420.0,
        80.0
      ],
      [
        1770.0,
        469.78875732421875,
        80.0
      ],
      [
        1770.0,
        483.3333435058594,
        78.66666412353516
      ],
      [
        1770.0,
        570.0,
        69.9788818359375
      ],
      [
        1770.0,
        470.0,
        80.0
      ],
      [
        1770.0,
        483.3333435058594,
        78.66666412353516
      ],
      [
        1770.0,
        470.0,
        80.0
      ],
      [
        1770.0,
        470.0,
        80.0
      ],
      [
        1770.0,
        620.0,
        258.0
      ],
      [
        1770.0,
        620.0,
        338.0
      ],
      [
        1770.0,
        680.0,
        258.0
      ],
      [
        1770.0,
        620.0,
        258.0
      ],
      [
        1770.0,
        700.0,
        258.0
      ],
      [
        1770.0,
        680.0,
        258.0
      ],
      [
        1770.0,
        690.0,
        100.0
      ],
      [
        1770.0,
        680.0,
        100.0
      ],
      [
        1770.0,
        680.0,
        100.0
      ],
      [
        1770.0,
        620.0,
        100.0
      ],
      [
        1770.0,
        670.0,
        60.0
      ],
      [
        1770.0,
        720.0,
        60.0
      ],
      [
        1770.0,
        620.0,
        220.0
      ],
      [
        1770.0,
        670.0,
        220.0
      ],
      [
        1535.0,
        1120.0,
        465.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1455.0,
        1120.0,
        465.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1250.0,
        670.0,
        220.0
      ],
      [
        1600.0,
        980.0,
        515.0
      ],
      [
        1600.0,
        980.0,
        140.0
      ],
      [
        1605.0,
        1030.0,
        140.0
      ],
      [
        1600.0,
        1030.0,
        140.0
      ],
      [
        1600.0,
        1030.0,
        465.0
      ],
      [
        1605.0,
        1030.0,
        465.0
      ],
      [
        1600.0,
        980.0,
        140.0
      ],
      [
        1600.0,
        980.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        98.0
      ],
      [
        1600.0,
        940.0,
        98.0
      ],
      [
        1600.0,
        960.0,
        98.0
      ],
      [
        1600.0,
        720.0,
        60.0
      ],
      [
        1600.0,
        720.0,
        80.0
      ],
      [
        1659.0,
        700.0,
        80.0
      ],
      [
        1770.0,
        670.0,
        258.0
      ],
      [
        1770.0,
        670.0,
        100.0
      ],
      [
        1600.0,
        680.0,
        80.0
      ],
      [
        1600.0,
        700.0,
        80.0
      ],
      [
        1600.0,
        680.0,
        80.0
      ],
      [
        1600.0,
        680.0,
        78.0
      ],
      [
        1564.9998779296875,
        1030.0,
        140.0
      ],
      [
        1564.9998779296875,
        1030.0,
        465.0
      ],
      [
        1570.0,
        980.0,
        140.0
      ],
      [
        1570.0,
        980.0,
        100.0
      ],
      [
        1530.0,
        1030.0,
        140.0
      ],
      [
        1530.0,
        1030.0,
        465.0
      ],
      [
        1535.0,
        980.0,
        140.0
      ],
      [
        1535.0,
        980.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        98.0
      ],
      [
        1530.0,
        960.0,
        98.0
      ],
      [
        1530.0,
        940.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        98.0
      ],
      [
        1550.0,
        840.0,
        135.0
      ],
      [
        1562.5999755859375,
        760.0,
        135.0
      ],
      [
        1562.5999755859375,
        760.0,
        160.0
      ],
      [
        1562.5999755859375,
        760.0,
        135.0
      ],
      [
        1562.5999755859375,
        760.0,
        80.0
      ],
      [
        1562.5999755859375,
        760.0,
        220.0
      ],
      [
        1562.5999755859375,
        760.0,
        160.0
      ],
      [
        1562.5999755859375,
        810.0,
        135.0
      ],
      [
        1562.5999755859375,
        840.0,
        135.0
      ],
      [
        1530.0,
        670.0,
        80.0
      ],
      [
        1530.0,
        680.0,
        80.0
      ],
      [
        1562.5999755859375,
        720.0,
        80.0
      ],
      [
        1562.5999755859375,
        760.0,
        80.0
      ],
      [
        1562.5999755859375,
        680.0,
        80.0
      ],
      [
        1530.0,
        680.0,
        80.0
      ],
      [
        1530.0,
        700.0,
        80.0
      ],
      [
        1562.5999755859375,
        700.0,
        80.0
      ],
      [
        1562.5999755859375,
        720.0,
        60.0
      ],
      [
        1562.5999755859375,
        720.0,
        80.0
      ],
      [
        1562.5999755859375,
        680.0,
        64.82001495361328
      ],
      [
        1562.5999755859375,
        670.0,
        64.82001495361328
      ],
      [
        1538.6363525390625,
        680.0,
        78.0
      ],
      [
        1562.5999755859375,
        680.0,
        80.0
      ],
      [
        1562.5999755859375,
        680.0,
        78.0
      ],
      [
        1562.5999755859375,
        720.0,
        135.0
      ],
      [
        1562.5999755859375,
        725.0,
        135.0
      ],
      [
        1562.5999755859375,
        725.0,
        135.0
      ],
      [
        1562.5999755859375,
        760.0,
        135.0
      ],
      [
        1562.5999755859375,
        760.0,
        135.0
      ],
      [
        1562.5999755859375,
        725.0,
        135.0
      ],
      [
        1562.5999755859375,
        720.0,
        110.0
      ],
      [
        1562.5999755859375,
        725.0,
        110.0
      ],
      [
        1562.5999755859375,
        720.0,
        105.0
      ],
      [
        1562.5999755859375,
        725.0,
        105.0
      ],
      [
        1535.0,
        720.0,
        110.0
      ],
      [
        1562.5999755859375,
        720.0,
        105.0
      ],
      [
        1562.5999755859375,
        720.0,
        110.0
      ],
      [
        1562.5999755859375,
        725.0,
        130.0
      ],
      [
        1562.5999755859375,
        720.0,
        130.0
      ],
      [
        1562.5999755859375,
        720.0,
        130.0
      ],
      [
        1562.5999755859375,
        720.0,
        135.0
      ],
      [
        1525.0001220703125,
        1030.0,
        140.0
      ],
      [
        1485.0,
        1030.0,
        140.0
      ],
      [
        1485.0,
        1030.0,
        465.0
      ],
      [
        1525.0001220703125,
        1030.0,
        465.0
      ],
      [
        1490.0,
        980.0,
        140.0
      ],
      [
        1520.0,
        980.0,
        140.0
      ],
      [
        1520.0,
        980.0,
        100.0
      ],
      [
        1490.0,
        980.0,
        100.0
      ],
      [
        1490.0,
        980.0,
        100.0
      ],
      [
        1520.0,
        980.0,
        100.0
      ],
      [
        1519.0001220703125,
        970.0,
        80.0
      ],
      [
        1491.0,
        970.0,
        80.0
      ],
      [
        1491.0,
        970.0,
        80.0
      ],
      [
        1519.0001220703125,
        970.0,
        80.0
      ],
      [
        1518.0,
        960.0,
        80.0
      ],
      [
        1492.0,
        960.0,
        80.0
      ],
      [
        1530.0,
        960.0,
        80.0
      ],
      [
        1445.0,
        1030.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        465.0
      ],
      [
        1445.0,
        1030.0,
        465.0
      ],
      [
        1410.0,
        980.0,
        140.0
      ],
      [
        1440.0001220703125,
        980.0,
        140.0
      ],
      [
        1440.0001220703125,
        980.0,
        100.0
      ],
      [
        1410.0,
        980.0,
        100.0
      ],
      [
        1410.0,
        980.0,
        100.0
      ],
      [
        1440.0001220703125,
        980.0,
        100.0
      ],
      [
        1439.0,
        970.0,
        80.0
      ],
      [
        1411.0,
        970.0,
        80.0
      ],
      [
        1438.0,
        960.0,
        80.0
      ],
      [
        1412.0,
        960.0,
        80.0
      ],
      [
        1411.0,
        970.0,
        80.0
      ],
      [
        1439.0,
        970.0,
        80.0
      ],
      [
        1380.0,
        960.0,
        80.0
      ],
      [
        1455.0,
        980.0,
        140.0
      ],
      [
        1455.0,
        980.0,
        100.0
      ],
      [
        1455.0,
        980.0,
        100.0
      ],
      [
        1455.0,
        970.0,
        80.0
      ],
      [
        1455.0,
        960.0,
        80.0
      ],
      [
        1455.0,
        970.0,
        80.0
      ],
      [
        1480.0,
        960.0,
        80.0
      ],
      [
        1480.0,
        960.0,
        80.0
      ],
      [
        1480.0,
        960.0,
        98.0
      ],
      [
        1520.0,
        933.3333129882812,
        81.33333587646484
      ],
      [
        1510.0,
        933.3333129882812,
        81.33333587646484
      ],
      [
        1520.0,
        936.6666870117188,
        81.66666412353516
      ],
      [
        1520.0,
        933.3333129882812,
        81.33333587646484
      ],
      [
        1500.0,
        720.0,
        100.0
      ],
      [
        1500.0,
        720.0,
        98.0
      ],
      [
        1500.0,
        720.0,
        98.0
      ],
      [
        1500.0,
        720.0,
        100.0
      ],
      [
        1520.0,
        904.0,
        98.0
      ],
      [
        1440.0,
        675.0,
        160.0
      ],
      [
        1440.0,
        675.0,
        338.0
      ],
      [
        1470.0,
        675.0,
        160.0
      ],
      [
        1470.0,
        675.0,
        338.0
      ],
      [
        1469.9000244140625,
        670.0,
        338.0
      ],
      [
        1470.0,
        675.0,
        338.0
      ],
      [
        1469.9000244140625,
        675.0,
        338.0
      ],
      [
        1440.0,
        675.0,
        338.0
      ],
      [
        1472.0,
        680.0,
        78.0
      ],
      [
        1438.0,
        680.0,
        78.0
      ],
      [
        1438.0,
        680.0,
        80.0
      ],
      [
        1472.0,
        680.0,
        80.0
      ],
      [
        1438.0,
        700.0,
        98.0
      ],
      [
        1472.0,
        700.0,
        98.0
      ],
      [
        1472.0,
        720.0,
        98.0
      ],
      [
        1438.0,
        720.0,
        98.0
      ],
      [
        1438.0,
        720.0,
        100.0
      ],
      [
        1472.0,
        720.0,
        100.0
      ],
      [
        1472.0,
        700.0,
        100.0
      ],
      [
        1438.0,
        700.0,
        100.0
      ],
      [
        1438.0,
        700.0,
        100.0
      ],
      [
        1472.0,
        700.0,
        100.0
      ],
      [
        1472.0,
        700.0,
        98.0
      ],
      [
        1438.0,
        700.0,
        98.0
      ],
      [
        1472.0,
        680.0,
        80.0
      ],
      [
        1438.0,
        680.0,
        80.0
      ],
      [
        1438.0,
        700.0,
        80.0
      ],
      [
        1472.0,
        700.0,
        80.0
      ],
      [
        1511.181884765625,
        680.0,
        78.0
      ],
      [
        1250.0,
        670.0,
        100.0
      ],
      [
        1250.0,
        670.0,
        100.0
      ],
      [
        1270.0,
        670.0,
        100.0
      ],
      [
        1394.0,
        700.0,
        98.0
      ],
      [
        1394.0,
        690.0,
        98.0
      ],
      [
        1394.0,
        690.0,
        98.0
      ],
      [
        1270.0,
        670.0,
        98.0
      ],
      [
        1270.0,
        670.0,
        100.0
      ],
      [
        1438.0,
        690.0,
        80.0
      ],
      [
        1275.7142333984375,
        670.0,
        61.41952133178711
      ],
      [
        1270.0,
        670.0,
        61.818180084228516
      ],
      [
        1275.7142333984375,
        670.0,
        61.41952133178711
      ],
      [
        1260.0,
        670.0,
        258.0
      ],
      [
        1002.6842651367188,
        944.4000244140625,
        220.0
      ],
      [
        997.1622924804688,
        945.186279296875,
        242.46412658691406
      ],
      [
        950.0,
        891.7157592773438,
        220.0
      ],
      [
        950.0,
        924.773681640625,
        337.72265625
      ],
      [
        310.0,
        670.0,
        160.0
      ],
      [
        310.0,
        670.0,
        420.0
      ],
      [
        1562.5999755859375,
        510.0,
        91.0
      ],
      [
        1562.5999755859375,
        510.0,
        80.0
      ],
      [
        1562.5999755859375,
        510.0,
        98.0
      ],
      [
        1562.5999755859375,
        510.0,
        91.0
      ],
      [
        1562.5999755859375,
        510.0,
        125.0
      ],
      [
        1562.5999755859375,
        510.0,
        118.0
      ],
      [
        1562.5999755859375,
        510.0,
        107.5
      ],
      [
        1562.5999755859375,
        510.0,
        100.0
      ],
      [
        1562.5999755859375,
        510.0,
        107.5
      ],
      [
        1562.5999755859375,
        510.0,
        118.0
      ],
      [
        1562.5999755859375,
        510.0,
        125.0
      ],
      [
        1562.5999755859375,
        510.0,
        140.0
      ],
      [
        1425.3846435546875,
        510.0,
        80.0
      ],
      [
        1425.3846435546875,
        510.0,
        98.0
      ],
      [
        1480.0,
        510.0,
        338.0
      ],
      [
        1480.0,
        510.0,
        258.0
      ],
      [
        1480.0,
        510.0,
        140.0
      ],
      [
        1480.0,
        510.0,
        258.0
      ],
      [
        1390.0,
        650.0,
        317.0
      ],
      [
        1390.0,
        670.0,
        317.0
      ],
      [
        1425.3846435546875,
        510.0,
        80.0
      ],
      [
        1425.3846435546875,
        510.0,
        98.0
      ],
      [
        1410.0,
        545.6636962890625,
        119.6106185913086
      ],
      [
        1430.0,
        545.6636962890625,
        119.6106185913086
      ],
      [
        1430.0,
        545.6636962890625,
        119.6106185913086
      ],
      [
        1430.0,
        542.5,
        118.0
      ],
      [
        1410.0,
        542.5,
        118.0
      ],
      [
        1410.0,
        522.5,
        118.0
      ],
      [
        1410.0,
        542.5,
        118.0
      ],
      [
        1410.0,
        545.6636962890625,
        119.6106185913086
      ],
      [
        1410.0,
        522.5,
        118.0
      ],
      [
        1430.0,
        522.5,
        118.0
      ],
      [
        1473.0,
        590.0,
        122.19993591308594
      ],
      [
        1473.0,
        590.0,
        122.19993591308594
      ],
      [
        1470.0,
        590.0,
        118.0
      ],
      [
        1473.0,
        570.0,
        122.19993591308594
      ],
      [
        1470.0,
        570.0,
        118.0
      ],
      [
        1473.0,
        570.0,
        122.19993591308594
      ],
      [
        1410.0,
        558.75,
        118.0
      ],
      [
        1430.0,
        558.75,
        118.0
      ],
      [
        1430.0,
        558.75,
        118.0
      ],
      [
        1410.0,
        558.75,
        118.0
      ],
      [
        1480.0,
        605.0,
        125.0
      ],
      [
        1480.0,
        605.0,
        125.0
      ],
      [
        1410.0,
        634.0,
        113.99999237060547
      ],
      [
        1410.0,
        636.8283081054688,
        115.17152404785156
      ],
      [
        1410.0,
        638.0,
        118.0
      ],
      [
        1410.0,
        629.9999389648438,
        118.0
      ],
      [
        1410.0,
        631.1715698242188,
        115.1716079711914
      ],
      [
        1410.0,
        629.9999389648438,
        118.0
      ],
      [
        1410.0,
        638.0,
        118.0
      ],
      [
        1410.0,
        636.8283081054688,
        115.17152404785156
      ],
      [
        1410.0,
        634.0,
        113.99999237060547
      ],
      [
        1410.0,
        631.1715698242188,
        115.1716079711914
      ],
      [
        1410.0,
        632.0000610351562,
        113.17156219482422
      ],
      [
        1410.0,
        632.0000610351562,
        113.17156219482422
      ],
      [
        1410.0,
        643.65673828125,
        118.0
      ],
      [
        1410.0,
        643.65673828125,
        118.0
      ],
      [
        1410.0,
        621.0,
        108.61512756347656
      ],
      [
        1410.0,
        621.0,
        108.61512756347656
      ],
      [
        1390.0,
        650.0,
        114.41419982910156
      ],
      [
        1410.0,
        650.0,
        114.4142074584961
      ],
      [
        1410.0,
        653.0000610351562,
        118.0
      ],
      [
        1410.0,
        651.8284301757812,
        115.17158508300781
      ],
      [
        1410.0,
        650.0,
        114.4142074584961
      ],
      [
        1410.0,
        650.0,
        114.41419982910156
      ],
      [
        1410.0,
        644.9999389648438,
        118.0
      ],
      [
        1410.0,
        646.1715698242188,
        115.17158508300781
      ],
      [
        1410.0,
        649.0,
        114.0
      ],
      [
        1410.0,
        644.9999389648438,
        118.0
      ],
      [
        1410.0,
        649.0,
        113.99998474121094
      ],
      [
        1410.0,
        646.1715698242188,
        115.17157745361328
      ],
      [
        1390.0,
        650.0,
        113.5857925415039
      ],
      [
        1410.0,
        650.0,
        113.5857925415039
      ],
      [
        1410.0,
        650.9999389648438,
        113.17155456542969
      ],
      [
        1410.0,
        650.0,
        113.58575439453125
      ],
      [
        1410.0,
        650.0,
        114.4142074584961
      ],
      [
        1410.0,
        650.0,
        113.5857925415039
      ],
      [
        1390.0,
        650.0,
        110.7575912475586
      ],
      [
        1410.0,
        650.0,
        110.7575912475586
      ],
      [
        1410.0,
        650.0,
        110.75762939453125
      ],
      [
        1410.0,
        650.0,
        113.58575439453125
      ],
      [
        1410.0,
        649.0,
        108.34353637695312
      ],
      [
        1410.0,
        650.0,
        110.7575912475586
      ],
      [
        1410.0,
        649.0,
        108.34355926513672
      ],
      [
        1410.0,
        621.0,
        104.0
      ],
      [
        1410.0,
        621.0,
        103.0
      ],
      [
        1410.0,
        622.0,
        103.0
      ],
      [
        1410.0,
        622.0,
        104.0
      ],
      [
        1410.0,
        621.0,
        103.0
      ],
      [
        1410.0,
        621.0,
        104.0
      ],
      [
        1410.0,
        622.0,
        104.0
      ],
      [
        1410.0,
        622.0,
        103.0
      ],
      [
        1410.0,
        646.7865600585938,
        103.0
      ],
      [
        1410.0,
        647.2008056640625,
        104.0
      ],
      [
        1410.0,
        647.2007446289062,
        104.0
      ],
      [
        1410.0,
        646.7864990234375,
        103.0
      ],
      [
        1410.0,
        644.7153930664062,
        98.0
      ],
      [
        1410.0,
        645.5438232421875,
        100.0
      ],
      [
        1410.0,
        644.7153930664062,
        98.0
      ],
      [
        1410.0,
        645.5438232421875,
        100.0
      ],
      [
        1422.0,
        669.0,
        98.0
      ],
      [
        1423.0,
        669.0,
        98.0
      ],
      [
        1467.0,
        669.0,
        98.0
      ],
      [
        1468.0,
        669.0,
        98.0
      ],
      [
        1424.0,
        670.0,
        106.0
      ],
      [
        1424.0,
        669.0,
        106.0
      ],
      [
        1466.0,
        669.0,
        106.0
      ],
      [
        1466.0,
        670.0,
        106.0
      ],
      [
        1410.0,
        669.0,
        106.0
      ],
      [
        1410.0,
        669.0,
        107.0
      ],
      [
        1410.0,
        670.0,
        107.0
      ],
      [
        1410.0,
        670.0,
        106.0
      ],
      [
        1422.0,
        670.0,
        98.0
      ],
      [
        1422.0,
        669.0,
        98.0
      ],
      [
        1468.0,
        669.0,
        98.0
      ],
      [
        1468.0,
        670.0,
        98.0
      ],
      [
        1423.0,
        669.0,
        98.0
      ],
      [
        1423.0,
        670.0,
        98.0
      ],
      [
        1467.0,
        670.0,
        98.0
      ],
      [
        1467.0,
        669.0,
        98.0
      ],
      [
        1410.0,
        669.0,
        100.0
      ],
      [
        1410.0,
        669.0,
        98.0
      ],
      [
        1410.0,
        669.0,
        100.0
      ],
      [
        1410.0,
        669.0,
        118.0
      ],
      [
        1430.0,
        542.5,
        116.0
      ],
      [
        1440.0,
        566.0714111328125,
        116.0
      ],
      [
        1440.0,
        542.5,
        116.0
      ],
      [
        1440.0,
        522.5,
        116.0
      ],
      [
        1430.0,
        522.5,
        116.0
      ],
      [
        1440.0,
        542.5,
        116.0
      ],
      [
        1430.0,
        542.5,
        116.0
      ],
      [
        1460.0,
        522.5,
        116.0
      ],
      [
        1460.0,
        542.5,
        116.0
      ],
      [
        1460.0,
        542.5,
        116.0
      ],
      [
        1460.0,
        566.0714111328125,
        116.0
      ],
      [
        1460.0,
        566.0714111328125,
        116.0
      ],
      [
        1440.0,
        566.0714111328125,
        116.0
      ],
      [
        1460.0,
        522.5,
        116.0
      ],
      [
        1440.0,
        522.5,
        116.0
      ],
      [
        1410.0,
        610.0,
        116.0
      ],
      [
        1410.0,
        620.0,
        116.0
      ],
      [
        1410.0,
        542.5,
        116.0
      ],
      [
        1410.0,
        522.5,
        116.0
      ],
      [
        1410.0,
        542.5,
        116.0
      ],
      [
        1390.0,
        620.0,
        116.0
      ],
      [
        1410.0,
        620.0,
        116.0
      ],
      [
        1410.0,
        610.0,
        116.0
      ],
      [
        1390.0,
        610.0,
        116.0
      ],
      [
        1410.0,
        522.5,
        116.0
      ],
      [
        1430.0,
        522.5,
        116.0
      ],
      [
        1390.0,
        620.0,
        100.0
      ],
      [
        1410.0,
        620.0,
        100.0
      ],
      [
        1410.0,
        610.0,
        100.0
      ],
      [
        1390.0,
        610.0,
        100.0
      ],
      [
        1410.0,
        620.0,
        100.0
      ],
      [
        1410.0,
        610.0,
        100.0
      ],
      [
        1410.0,
        522.5,
        106.4615478515625
      ],
      [
        1430.0,
        522.5,
        106.4615478515625
      ],
      [
        1410.0,
        522.5,
        106.4615478515625
      ],
      [
        1410.0,
        620.0,
        116.0
      ],
      [
        1410.0,
        620.0,
        100.0
      ],
      [
        1410.0,
        620.0,
        103.0
      ],
      [
        1412.0,
        620.0,
        103.0
      ],
      [
        1410.0,
        620.0,
        102.0
      ],
      [
        1412.0,
        620.0,
        102.0
      ],
      [
        1412.0,
        620.0,
        103.0
      ],
      [
        1412.0,
        620.0,
        102.0
      ],
      [
        1410.0,
        610.0,
        100.0
      ],
      [
        1410.0,
        610.0,
        116.0
      ],
      [
        1410.0,
        610.0,
        103.0
      ],
      [
        1412.0,
        610.0,
        103.0
      ],
      [
        1410.0,
        610.0,
        102.0
      ],
      [
        1412.0,
        610.0,
        102.0
      ],
      [
        1412.0,
        610.0,
        103.0
      ],
      [
        1412.0,
        610.0,
        102.0
      ],
      [
        1410.0,
        620.0,
        91.0
      ],
      [
        1390.0,
        620.0,
        91.0
      ],
      [
        1410.0,
        620.0,
        91.0
      ],
      [
        1410.0,
        620.0,
        90.0
      ],
      [
        1410.0,
        650.0,
        91.0
      ],
      [
        1410.0,
        663.0,
        91.0
      ],
      [
        1410.0,
        621.0,
        91.0
      ],
      [
        1410.0,
        650.0,
        91.0
      ],
      [
        1410.0,
        670.0,
        91.0
      ],
      [
        1410.0,
        650.0,
        91.0
      ],
      [
        1390.0,
        621.0,
        91.0
      ],
      [
        1410.0,
        621.0,
        91.0
      ],
      [
        1409.5,
        620.0,
        90.0
      ],
      [
        1410.0,
        620.0,
        90.0
      ],
      [
        1409.5,
        620.0,
        90.0
      ],
      [
        1409.5,
        620.0,
        91.0
      ],
      [
        1410.0,
        650.0,
        83.5
      ],
      [
        1410.0,
        650.0,
        84.0
      ],
      [
        1414.0,
        650.0,
        83.5
      ],
      [
        1410.0,
        621.0,
        84.0
      ],
      [
        1410.0,
        621.0,
        83.5
      ],
      [
        1414.0,
        621.0,
        83.5
      ],
      [
        1414.0,
        621.0,
        84.0
      ],
      [
        1414.0,
        621.0,
        80.0
      ],
      [
        1414.0,
        667.0,
        86.0
      ],
      [
        1414.0,
        666.0,
        86.0
      ],
      [
        1414.0,
        670.0,
        86.0
      ],
      [
        1414.0,
        667.0,
        86.0
      ],
      [
        1412.5,
        621.0,
        85.0
      ],
      [
        1410.0,
        621.0,
        86.0
      ],
      [
        1412.5,
        621.0,
        85.0
      ],
      [
        1411.0,
        621.0,
        86.0
      ],
      [
        1414.0,
        666.0,
        86.0
      ],
      [
        1414.0,
        621.0,
        85.0
      ],
      [
        1414.0,
        621.0,
        85.0
      ],
      [
        1414.0,
        621.0,
        86.0
      ],
      [
        1414.0,
        621.0,
        91.0
      ],
      [
        1472.0,
        640.0,
        91.0
      ],
      [
        1472.0,
        621.0,
        91.0
      ],
      [
        1472.0,
        640.0,
        91.0
      ],
      [
        1480.0,
        640.0,
        91.0
      ],
      [
        1472.0,
        621.0,
        91.0
      ],
      [
        1472.0,
        621.0,
        80.0
      ],
      [
        1472.0,
        621.0,
        91.0
      ],
      [
        1480.0,
        621.0,
        91.0
      ],
      [
        1472.0,
        669.0,
        86.0
      ],
      [
        1472.0,
        670.0,
        86.0
      ],
      [
        1476.0,
        650.0,
        83.5
      ],
      [
        1480.0,
        650.0,
        84.0
      ],
      [
        1480.0,
        650.0,
        83.5
      ],
      [
        1476.0,
        666.0,
        86.0
      ],
      [
        1472.0,
        666.9998779296875,
        84.66658782958984
      ],
      [
        1472.0,
        669.0,
        86.0
      ],
      [
        1472.0,
        666.0,
        80.0
      ],
      [
        1472.0,
        666.0,
        84.0
      ],
      [
        1472.0,
        666.0,
        84.0
      ],
      [
        1450.0,
        666.0,
        86.0
      ],
      [
        1440.0,
        666.0,
        86.0
      ],
      [
        1440.0,
        666.0,
        87.5999984741211
      ],
      [
        1450.0,
        666.0,
        87.5999984741211
      ],
      [
        1424.0,
        669.0,
        91.0
      ],
      [
        1423.0,
        669.0,
        91.0
      ],
      [
        1467.0,
        669.0,
        91.0
      ],
      [
        1466.0,
        669.0,
        91.0
      ],
      [
        1440.0,
        669.0,
        90.0
      ],
      [
        1450.0,
        669.0,
        90.0
      ],
      [
        1450.0,
        670.0,
        89.0
      ],
      [
        1450.0,
        669.0,
        89.0
      ],
      [
        1450.0,
        669.0,
        90.0
      ],
      [
        1424.0,
        669.0,
        90.0
      ],
      [
        1424.0,
        670.0,
        90.0
      ],
      [
        1440.0,
        669.0,
        90.0
      ],
      [
        1440.0,
        669.0,
        89.0
      ],
      [
        1440.0,
        670.0,
        89.0
      ],
      [
        1466.0,
        670.0,
        90.0
      ],
      [
        1466.0,
        669.0,
        90.0
      ],
      [
        1424.0,
        670.0,
        91.0
      ],
      [
        1424.0,
        669.0,
        91.0
      ],
      [
        1423.0,
        669.0,
        91.0
      ],
      [
        1423.0,
        670.0,
        91.0
      ],
      [
        1466.0,
        669.0,
        91.0
      ],
      [
        1466.0,
        670.0,
        91.0
      ],
      [
        1467.0,
        670.0,
        91.0
      ],
      [
        1467.0,
        669.0,
        91.0
      ],
      [
        1450.0,
        666.875,
        89.0
      ],
      [
        1440.0,
        666.875,
        89.0
      ],
      [
        1450.0,
        666.0,
        86.0
      ],
      [
        1450.0,
        666.0,
        87.5999984741211
      ],
      [
        1440.0,
        666.0,
        87.5999984741211
      ],
      [
        1440.0,
        666.0,
        86.0
      ],
      [
        1430.0,
        626.0,
        85.0
      ],
      [
        1430.0,
        626.0,
        84.0
      ],
      [
        1435.0,
        626.0,
        84.0
      ],
      [
        1435.0,
        626.0,
        85.0
      ],
      [
        1430.0,
        621.0,
        85.0
      ],
      [
        1430.0,
        621.0,
        84.0
      ],
      [
        1430.0,
        626.0,
        84.0
      ],
      [
        1430.0,
        626.0,
        85.0
      ],
      [
        1435.0,
        626.0,
        91.0
      ],
      [
        1435.0,
        626.0,
        80.0
      ],
      [
        1447.5,
        665.0,
        80.0
      ],
      [
        1442.5,
        665.0,
        80.0
      ],
      [
        1442.5,
        665.0,
        84.0
      ],
      [
        1447.5,
        665.0,
        84.0
      ],
      [
        1450.0,
        665.0,
        84.0
      ],
      [
        1450.0,
        665.0,
        84.0
      ],
      [
        1442.5,
        665.0,
        86.0
      ],
      [
        1442.5,
        665.0,
        86.0
      ],
      [
        1442.5,
        666.0,
        87.5999984741211
      ],
      [
        1410.0,
        620.0,
        91.0
      ],
      [
        1410.0,
        620.0,
        98.0
      ],
      [
        1410.0,
        620.0,
        98.0
      ],
      [
        1410.0,
        620.0,
        91.0
      ],
      [
        1441.2071533203125,
        639.25,
        95.25
      ],
      [
        1441.2071533203125,
        639.75,
        95.25
      ],
      [
        1448.7928466796875,
        645.25,
        95.25
      ],
      [
        1448.7928466796875,
        645.75,
        95.25
      ],
      [
        1370.0,
        565.0,
        118.0
      ],
      [
        1380.0,
        565.0,
        118.0
      ],
      [
        1360.0,
        565.0,
        118.0
      ],
      [
        1370.0,
        565.0,
        118.0
      ],
      [
        1370.0,
        574.800048828125,
        118.0
      ],
      [
        1380.0,
        574.800048828125,
        118.0
      ],
      [
        1370.0,
        574.800048828125,
        118.0
      ],
      [
        1360.0,
        574.800048828125,
        118.0
      ],
      [
        1380.0,
        574.800048828125,
        118.0
      ],
      [
        1380.0,
        565.0,
        118.0
      ],
      [
        1360.0,
        574.800048828125,
        118.0
      ],
      [
        1360.0,
        565.0,
        118.0
      ],
      [
        1367.9476318359375,
        610.0,
        116.0
      ],
      [
        1389.0,
        610.0,
        116.0
      ],
      [
        1360.0,
        574.800048828125,
        117.0
      ],
      [
        1360.0,
        565.0,
        117.0
      ],
      [
        1360.0,
        620.0,
        116.0
      ],
      [
        1367.9476318359375,
        610.0,
        116.0
      ],
      [
        1389.0,
        610.0,
        116.0
      ],
      [
        1389.0,
        620.0,
        116.0
      ],
      [
        1367.9476318359375,
        610.0,
        100.0
      ],
      [
        1389.0,
        610.0,
        100.0
      ],
      [
        1360.0,
        620.0,
        100.0
      ],
      [
        1367.9476318359375,
        610.0,
        100.0
      ],
      [
        1340.0,
        620.0,
        100.0
      ],
      [
        1350.0,
        620.0,
        100.0
      ],
      [
        1389.0,
        620.0,
        100.0
      ],
      [
        1389.0,
        610.0,
        100.0
      ],
      [
        1354.285400390625,
        609.1243896484375,
        100.0
      ],
      [
        1354.6239013671875,
        609.5380249023438,
        103.0
      ],
      [
        1352.314697265625,
        609.1243896484375,
        100.0
      ],
      [
        1351.9761962890625,
        609.5380249023438,
        103.0
      ],
      [
        1351.9761962890625,
        609.5380249023438,
        103.0
      ],
      [
        1354.6239013671875,
        609.5380249023438,
        103.0
      ],
      [
        1357.699951171875,
        609.344970703125,
        101.5999984741211
      ],
      [
        1357.699951171875,
        609.1243896484375,
        100.0
      ],
      [
        1357.699951171875,
        609.344970703125,
        101.5999984741211
      ],
      [
        1389.300048828125,
        609.3002319335938,
        102.0
      ],
      [
        1357.699951171875,
        609.2999877929688,
        102.0
      ],
      [
        1354.472900390625,
        608.7997436523438,
        100.0
      ],
      [
        1354.5689697265625,
        609.2998657226562,
        102.0
      ],
      [
        1354.5111083984375,
        609.400146484375,
        102.0
      ],
      [
        1352.127197265625,
        608.7997436523438,
        100.0
      ],
      [
        1352.0889892578125,
        609.400146484375,
        102.0
      ],
      [
        1352.0311279296875,
        609.2998657226562,
        102.0
      ],
      [
        1357.699951171875,
        609.2999877929688,
        102.0
      ],
      [
        1354.6119384765625,
        609.5233154296875,
        102.8934555053711
      ],
      [
        1351.9881591796875,
        609.5233154296875,
        102.8934555053711
      ],
      [
        1372.0,
        578.0,
        105.0
      ],
      [
        1372.0,
        580.0,
        105.0
      ],
      [
        1370.0,
        580.0,
        105.0
      ],
      [
        1370.0,
        578.0,
        105.0
      ],
      [
        1355.35791015625,
        607.800048828125,
        101.5999984741211
      ],
      [
        1355.4349365234375,
        607.800048828125,
        102.0
      ],
      [
        1354.5689697265625,
        609.2998657226562,
        102.0
      ],
      [
        1354.5498046875,
        609.1998291015625,
        101.5999984741211
      ],
      [
        1352.05029296875,
        609.1998291015625,
        101.5999984741211
      ],
      [
        1352.0311279296875,
        609.2998657226562,
        102.0
      ],
      [
        1351.1651611328125,
        607.800048828125,
        102.0
      ],
      [
        1351.2421875,
        607.800048828125,
        101.5999984741211
      ],
      [
        1355.4349365234375,
        607.800048828125,
        102.0
      ],
      [
        1355.35791015625,
        607.800048828125,
        101.5999984741211
      ],
      [
        1355.0115966796875,
        607.2001953125,
        101.5999984741211
      ],
      [
        1354.9730224609375,
        607.0,
        102.0
      ],
      [
        1351.2421875,
        607.800048828125,
        101.5999984741211
      ],
      [
        1351.1651611328125,
        607.800048828125,
        102.0
      ],
      [
        1351.6270751953125,
        607.0,
        102.0
      ],
      [
        1351.5885009765625,
        607.2001953125,
        101.5999984741211
      ],
      [
        1354.93408203125,
        608.0009155273438,
        100.0
      ],
      [
        1355.1273193359375,
        607.800048828125,
        100.40135192871094
      ],
      [
        1351.666015625,
        608.0009155273438,
        100.0
      ],
      [
        1351.4727783203125,
        607.800048828125,
        100.40135192871094
      ],
      [
        1355.1273193359375,
        607.800048828125,
        100.40135192871094
      ],
      [
        1351.4727783203125,
        607.800048828125,
        100.40135192871094
      ],
      [
        1354.8765869140625,
        606.49951171875,
        103.0
      ],
      [
        1351.7235107421875,
        606.49951171875,
        103.0
      ],
      [
        1354.8765869140625,
        606.49951171875,
        103.0
      ],
      [
        1351.7235107421875,
        606.49951171875,
        103.0
      ],
      [
        1354.66064453125,
        606.4994506835938,
        103.0
      ],
      [
        1355.0146484375,
        606.1455078125,
        103.70722198486328
      ],
      [
        1355.0146484375,
        606.1455078125,
        103.70722198486328
      ],
      [
        1354.66064453125,
        606.4994506835938,
        103.0
      ],
      [
        1353.35302734375,
        607.80712890625,
        103.0
      ],
      [
        1352.04541015625,
        606.49951171875,
        103.0
      ],
      [
        1351.691162109375,
        606.145263671875,
        103.70777130126953
      ],
      [
        1353.35302734375,
        607.80712890625,
        112.0
      ],
      [
        1351.691162109375,
        606.145263671875,
        103.70777130126953
      ],
      [
        1352.04541015625,
        606.49951171875,
        103.0
      ],
      [
        1353.35302734375,
        607.80712890625,
        103.0
      ],
      [
        1353.35302734375,
        607.80712890625,
        112.0
      ],
      [
        1351.96337890625,
        606.41748046875,
        103.163818359375
      ],
      [
        1351.683837890625,
        606.49951171875,
        103.0
      ],
      [
        1354.7425537109375,
        606.4175415039062,
        103.16371154785156
      ],
      [
        1351.96337890625,
        606.41748046875,
        103.163818359375
      ],
      [
        1355.02197265625,
        606.4994506835938,
        103.0
      ],
      [
        1354.7425537109375,
        606.4175415039062,
        103.16371154785156
      ],
      [
        1344.4964599609375,
        584.7792358398438,
        111.22642517089844
      ],
      [
        1344.8323974609375,
        585.1151733398438,
        112.04952239990234
      ],
      [
        1345.1859130859375,
        584.7616577148438,
        112.04952239990234
      ],
      [
        1344.85009765625,
        584.42578125,
        111.22683715820312
      ],
      [
        1345.1859130859375,
        584.7616577148438,
        112.04952239990234
      ],
      [
        1344.8323974609375,
        585.1151733398438,
        112.04952239990234
      ],
      [
        1344.85009765625,
        585.1328735351562,
        112.0423355102539
      ],
      [
        1345.20361328125,
        584.7793579101562,
        112.0423355102539
      ],
      [
        1345.5361328125,
        585.818603515625,
        111.76371002197266
      ],
      [
        1345.8895263671875,
        585.4652099609375,
        111.76371002197266
      ],
      [
        1344.8323974609375,
        584.4080810546875,
        111.1834945678711
      ],
      [
        1344.4788818359375,
        584.76171875,
        111.1834945678711
      ],
      [
        1295.5,
        668.0,
        102.0
      ],
      [
        1295.5,
        668.0,
        103.0
      ],
      [
        1303.5,
        668.0,
        103.0
      ],
      [
        1303.5,
        668.0,
        102.0
      ],
      [
        1303.5,
        668.0,
        98.0
      ],
      [
        1305.5,
        668.0,
        103.0
      ],
      [
        1305.5,
        668.0,
        103.0
      ],
      [
        1291.0,
        668.0,
        98.5
      ],
      [
        1291.5,
        668.0,
        98.5
      ],
      [
        1291.5,
        665.5,
        98.5
      ],
      [
        1291.0,
        665.5,
        98.5
      ],
      [
        1311.5,
        668.0,
        98.5
      ],
      [
        1312.0,
        668.0,
        98.5
      ],
      [
        1312.0,
        665.5,
        98.5
      ],
      [
        1311.5,
        665.5,
        98.5
      ],
      [
        1335.5,
        668.0,
        102.0
      ],
      [
        1335.5,
        668.0,
        103.0
      ],
      [
        1343.5,
        668.0,
        103.0
      ],
      [
        1343.5,
        668.0,
        102.0
      ],
      [
        1343.5,
        668.0,
        98.0
      ],
      [
        1345.5,
        668.0,
        103.0
      ],
      [
        1345.5,
        668.0,
        103.0
      ],
      [
        1331.5,
        668.0,
        98.5
      ],
      [
        1332.0,
        668.0,
        98.5
      ],
      [
        1332.0,
        665.5,
        98.5
      ],
      [
        1331.5,
        665.5,
        98.5
      ],
      [
        1370.0,
        646.8038330078125,
        118.0
      ],
      [
        1370.0,
        646.8038330078125,
        117.0
      ],
      [
        1368.196044921875,
        645.0,
        118.0
      ],
      [
        1368.196044921875,
        645.0,
        117.0
      ],
      [
        1356.0,
        668.0,
        102.0
      ],
      [
        1356.0,
        668.0,
        103.0
      ],
      [
        1364.0,
        668.0,
        103.0
      ],
      [
        1364.0,
        668.0,
        102.0
      ],
      [
        1364.0,
        668.0,
        98.0
      ],
      [
        1366.0,
        668.0,
        103.0
      ],
      [
        1366.0,
        668.0,
        103.0
      ],
      [
        1351.5,
        668.0,
        98.5
      ],
      [
        1352.0,
        668.0,
        98.5
      ],
      [
        1352.0,
        665.5,
        98.5
      ],
      [
        1351.5,
        665.5,
        98.5
      ],
      [
        1385.0,
        666.0,
        104.0
      ],
      [
        1480.0,
        510.0,
        338.0
      ],
      [
        1470.0,
        510.0,
        348.0
      ],
      [
        1390.0,
        650.0,
        331.0
      ],
      [
        1390.0,
        670.0,
        331.0
      ],
      [
        1421.0882568359375,
        590.0,
        320.0
      ],
      [
        1418.5118408203125,
        590.0,
        320.0
      ],
      [
        1471.4881591796875,
        590.0,
        320.0
      ],
      [
        1468.9117431640625,
        590.0,
        320.0
      ],
      [
        1420.8392333984375,
        590.0,
        318.70654296875
      ],
      [
        1421.0882568359375,
        590.0,
        320.0
      ],
      [
        1418.5118408203125,
        590.0,
        320.0
      ],
      [
        1418.7608642578125,
        590.0,
        318.70654296875
      ],
      [
        1468.9117431640625,
        590.0,
        320.0
      ],
      [
        1469.1607666015625,
        590.0,
        318.70654296875
      ],
      [
        1471.2391357421875,
        590.0,
        318.70654296875
      ],
      [
        1471.4881591796875,
        590.0,
        320.0
      ],
      [
        1410.0,
        645.0,
        331.0
      ],
      [
        1410.0,
        645.0,
        317.0
      ],
      [
        1474.5,
        668.0,
        322.0
      ],
      [
        1474.5,
        668.0,
        321.0
      ],
      [
        1466.5,
        668.0,
        321.0
      ],
      [
        1466.5,
        668.0,
        322.0
      ],
      [
        1466.5,
        670.0,
        323.0
      ],
      [
        1466.5,
        668.0,
        323.0
      ],
      [
        1466.5,
        668.0,
        323.0
      ],
      [
        1466.5,
        668.0,
        317.0
      ],
      [
        1478.5,
        668.0,
        317.5
      ],
      [
        1479.0,
        668.0,
        317.5
      ],
      [
        1479.0,
        665.5,
        317.5
      ],
      [
        1478.5,
        665.5,
        317.5
      ],
      [
        1415.5,
        668.0,
        321.0
      ],
      [
        1415.5,
        668.0,
        322.0
      ],
      [
        1423.5,
        668.0,
        322.0
      ],
      [
        1423.5,
        668.0,
        321.0
      ],
      [
        1423.5,
        668.0,
        323.0
      ],
      [
        1423.5,
        670.0,
        323.0
      ],
      [
        1423.5,
        668.0,
        323.0
      ],
      [
        1423.5,
        668.0,
        317.0
      ],
      [
        1411.0,
        668.0,
        317.5
      ],
      [
        1411.5,
        668.0,
        317.5
      ],
      [
        1411.5,
        665.5,
        317.5
      ],
      [
        1411.0,
        665.5,
        317.5
      ],
      [
        1410.0,
        644.0,
        331.0
      ],
      [
        1410.0,
        645.0,
        330.0
      ],
      [
        1410.0,
        644.0,
        330.0
      ],
      [
        1410.0,
        644.0,
        317.0
      ],
      [
        1440.0,
        637.0,
        321.2000427246094
      ],
      [
        1450.0,
        637.0,
        321.2000427246094
      ],
      [
        1419.85302734375,
        591.8071899414062,
        320.0
      ],
      [
        1419.85302734375,
        591.8071899414062,
        329.0
      ],
      [
        1419.85302734375,
        591.8071899414062,
        329.0
      ],
      [
        1419.85302734375,
        591.8071899414062,
        320.0
      ],
      [
        1470.14697265625,
        591.80712890625,
        329.0
      ],
      [
        1470.14697265625,
        591.80712890625,
        320.0
      ],
      [
        1470.14697265625,
        591.80712890625,
        329.0
      ],
      [
        1470.14697265625,
        591.80712890625,
        320.0
      ],
      [
        1562.5999755859375,
        630.0,
        338.0
      ],
      [
        1562.5999755859375,
        630.0,
        315.1800231933594
      ],
      [
        1562.5999755859375,
        630.0,
        98.0
      ],
      [
        1562.5999755859375,
        630.0,
        90.0
      ],
      [
        1562.5999755859375,
        630.0,
        90.0
      ],
      [
        1562.5999755859375,
        630.0,
        80.0
      ],
      [
        1562.5999755859375,
        630.0,
        317.0
      ],
      [
        1562.5999755859375,
        630.0,
        331.0
      ],
      [
        1562.5999755859375,
        630.0,
        100.0
      ],
      [
        1562.5999755859375,
        630.0,
        116.0
      ],
      [
        1562.5999755859375,
        630.0,
        120.0
      ],
      [
        1562.5999755859375,
        630.0,
        98.0
      ],
      [
        1562.5999755859375,
        510.0,
        140.0
      ],
      [
        1562.5999755859375,
        630.0,
        140.0
      ],
      [
        1562.5999755859375,
        520.0,
        100.0
      ],
      [
        1562.5999755859375,
        630.0,
        100.0
      ],
      [
        1562.5999755859375,
        628.0,
        80.0
      ],
      [
        1562.5999755859375,
        610.0,
        80.0
      ],
      [
        1562.5999755859375,
        510.0,
        80.0
      ],
      [
        1562.5999755859375,
        610.0,
        80.0
      ],
      [
        1562.5999755859375,
        610.0,
        98.0
      ],
      [
        1562.5999755859375,
        628.0,
        98.0
      ],
      [
        1562.5999755859375,
        610.0,
        98.0
      ],
      [
        1562.5999755859375,
        510.0,
        98.0
      ],
      [
        1562.5999755859375,
        610.0,
        80.0
      ],
      [
        1562.5999755859375,
        610.0,
        91.0
      ],
      [
        1562.5999755859375,
        610.0,
        91.0
      ],
      [
        1562.5999755859375,
        610.0,
        98.0
      ],
      [
        1562.5999755859375,
        610.0,
        98.0
      ],
      [
        1562.5999755859375,
        610.0,
        90.0
      ],
      [
        1562.5999755859375,
        610.0,
        90.0
      ],
      [
        1562.5999755859375,
        610.0,
        80.0
      ],
      [
        1562.5999755859375,
        628.0,
        80.0
      ],
      [
        1562.5999755859375,
        628.0,
        90.0
      ],
      [
        1562.5999755859375,
        628.0,
        98.0
      ],
      [
        1562.5999755859375,
        628.0,
        90.0
      ],
      [
        1562.5999755859375,
        520.0,
        116.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        116.0
      ],
      [
        1562.5999755859375,
        630.0,
        116.0
      ],
      [
        1562.5999755859375,
        618.8999633789062,
        116.0
      ],
      [
        1562.5999755859375,
        618.8999633789062,
        116.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        116.0
      ],
      [
        1562.5999755859375,
        600.0,
        132.0
      ],
      [
        1562.5999755859375,
        607.4000244140625,
        132.0
      ],
      [
        1562.5999755859375,
        520.0,
        132.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        132.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        132.0
      ],
      [
        1562.5999755859375,
        600.0,
        132.0
      ],
      [
        1562.5999755859375,
        607.4000244140625,
        118.0
      ],
      [
        1562.5999755859375,
        600.0,
        118.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        118.0
      ],
      [
        1562.5999755859375,
        520.0,
        118.0
      ],
      [
        1562.5999755859375,
        600.0,
        118.0
      ],
      [
        1562.5999755859375,
        527.4000244140625,
        118.0
      ],
      [
        1498.0,
        618.0,
        118.0
      ],
      [
        1498.9998779296875,
        621.8570556640625,
        122.0
      ],
      [
        1500.0,
        622.8571166992188,
        122.0
      ],
      [
        1498.0,
        520.0,
        118.0
      ],
      [
        1500.0,
        520.0,
        122.0
      ],
      [
        1498.9998779296875,
        520.0,
        122.0
      ],
      [
        1480.0,
        602.8571166992188,
        122.0
      ],
      [
        1480.0,
        520.0,
        122.0
      ],
      [
        1550.0,
        622.8571166992188,
        122.0
      ],
      [
        1551.0001220703125,
        621.8570556640625,
        122.0
      ],
      [
        1552.0,
        618.0,
        118.0
      ],
      [
        1550.0,
        520.0,
        122.0
      ],
      [
        1552.0,
        520.0,
        118.0
      ],
      [
        1551.0001220703125,
        520.0,
        122.0
      ],
      [
        1562.5999755859375,
        610.2571411132812,
        122.0
      ],
      [
        1562.5999755859375,
        607.4000244140625,
        118.0
      ],
      [
        1562.5999755859375,
        520.0,
        118.0
      ],
      [
        1562.5999755859375,
        520.0,
        122.0
      ],
      [
        1562.5999755859375,
        607.4000244140625,
        132.0
      ],
      [
        1562.5999755859375,
        612.4000244140625,
        125.0
      ],
      [
        1562.5999755859375,
        612.4000244140625,
        125.0
      ],
      [
        1562.5999755859375,
        520.0,
        132.0
      ],
      [
        1509.2857666015625,
        510.0,
        120.00000762939453
      ],
      [
        1540.7142333984375,
        510.0,
        120.00000762939453
      ],
      [
        1484.828369140625,
        598.0,
        116.0
      ],
      [
        1484.828369140625,
        598.0,
        100.0
      ],
      [
        1544.800048828125,
        630.0,
        101.5999984741211
      ],
      [
        1544.800048828125,
        630.0,
        102.0
      ],
      [
        1544.800048828125,
        626.9999389648438,
        102.0
      ],
      [
        1544.800048828125,
        627.2001342773438,
        101.5999984741211
      ],
      [
        1558.0,
        630.0,
        102.0
      ],
      [
        1558.0,
        630.0,
        101.5999984741211
      ],
      [
        1558.0,
        627.2001342773438,
        101.5999984741211
      ],
      [
        1558.0,
        626.9999389648438,
        102.0
      ],
      [
        1544.800048828125,
        628.800048828125,
        100.0
      ],
      [
        1544.800048828125,
        629.2001953125,
        101.5999984741211
      ],
      [
        1558.0,
        628.8001098632812,
        100.0
      ],
      [
        1558.0,
        629.2002563476562,
        101.5999984741211
      ],
      [
        1558.0,
        628.0009155273438,
        100.0
      ],
      [
        1544.800048828125,
        628.0009155273438,
        100.0
      ],
      [
        1504.0001220703125,
        629.59326171875,
        103.4000015258789
      ],
      [
        1504.0001220703125,
        629.5380249023438,
        103.0
      ],
      [
        1558.0,
        630.0,
        104.9000015258789
      ],
      [
        1558.0,
        629.400146484375,
        102.0
      ],
      [
        1558.0,
        629.800048828125,
        104.9000015258789
      ],
      [
        1544.800048828125,
        630.0,
        104.9000015258789
      ],
      [
        1544.800048828125,
        629.800048828125,
        104.9000015258789
      ],
      [
        1544.800048828125,
        629.400146484375,
        102.0
      ],
      [
        1562.5999755859375,
        630.0,
        104.0
      ],
      [
        1558.0,
        629.6759033203125,
        104.0
      ],
      [
        1562.5999755859375,
        629.6759033203125,
        104.0
      ],
      [
        1558.0,
        629.7449340820312,
        104.5
      ],
      [
        1562.5999755859375,
        630.0,
        104.5
      ],
      [
        1562.5999755859375,
        629.7449340820312,
        104.5
      ],
      [
        1497.800048828125,
        629.5380249023438,
        103.0
      ],
      [
        1497.800048828125,
        629.59326171875,
        103.4000015258789
      ],
      [
        1497.800048828125,
        629.5380249023438,
        103.0
      ],
      [
        1504.0001220703125,
        629.5380249023438,
        103.0
      ],
      [
        1497.800048828125,
        629.59326171875,
        103.4000015258789
      ],
      [
        1504.0001220703125,
        629.59326171875,
        103.4000015258789
      ],
      [
        1544.800048828125,
        625.548583984375,
        104.9000015258789
      ],
      [
        1558.0,
        625.548583984375,
        104.9000015258789
      ],
      [
        1562.5999755859375,
        627.0,
        104.5
      ],
      [
        1562.5999755859375,
        627.0,
        104.0
      ],
      [
        1562.5999755859375,
        627.0,
        104.0
      ],
      [
        1562.5999755859375,
        627.0,
        104.5
      ],
      [
        1497.800048828125,
        626.29931640625,
        103.4000015258789
      ],
      [
        1504.0,
        626.29931640625,
        103.4000015258789
      ],
      [
        1497.800048828125,
        626.49951171875,
        103.0
      ],
      [
        1504.0,
        626.49951171875,
        103.0
      ],
      [
        1504.0,
        626.29931640625,
        103.4000015258789
      ],
      [
        1504.0,
        626.49951171875,
        103.0
      ],
      [
        1497.800048828125,
        626.49951171875,
        103.0
      ],
      [
        1497.800048828125,
        626.29931640625,
        103.4000015258789
      ],
      [
        1544.800048828125,
        625.0,
        105.9960708618164
      ],
      [
        1551.4000244140625,
        625.0,
        105.9960708618164
      ],
      [
        1551.4000244140625,
        625.0,
        105.9960708618164
      ],
      [
        1558.0,
        625.0,
        105.9960708618164
      ],
      [
        1558.0,
        625.0,
        105.9960708618164
      ],
      [
        1544.800048828125,
        625.0,
        105.9960708618164
      ],
      [
        1562.5999755859375,
        520.0,
        100.0
      ],
      [
        1562.5999755859375,
        520.0,
        107.5
      ],
      [
        1562.5999755859375,
        520.0,
        107.5
      ],
      [
        1562.5999755859375,
        520.0,
        116.0
      ],
      [
        1484.828369140625,
        598.0,
        105.0
      ],
      [
        1487.071044921875,
        597.071044921875,
        105.0
      ],
      [
        1487.071044921875,
        597.071044921875,
        105.0
      ],
      [
        1487.928955078125,
        595.0,
        100.0
      ],
      [
        1487.928955078125,
        595.0,
        105.0
      ],
      [
        1487.928955078125,
        595.0,
        116.0
      ],
      [
        1562.5999755859375,
        523.72314453125,
        116.0
      ],
      [
        1562.5999755859375,
        523.72314453125,
        100.0
      ],
      [
        1562.5999755859375,
        536.27685546875,
        116.0
      ],
      [
        1562.5999755859375,
        536.27685546875,
        100.0
      ],
      [
        1502.35302734375,
        523.80712890625,
        103.0
      ],
      [
        1502.35302734375,
        523.80712890625,
        112.0
      ],
      [
        1502.35302734375,
        523.80712890625,
        112.0
      ],
      [
        1502.35302734375,
        523.80712890625,
        103.0
      ],
      [
        1547.6470947265625,
        523.8072509765625,
        103.0
      ],
      [
        1547.6470947265625,
        523.8072509765625,
        112.0
      ],
      [
        1547.6470947265625,
        523.8072509765625,
        112.0
      ],
      [
        1547.6470947265625,
        523.8072509765625,
        103.0
      ],
      [
        1562.5999755859375,
        600.0,
        317.0
      ],
      [
        1562.5999755859375,
        630.0,
        317.0
      ],
      [
        1562.5999755859375,
        600.0,
        331.0
      ],
      [
        1562.5999755859375,
        600.0,
        317.0
      ],
      [
        1562.5999755859375,
        630.0,
        331.0
      ],
      [
        1562.5999755859375,
        600.0,
        331.0
      ],
      [
        1562.5999755859375,
        630.0,
        315.1800231933594
      ],
      [
        1562.5999755859375,
        600.0,
        315.1800231933594
      ],
      [
        1562.5999755859375,
        670.0,
        80.0
      ],
      [
        1562.5999755859375,
        630.0,
        80.0
      ],
      [
        1562.5999755859375,
        630.0,
        160.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        160.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        120.0
      ],
      [
        1562.5999755859375,
        630.0,
        120.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        140.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        120.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        140.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        160.0
      ],
      [
        1374.1917724609375,
        510.0,
        88.0
      ],
      [
        1371.052001953125,
        510.0,
        98.0
      ],
      [
        1493.5538330078125,
        490.0,
        118.0
      ],
      [
        1487.9036865234375,
        490.0,
        118.0
      ],
      [
        1562.1053466796875,
        490.0,
        118.0
      ],
      [
        1556.449951171875,
        490.0,
        118.0
      ],
      [
        1562.5999755859375,
        510.0,
        118.0
      ],
      [
        1562.5999755859375,
        490.0,
        118.0
      ],
      [
        1562.5999755859375,
        510.0,
        138.0
      ],
      [
        1493.5548095703125,
        490.0,
        138.0
      ],
      [
        1556.4451904296875,
        490.0,
        138.0
      ],
      [
        1562.5999755859375,
        502.7752990722656,
        138.0
      ],
      [
        1548.9193115234375,
        490.0,
        140.0
      ],
      [
        1501.0806884765625,
        490.0,
        140.0
      ],
      [
        1562.5999755859375,
        502.7752990722656,
        138.0
      ],
      [
        1562.5999755859375,
        510.0,
        138.8340606689453
      ],
      [
        1556.4451904296875,
        490.0,
        138.0
      ],
      [
        1548.9193115234375,
        490.0,
        140.0
      ],
      [
        1493.5548095703125,
        490.0,
        138.0
      ],
      [
        1501.0806884765625,
        490.0,
        140.0
      ],
      [
        1487.9036865234375,
        490.0,
        120.0
      ],
      [
        1493.5538330078125,
        490.0,
        120.0
      ],
      [
        1556.4461669921875,
        490.0,
        120.0
      ],
      [
        1562.0963134765625,
        490.0,
        120.0
      ],
      [
        1556.4461669921875,
        490.0,
        120.0
      ],
      [
        1562.0963134765625,
        490.0,
        120.0
      ],
      [
        1487.9036865234375,
        490.0,
        120.0
      ],
      [
        1493.5538330078125,
        490.0,
        120.0
      ],
      [
        1562.5999755859375,
        502.7752990722656,
        120.0
      ],
      [
        1556.4451904296875,
        490.0,
        120.0
      ],
      [
        1493.5548095703125,
        490.0,
        120.0
      ],
      [
        1562.5999755859375,
        510.0,
        120.0
      ],
      [
        1562.0963134765625,
        490.0,
        120.0
      ],
      [
        1562.1053466796875,
        490.0,
        118.0
      ],
      [
        1487.9036865234375,
        490.0,
        118.0
      ],
      [
        1487.9036865234375,
        490.0,
        120.0
      ],
      [
        1494.7852783203125,
        495.60009765625,
        138.0
      ],
      [
        1494.7852783203125,
        495.60009765625,
        120.0
      ],
      [
        1555.2147216796875,
        495.60009765625,
        120.0
      ],
      [
        1555.2147216796875,
        495.60009765625,
        138.0
      ],
      [
        1502.0,
        490.0,
        80.0
      ],
      [
        1548.0,
        490.0,
        80.0
      ],
      [
        1562.5999755859375,
        490.8783264160156,
        100.0
      ],
      [
        1562.5999755859375,
        502.7655029296875,
        100.0
      ],
      [
        1493.551025390625,
        490.0,
        100.0
      ],
      [
        1556.4527587890625,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        490.8783264160156,
        100.0
      ],
      [
        1562.5999755859375,
        490.0,
        100.0
      ],
      [
        1556.4527587890625,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        490.8783264160156,
        100.0
      ],
      [
        1562.5999755859375,
        490.0,
        100.0
      ],
      [
        1508.0,
        490.0,
        100.0
      ],
      [
        1493.551025390625,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        502.7655029296875,
        100.0
      ],
      [
        1556.4527587890625,
        490.0,
        100.0
      ],
      [
        1542.0,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        510.0,
        100.0
      ],
      [
        1562.5999755859375,
        502.7655029296875,
        100.0
      ],
      [
        1556.4527587890625,
        490.0,
        100.0
      ],
      [
        1542.0,
        490.0,
        100.0
      ],
      [
        1562.5999755859375,
        510.0,
        100.0
      ],
      [
        1542.0,
        490.0,
        100.0
      ],
      [
        1508.0,
        490.0,
        100.0
      ],
      [
        1541.3333740234375,
        490.0,
        98.0
      ],
      [
        1508.6666259765625,
        490.0,
        98.0
      ],
      [
        1548.0,
        490.0,
        80.0
      ],
      [
        1548.0,
        490.0,
        91.0
      ],
      [
        1502.0,
        490.0,
        91.0
      ],
      [
        1502.0,
        490.0,
        80.0
      ],
      [
        1508.6666259765625,
        490.0,
        98.0
      ],
      [
        1502.0,
        490.0,
        91.0
      ],
      [
        1548.0,
        490.0,
        91.0
      ],
      [
        1541.3333740234375,
        490.0,
        98.0
      ],
      [
        1562.5999755859375,
        502.7655334472656,
        118.0
      ],
      [
        1562.5999755859375,
        502.7655029296875,
        100.0
      ],
      [
        1556.45263671875,
        490.0,
        118.0
      ],
      [
        1556.4527587890625,
        490.0,
        100.0
      ],
      [
        1556.45263671875,
        490.0,
        118.0
      ],
      [
        1556.4527587890625,
        490.0,
        100.0
      ],
      [
        1493.551025390625,
        490.0,
        100.0
      ],
      [
        1493.551025390625,
        490.0,
        118.0
      ],
      [
        1290.0,
        420.0,
        210.0
      ],
      [
        1290.0,
        420.0,
        80.0
      ],
      [
        1562.5999755859375,
        420.0,
        140.0
      ],
      [
        1562.5999755859375,
        420.0,
        80.0
      ],
      [
        1290.0,
        420.0,
        80.0
      ],
      [
        1562.5999755859375,
        420.0,
        80.0
      ],
      [
        1562.5999755859375,
        420.0,
        140.0
      ],
      [
        1290.0,
        420.0,
        140.0
      ],
      [
        1562.5999755859375,
        420.0,
        80.0
      ],
      [
        1562.5999755859375,
        470.0,
        80.0
      ],
      [
        1290.0,
        420.0,
        80.0
      ],
      [
        1290.0,
        470.0,
        80.0
      ],
      [
        1562.5999755859375,
        420.0,
        80.0
      ],
      [
        1562.5999755859375,
        470.0,
        80.0
      ],
      [
        1290.0,
        470.0,
        80.0
      ],
      [
        1562.5999755859375,
        461.875,
        120.0
      ],
      [
        1562.5999755859375,
        489.4373779296875,
        120.0
      ],
      [
        1562.5999755859375,
        461.875,
        120.0
      ],
      [
        1562.5999755859375,
        489.4373779296875,
        120.0
      ],
      [
        1562.5999755859375,
        489.4471130371094,
        118.0
      ],
      [
        1562.5999755859375,
        461.875,
        118.0
      ],
      [
        1562.5999755859375,
        488.7811279296875,
        118.0
      ],
      [
        1386.0,
        460.0,
        118.0
      ],
      [
        1562.5999755859375,
        489.4373779296875,
        120.0
      ],
      [
        1562.5999755859375,
        489.4471130371094,
        118.0
      ],
      [
        1562.5999755859375,
        488.7811279296875,
        100.0
      ],
      [
        1562.5999755859375,
        488.7811279296875,
        100.0
      ],
      [
        1290.0,
        450.0,
        100.0
      ],
      [
        1290.0,
        470.0,
        100.0
      ],
      [
        1290.0,
        470.0,
        100.0
      ],
      [
        1290.0,
        470.0,
        98.0
      ],
      [
        1562.5999755859375,
        460.0,
        91.760009765625
      ],
      [
        1562.5999755859375,
        460.0,
        89.760009765625
      ],
      [
        1547.0,
        460.0,
        98.0
      ],
      [
        1547.0,
        450.0,
        98.0
      ],
      [
        1562.5999755859375,
        450.0,
        89.760009765625
      ],
      [
        1562.5999755859375,
        460.0,
        89.760009765625
      ],
      [
        1562.5999755859375,
        460.0,
        91.760009765625
      ],
      [
        1562.5999755859375,
        450.0,
        91.760009765625
      ],
      [
        1352.0,
        460.0,
        99.00001525878906
      ],
      [
        1352.0,
        450.0,
        99.00001525878906
      ],
      [
        1352.0,
        460.0,
        99.00001525878906
      ],
      [
        1354.0,
        460.0,
        100.0
      ],
      [
        1354.0,
        450.0,
        100.0
      ],
      [
        1354.0,
        460.0,
        100.0
      ],
      [
        1542.7359619140625,
        484.50384521484375,
        120.0
      ],
      [
        1542.7359619140625,
        484.50384521484375,
        138.0
      ],
      [
        1507.2640380859375,
        484.5038146972656,
        138.0
      ],
      [
        1507.2640380859375,
        484.5038146972656,
        120.0
      ],
      [
        1624.6153564453125,
        510.0,
        98.0
      ],
      [
        1624.6153564453125,
        510.0,
        80.0
      ],
      [
        1600.0,
        510.0,
        80.0
      ],
      [
        1624.6153564453125,
        510.0,
        80.0
      ],
      [
        1600.0,
        510.0,
        80.0
      ],
      [
        1570.0,
        628.0,
        85.0
      ],
      [
        1570.0,
        610.0,
        85.0
      ],
      [
        1570.0,
        630.0,
        85.0
      ],
      [
        1570.0,
        610.0,
        85.0
      ],
      [
        1570.0,
        630.0,
        85.0
      ],
      [
        1570.0,
        670.0,
        85.0
      ],
      [
        1570.0,
        670.0,
        85.0
      ],
      [
        1570.0,
        630.0,
        85.0
      ],
      [
        1640.0,
        630.0,
        85.0
      ],
      [
        1620.0,
        630.0,
        85.0
      ],
      [
        1600.0,
        630.0,
        85.0
      ],
      [
        1570.0,
        630.0,
        85.0
      ],
      [
        1600.0,
        640.0,
        85.0
      ],
      [
        1600.0,
        630.0,
        85.0
      ],
      [
        1600.0,
        670.0,
        85.0
      ],
      [
        1600.0,
        650.0,
        85.0
      ],
      [
        1595.0,
        652.5,
        85.0
      ],
      [
        1580.0,
        652.5,
        85.0
      ],
      [
        1580.0,
        652.5,
        85.0
      ],
      [
        1595.0,
        652.5,
        85.0
      ],
      [
        1580.0,
        667.5,
        85.0
      ],
      [
        1580.0,
        652.5,
        85.0
      ],
      [
        1595.0,
        655.0,
        85.0
      ],
      [
        1600.0,
        655.0,
        85.0
      ],
      [
        1595.0,
        652.5,
        85.0
      ],
      [
        1595.0,
        655.0,
        85.0
      ],
      [
        1595.0,
        665.0,
        85.0
      ],
      [
        1595.0,
        667.5,
        85.0
      ],
      [
        1580.0,
        637.5,
        85.0
      ],
      [
        1595.0,
        637.5,
        85.0
      ],
      [
        1580.0,
        652.5,
        85.0
      ],
      [
        1580.0,
        637.5,
        85.0
      ],
      [
        1595.0,
        650.0,
        85.0
      ],
      [
        1600.0,
        650.0,
        85.0
      ],
      [
        1595.0,
        650.0,
        85.0
      ],
      [
        1595.0,
        652.5,
        85.0
      ],
      [
        1595.0,
        640.0,
        85.0
      ],
      [
        1600.0,
        640.0,
        85.0
      ],
      [
        1595.0,
        637.5,
        85.0
      ],
      [
        1595.0,
        640.0,
        85.0
      ],
      [
        1620.0,
        640.0,
        85.0
      ],
      [
        1620.0,
        630.0,
        85.0
      ],
      [
        1620.0,
        670.0,
        85.0
      ],
      [
        1620.0,
        650.0,
        85.0
      ],
      [
        1637.5,
        652.5,
        85.0
      ],
      [
        1637.5,
        637.5,
        85.0
      ],
      [
        1625.0,
        652.5,
        85.0
      ],
      [
        1637.5,
        652.5,
        85.0
      ],
      [
        1625.0,
        637.5,
        85.0
      ],
      [
        1637.5,
        637.5,
        85.0
      ],
      [
        1620.0,
        650.0,
        85.0
      ],
      [
        1625.0,
        650.0,
        85.0
      ],
      [
        1625.0,
        650.0,
        85.0
      ],
      [
        1625.0,
        652.5,
        85.0
      ],
      [
        1620.0,
        640.0,
        85.0
      ],
      [
        1625.0,
        640.0,
        85.0
      ],
      [
        1625.0,
        640.0,
        85.0
      ],
      [
        1625.0,
        637.5,
        85.0
      ],
      [
        1570.0,
        610.0,
        85.0
      ],
      [
        1562.5999755859375,
        610.0,
        85.0
      ],
      [
        1570.0,
        610.0,
        85.0
      ],
      [
        1562.5999755859375,
        610.0,
        85.0
      ],
      [
        1562.5999755859375,
        628.0,
        85.0
      ],
      [
        1570.0,
        628.0,
        85.0
      ],
      [
        1570.0,
        630.0,
        85.0
      ],
      [
        1562.5999755859375,
        630.0,
        85.0
      ],
      [
        1570.0,
        510.0,
        258.0
      ],
      [
        1570.0,
        510.0,
        338.0
      ],
      [
        1570.0,
        510.0,
        140.0
      ],
      [
        1570.0,
        510.0,
        258.0
      ],
      [
        1570.0,
        510.0,
        338.0
      ],
      [
        1580.0,
        510.0,
        348.0
      ],
      [
        1580.0,
        630.0,
        98.0
      ],
      [
        1580.0,
        510.0,
        98.0
      ],
      [
        1580.0,
        585.0,
        116.0
      ],
      [
        1580.0,
        600.0,
        116.0
      ],
      [
        1580.0,
        545.0,
        118.0
      ],
      [
        1580.0,
        555.0,
        118.0
      ],
      [
        1580.0,
        540.0,
        125.0
      ],
      [
        1580.0,
        545.0,
        118.0
      ],
      [
        1580.0,
        555.0,
        118.0
      ],
      [
        1580.0,
        560.0,
        125.0
      ],
      [
        1580.0,
        545.0,
        132.0
      ],
      [
        1580.0,
        540.0,
        125.0
      ],
      [
        1580.0,
        560.0,
        125.0
      ],
      [
        1580.0,
        555.0,
        132.0
      ],
      [
        1580.0,
        600.0,
        100.0
      ],
      [
        1580.0,
        585.0,
        100.0
      ],
      [
        1580.0,
        585.0,
        100.0
      ],
      [
        1580.0,
        580.0,
        108.0
      ],
      [
        1580.0,
        580.0,
        108.0
      ],
      [
        1580.0,
        585.0,
        116.0
      ],
      [
        1580.0,
        605.0,
        108.0
      ],
      [
        1580.0,
        600.0,
        100.0
      ],
      [
        1580.0,
        600.0,
        116.0
      ],
      [
        1580.0,
        605.0,
        108.0
      ],
      [
        1580.0,
        600.0,
        317.0
      ],
      [
        1570.0,
        600.0,
        317.0
      ],
      [
        1570.0,
        630.0,
        317.0
      ],
      [
        1580.0,
        630.0,
        317.0
      ],
      [
        1580.0,
        555.0,
        132.0
      ],
      [
        1580.0,
        545.0,
        132.0
      ],
      [
        1580.0,
        630.0,
        331.0
      ],
      [
        1570.0,
        630.0,
        331.0
      ],
      [
        1570.0,
        600.0,
        331.0
      ],
      [
        1580.0,
        600.0,
        331.0
      ],
      [
        1580.0,
        600.0,
        331.0
      ],
      [
        1570.0,
        600.0,
        331.0
      ],
      [
        1570.0,
        600.0,
        317.0
      ],
      [
        1580.0,
        600.0,
        317.0
      ],
      [
        1580.0,
        630.0,
        317.0
      ],
      [
        1570.0,
        630.0,
        317.0
      ],
      [
        1570.0,
        630.0,
        331.0
      ],
      [
        1580.0,
        630.0,
        331.0
      ],
      [
        1570.0,
        605.0,
        125.0
      ],
      [
        1570.0,
        605.0,
        125.0
      ],
      [
        1580.0,
        630.0,
        98.0
      ],
      [
        1580.0,
        630.0,
        91.0
      ],
      [
        1580.0,
        630.0,
        85.0
      ],
      [
        1580.0,
        630.0,
        91.0
      ],
      [
        1562.5999755859375,
        630.0,
        118.0
      ],
      [
        1562.5999755859375,
        630.0,
        116.0
      ],
      [
        1570.0,
        630.0,
        116.0
      ],
      [
        1570.0,
        630.0,
        118.0
      ],
      [
        1563.97119140625,
        650.0,
        132.0
      ],
      [
        1570.0,
        630.0,
        132.0
      ],
      [
        1562.5999755859375,
        651.2188720703125,
        132.0
      ],
      [
        1563.97119140625,
        650.0,
        132.0
      ],
      [
        1570.0,
        520.0,
        120.0
      ],
      [
        1562.5999755859375,
        520.0,
        120.0
      ],
      [
        1570.0,
        601.4285888671875,
        120.0
      ],
      [
        1562.5999755859375,
        608.82861328125,
        120.0
      ],
      [
        1562.5999755859375,
        630.0,
        100.0
      ],
      [
        1570.0,
        630.0,
        100.0
      ],
      [
        1562.5999755859375,
        630.0,
        317.0
      ],
      [
        1570.0,
        630.0,
        317.0
      ],
      [
        1562.5999755859375,
        630.0,
        331.0
      ],
      [
        1570.0,
        630.0,
        331.0
      ],
      [
        1637.5,
        660.0,
        348.0
      ],
      [
        1637.5,
        533.353515625,
        348.0
      ],
      [
        1637.5,
        520.46875,
        98.0
      ],
      [
        1637.5,
        630.0,
        98.0
      ],
      [
        1637.5,
        590.0,
        118.0
      ],
      [
        1637.5,
        600.0,
        118.0
      ],
      [
        1637.5,
        600.0,
        132.0
      ],
      [
        1637.5,
        590.0,
        132.0
      ],
      [
        1637.5,
        590.0,
        125.0
      ],
      [
        1637.5,
        590.0,
        118.0
      ],
      [
        1637.5,
        590.0,
        132.0
      ],
      [
        1637.5,
        590.0,
        125.0
      ],
      [
        1637.5,
        600.0,
        125.0
      ],
      [
        1637.5,
        600.0,
        132.0
      ],
      [
        1637.5,
        600.0,
        118.0
      ],
      [
        1637.5,
        600.0,
        125.0
      ],
      [
        1637.5,
        630.0,
        91.0
      ],
      [
        1637.5,
        630.0,
        98.0
      ],
      [
        1637.5,
        630.0,
        85.0
      ],
      [
        1637.5,
        630.0,
        91.0
      ],
      [
        1608.7572021484375,
        510.0,
        348.0
      ],
      [
        1580.0,
        510.0,
        348.0
      ],
      [
        1600.0,
        637.5,
        98.0
      ],
      [
        1620.0,
        637.5,
        98.0
      ],
      [
        1624.6153564453125,
        510.0,
        98.0
      ],
      [
        1600.0,
        510.0,
        98.0
      ],
      [
        1600.0,
        510.0,
        98.0
      ],
      [
        1620.0,
        637.5,
        132.0
      ],
      [
        1605.0,
        637.5,
        132.0
      ],
      [
        1605.0,
        635.0,
        317.0
      ],
      [
        1620.0,
        635.0,
        317.0
      ],
      [
        1620.0,
        635.0,
        331.0
      ],
      [
        1605.0,
        635.0,
        331.0
      ],
      [
        1620.0,
        635.0,
        317.0
      ],
      [
        1625.0,
        635.0,
        324.0
      ],
      [
        1625.0,
        635.0,
        324.0
      ],
      [
        1620.0,
        635.0,
        331.0
      ],
      [
        1605.0,
        635.0,
        331.0
      ],
      [
        1600.0,
        635.0,
        324.0
      ],
      [
        1600.0,
        635.0,
        324.0
      ],
      [
        1605.0,
        635.0,
        317.0
      ],
      [
        1624.0,
        637.5,
        195.0
      ],
      [
        1605.0,
        637.5,
        317.0
      ],
      [
        1620.0,
        637.5,
        317.0
      ],
      [
        1620.0,
        637.5,
        331.0
      ],
      [
        1605.0,
        637.5,
        331.0
      ],
      [
        1605.0,
        637.5,
        331.0
      ],
      [
        1600.0,
        637.5,
        324.0
      ],
      [
        1600.0,
        637.5,
        324.0
      ],
      [
        1605.0,
        637.5,
        317.0
      ],
      [
        1625.0,
        637.5,
        324.0
      ],
      [
        1620.0,
        637.5,
        331.0
      ],
      [
        1620.0,
        637.5,
        317.0
      ],
      [
        1625.0,
        637.5,
        324.0
      ],
      [
        1624.0,
        637.5,
        180.0
      ],
      [
        1595.0,
        637.5,
        180.0
      ],
      [
        1595.0,
        637.5,
        195.0
      ],
      [
        1624.0,
        637.5,
        190.0
      ],
      [
        1624.0,
        637.5,
        195.0
      ],
      [
        1624.0,
        637.5,
        190.0
      ],
      [
        1624.0,
        637.5,
        180.0
      ],
      [
        1605.0,
        637.5,
        118.0
      ],
      [
        1620.0,
        637.5,
        118.0
      ],
      [
        1620.0,
        637.5,
        100.0
      ],
      [
        1605.0,
        637.5,
        100.0
      ],
      [
        1620.0,
        637.5,
        116.0
      ],
      [
        1605.0,
        637.5,
        116.0
      ],
      [
        1625.0,
        637.5,
        108.0
      ],
      [
        1620.0,
        637.5,
        116.0
      ],
      [
        1620.0,
        637.5,
        100.0
      ],
      [
        1625.0,
        637.5,
        108.0
      ],
      [
        1600.0,
        637.5,
        108.0
      ],
      [
        1605.0,
        637.5,
        100.0
      ],
      [
        1600.0,
        637.5,
        108.0
      ],
      [
        1605.0,
        637.5,
        100.0
      ],
      [
        1595.22412109375,
        606.0819091796875,
        109.73117065429688
      ],
      [
        1598.2843017578125,
        606.7156982421875,
        110.7452392578125
      ],
      [
        1598.2843017578125,
        606.7156982421875,
        110.7452392578125
      ],
      [
        1595.0,
        602.071044921875,
        116.0
      ],
      [
        1605.0,
        637.5,
        116.0
      ],
      [
        1600.0,
        637.5,
        108.0
      ],
      [
        1605.0,
        637.5,
        116.0
      ],
      [
        1600.0,
        637.5,
        108.0
      ],
      [
        1620.0,
        637.5,
        118.0
      ],
      [
        1625.0,
        637.5,
        125.0
      ],
      [
        1630.0,
        590.0,
        132.0
      ],
      [
        1630.0,
        600.0,
        132.0
      ],
      [
        1625.0,
        637.5,
        125.0
      ],
      [
        1620.0,
        637.5,
        132.0
      ],
      [
        1600.0,
        637.5,
        125.0
      ],
      [
        1605.0,
        637.5,
        118.0
      ],
      [
        1595.0,
        545.0,
        132.0
      ],
      [
        1595.0,
        555.0,
        132.0
      ],
      [
        1605.0,
        637.5,
        132.0
      ],
      [
        1600.0,
        637.5,
        125.0
      ],
      [
        1620.0,
        637.5,
        95.0
      ],
      [
        1620.0,
        637.5,
        85.0
      ],
      [
        1620.0,
        637.5,
        95.0
      ],
      [
        1620.0,
        637.5,
        98.0
      ],
      [
        1600.0,
        637.5,
        85.0
      ],
      [
        1600.0,
        637.5,
        95.0
      ],
      [
        1600.0,
        637.5,
        98.0
      ],
      [
        1600.0,
        637.5,
        95.0
      ],
      [
        1625.0,
        660.0,
        348.0
      ],
      [
        1624.0,
        652.5,
        180.0
      ],
      [
        1600.0,
        652.5,
        98.0
      ],
      [
        1620.0,
        652.5,
        98.0
      ],
      [
        1620.0,
        652.5,
        132.0
      ],
      [
        1605.0,
        652.5,
        132.0
      ],
      [
        1620.0,
        652.5,
        100.0
      ],
      [
        1605.0,
        652.5,
        100.0
      ],
      [
        1595.0,
        652.5,
        98.0
      ],
      [
        1595.0,
        667.5,
        98.0
      ],
      [
        1620.0,
        652.5,
        100.0
      ],
      [
        1625.0,
        652.5,
        108.0
      ],
      [
        1605.0,
        652.5,
        132.0
      ],
      [
        1600.0,
        652.5,
        125.0
      ],
      [
        1625.0,
        652.5,
        125.0
      ],
      [
        1620.0,
        652.5,
        132.0
      ],
      [
        1600.0,
        652.5,
        108.0
      ],
      [
        1605.0,
        652.5,
        100.0
      ],
      [
        1595.0,
        667.5,
        115.99988555908203
      ],
      [
        1595.0,
        652.5,
        115.99988555908203
      ],
      [
        1605.0,
        652.5,
        116.0
      ],
      [
        1600.0,
        652.5,
        108.0
      ],
      [
        1600.0,
        652.5,
        125.0
      ],
      [
        1605.0,
        652.5,
        118.0
      ],
      [
        1606.2501220703125,
        655.0,
        118.0
      ],
      [
        1606.2501220703125,
        665.0,
        118.0
      ],
      [
        1606.2501220703125,
        652.5,
        118.0
      ],
      [
        1605.0,
        652.5,
        118.0
      ],
      [
        1606.2501220703125,
        655.0,
        118.0
      ],
      [
        1606.2501220703125,
        670.0,
        118.0
      ],
      [
        1606.2501220703125,
        665.0,
        118.0
      ],
      [
        1625.0,
        652.5,
        108.0
      ],
      [
        1620.0,
        652.5,
        116.0
      ],
      [
        1620.0,
        652.5,
        118.0
      ],
      [
        1625.0,
        652.5,
        125.0
      ],
      [
        1618.75,
        665.0,
        118.0
      ],
      [
        1618.75,
        655.0,
        118.0
      ],
      [
        1620.0,
        652.5,
        118.0
      ],
      [
        1618.7498779296875,
        652.5,
        118.0
      ],
      [
        1618.75,
        655.0,
        118.0
      ],
      [
        1618.7498779296875,
        670.0,
        118.0
      ],
      [
        1618.75,
        665.0,
        118.0
      ],
      [
        1620.0,
        652.5,
        116.0
      ],
      [
        1605.0,
        652.5,
        116.0
      ],
      [
        1600.0,
        652.5,
        95.0
      ],
      [
        1600.0,
        652.5,
        85.0
      ],
      [
        1600.0,
        652.5,
        98.0
      ],
      [
        1600.0,
        652.5,
        95.0
      ],
      [
        1620.0,
        652.5,
        95.0
      ],
      [
        1620.0,
        652.5,
        85.0
      ],
      [
        1620.0,
        652.5,
        95.0
      ],
      [
        1620.0,
        652.5,
        98.0
      ],
      [
        1624.0,
        652.5,
        195.0
      ],
      [
        1620.0,
        652.5,
        331.0
      ],
      [
        1605.0,
        652.5,
        331.0
      ],
      [
        1605.0,
        652.5,
        317.0
      ],
      [
        1620.0,
        652.5,
        317.0
      ],
      [
        1625.0,
        652.5,
        324.0
      ],
      [
        1620.0,
        652.5,
        331.0
      ],
      [
        1620.0,
        652.5,
        317.0
      ],
      [
        1625.0,
        652.5,
        324.0
      ],
      [
        1600.0,
        667.5,
        324.0
      ],
      [
        1605.0,
        667.5,
        331.0
      ],
      [
        1605.0,
        667.5,
        331.0
      ],
      [
        1600.0,
        667.5,
        324.0
      ],
      [
        1605.0,
        667.5,
        317.0
      ],
      [
        1600.0,
        667.5,
        324.0
      ],
      [
        1605.0,
        667.5,
        317.0
      ],
      [
        1600.0,
        667.5,
        324.0
      ],
      [
        1600.0,
        652.5,
        324.0
      ],
      [
        1605.0,
        652.5,
        331.0
      ],
      [
        1605.0,
        652.5,
        331.0
      ],
      [
        1600.0,
        652.5,
        324.0
      ],
      [
        1605.0,
        652.5,
        317.0
      ],
      [
        1600.0,
        652.5,
        324.0
      ],
      [
        1605.0,
        652.5,
        317.0
      ],
      [
        1600.0,
        652.5,
        324.0
      ],
      [
        1600.0,
        665.0,
        323.9999084472656
      ],
      [
        1624.0,
        652.5,
        190.0
      ],
      [
        1624.0,
        652.5,
        195.0
      ],
      [
        1624.0,
        652.5,
        180.0
      ],
      [
        1624.0,
        652.5,
        190.0
      ],
      [
        1595.0,
        652.5,
        180.0
      ],
      [
        1595.0,
        652.5,
        195.0
      ],
      [
        1595.0,
        652.5,
        348.0
      ],
      [
        1595.0,
        637.5,
        348.0
      ],
      [
        1770.0,
        628.1248779296875,
        64.16638946533203
      ],
      [
        1760.0,
        619.9999389648438,
        84.9999771118164
      ],
      [
        1760.0,
        619.9999389648438,
        82.99998474121094
      ],
      [
        1760.0,
        624.0,
        85.0
      ],
      [
        1760.0,
        620.0,
        85.0
      ],
      [
        1760.0,
        670.0,
        85.0
      ],
      [
        1660.0,
        670.0,
        85.0
      ],
      [
        1660.0,
        650.0,
        85.0
      ],
      [
        1660.0,
        538.75,
        85.0
      ],
      [
        1660.0,
        560.0,
        85.0
      ],
      [
        1660.0,
        670.0,
        85.0
      ],
      [
        1660.0,
        650.0,
        85.0
      ],
      [
        1640.0,
        650.0,
        85.0
      ],
      [
        1660.0,
        650.0,
        85.0
      ],
      [
        1660.0,
        650.0,
        85.0
      ],
      [
        1640.0,
        650.0,
        85.0
      ],
      [
        1660.0,
        560.0,
        85.0
      ],
      [
        1640.0,
        560.0,
        85.0
      ],
      [
        1760.0,
        650.0,
        98.0
      ],
      [
        1660.0,
        650.0,
        348.0
      ],
      [
        1660.0,
        650.0,
        338.0
      ],
      [
        1660.0,
        642.5,
        118.0
      ],
      [
        1660.0,
        627.5,
        118.0
      ],
      [
        1660.0,
        612.5,
        118.0
      ],
      [
        1660.0,
        597.5,
        118.0
      ],
      [
        1660.0,
        582.5,
        118.0
      ],
      [
        1660.0,
        567.5,
        118.0
      ],
      [
        1660.0,
        560.0,
        118.0
      ],
      [
        1660.0,
        650.0,
        118.0
      ],
      [
        1770.0,
        650.0,
        100.0
      ],
      [
        1770.0,
        628.125,
        100.0
      ],
      [
        1760.0,
        650.0,
        100.0
      ],
      [
        1760.0,
        646.0,
        98.0
      ],
      [
        1760.0,
        650.0,
        220.0
      ],
      [
        1770.0,
        628.125,
        220.0
      ],
      [
        1770.0,
        650.0,
        220.0
      ],
      [
        1760.0,
        650.0,
        258.0
      ],
      [
        1770.0,
        628.125,
        258.0
      ],
      [
        1770.0,
        650.0,
        258.0
      ],
      [
        1660.0,
        600.0,
        142.0
      ],
      [
        1660.7689208984375,
        600.0,
        142.0
      ],
      [
        1660.7689208984375,
        610.0,
        142.0
      ],
      [
        1660.0,
        610.0,
        142.0
      ],
      [
        1660.0,
        560.0,
        142.0
      ],
      [
        1660.7689208984375,
        560.0,
        142.0
      ],
      [
        1660.7689208984375,
        600.0,
        142.0
      ],
      [
        1660.0,
        600.0,
        142.0
      ],
      [
        1660.0,
        610.0,
        142.0
      ],
      [
        1660.7689208984375,
        610.0,
        142.0
      ],
      [
        1660.7689208984375,
        650.0,
        142.0
      ],
      [
        1660.0,
        650.0,
        142.0
      ],
      [
        1660.7689208984375,
        560.0,
        142.0
      ],
      [
        1660.0,
        560.0,
        142.0
      ],
      [
        1660.0,
        560.0,
        141.74517822265625
      ],
      [
        1687.4111328125,
        615.5,
        142.0
      ],
      [
        1687.4111328125,
        624.5,
        142.0
      ],
      [
        1687.4111328125,
        585.5,
        142.0
      ],
      [
        1687.4111328125,
        594.5,
        142.0
      ],
      [
        1680.0,
        594.5,
        127.68624877929688
      ],
      [
        1680.0,
        615.5,
        127.68624877929688
      ],
      [
        1680.0,
        560.0,
        127.68638610839844
      ],
      [
        1680.0,
        585.5,
        127.68624877929688
      ],
      [
        1680.0,
        650.0,
        127.68639373779297
      ],
      [
        1680.0,
        624.5,
        127.68624877929688
      ],
      [
        1680.0,
        615.5,
        127.68624877929688
      ],
      [
        1687.4111328125,
        615.5,
        142.0
      ],
      [
        1680.0,
        585.5,
        127.68624877929688
      ],
      [
        1687.4111328125,
        585.5,
        142.0
      ],
      [
        1680.0,
        594.5,
        127.68624877929688
      ],
      [
        1687.4111328125,
        594.5,
        142.0
      ],
      [
        1680.0,
        624.5,
        127.68624877929688
      ],
      [
        1687.4111328125,
        624.5,
        142.0
      ],
      [
        1680.0,
        560.0,
        127.68639373779297
      ],
      [
        1660.0,
        560.0,
        118.0
      ],
      [
        1674.9847412109375,
        560.0,
        118.0
      ],
      [
        1660.0,
        642.5,
        118.0
      ],
      [
        1674.9847412109375,
        642.5,
        118.0
      ],
      [
        1677.573486328125,
        645.5,
        123.0
      ],
      [
        1660.0,
        645.5,
        123.0
      ],
      [
        1660.0,
        645.5,
        123.0
      ],
      [
        1677.573486328125,
        645.5,
        123.0
      ],
      [
        1674.9847412109375,
        642.5,
        118.0
      ],
      [
        1660.0,
        642.5,
        118.0
      ],
      [
        1677.573486328125,
        564.5,
        123.0
      ],
      [
        1660.0,
        564.5,
        123.0
      ],
      [
        1660.0,
        567.5,
        118.0
      ],
      [
        1674.9847412109375,
        567.5,
        118.0
      ],
      [
        1660.0,
        612.5,
        118.0
      ],
      [
        1674.9847412109375,
        612.5,
        118.0
      ],
      [
        1677.573486328125,
        615.5,
        123.0
      ],
      [
        1660.0,
        615.5,
        123.0
      ],
      [
        1660.0,
        615.5,
        123.0
      ],
      [
        1677.573486328125,
        615.5,
        123.0
      ],
      [
        1674.9847412109375,
        612.5,
        118.0
      ],
      [
        1660.0,
        612.5,
        118.0
      ],
      [
        1674.9847412109375,
        597.5,
        118.0
      ],
      [
        1660.0,
        597.5,
        118.0
      ],
      [
        1660.0,
        594.5,
        123.0
      ],
      [
        1677.573486328125,
        594.5,
        123.0
      ],
      [
        1677.573486328125,
        594.5,
        123.0
      ],
      [
        1660.0,
        594.5,
        123.0
      ],
      [
        1660.0,
        597.5,
        118.0
      ],
      [
        1674.9847412109375,
        597.5,
        118.0
      ],
      [
        1677.1429443359375,
        594.5,
        123.00005340576172
      ],
      [
        1677.8184814453125,
        594.5,
        123.47291564941406
      ],
      [
        1677.8184814453125,
        594.21630859375,
        123.47291564941406
      ],
      [
        1677.8184814453125,
        594.5,
        123.47291564941406
      ],
      [
        1677.1429443359375,
        594.5,
        123.00005340576172
      ],
      [
        1677.5736083984375,
        594.5,
        123.00005340576172
      ],
      [
        1677.8184814453125,
        615.5,
        123.47291564941406
      ],
      [
        1677.142822265625,
        615.5,
        122.99998474121094
      ],
      [
        1677.8184814453125,
        615.7837524414062,
        123.47291564941406
      ],
      [
        1677.142822265625,
        615.5,
        122.99999237060547
      ],
      [
        1677.8184814453125,
        615.5,
        123.47291564941406
      ],
      [
        1677.5736083984375,
        615.5,
        122.99998474121094
      ],
      [
        1660.0,
        582.5,
        118.0
      ],
      [
        1674.9847412109375,
        582.5,
        118.0
      ],
      [
        1677.573486328125,
        585.5,
        123.0
      ],
      [
        1660.0,
        585.5,
        123.0
      ],
      [
        1660.0,
        585.5,
        123.0
      ],
      [
        1677.573486328125,
        585.5,
        123.0
      ],
      [
        1674.9847412109375,
        582.5,
        118.0
      ],
      [
        1660.0,
        582.5,
        118.0
      ],
      [
        1677.8184814453125,
        585.5,
        123.47291564941406
      ],
      [
        1677.1429443359375,
        585.5,
        123.00005340576172
      ],
      [
        1677.8184814453125,
        585.78369140625,
        123.47291564941406
      ],
      [
        1677.1429443359375,
        585.5,
        123.00005340576172
      ],
      [
        1677.8184814453125,
        585.5,
        123.47291564941406
      ],
      [
        1677.5736083984375,
        585.5,
        123.00005340576172
      ],
      [
        1674.984619140625,
        585.5,
        118.0
      ],
      [
        1674.984619140625,
        594.5,
        118.0
      ],
      [
        1674.9847412109375,
        627.5,
        118.0
      ],
      [
        1660.0,
        627.5,
        118.0
      ],
      [
        1660.0,
        624.5,
        123.0
      ],
      [
        1677.573486328125,
        624.5,
        123.0
      ],
      [
        1677.573486328125,
        624.5,
        123.0
      ],
      [
        1660.0,
        624.5,
        123.0
      ],
      [
        1660.0,
        627.5,
        118.0
      ],
      [
        1674.9847412109375,
        627.5,
        118.0
      ],
      [
        1677.142822265625,
        624.5,
        122.99993133544922
      ],
      [
        1677.8184814453125,
        624.5,
        123.47291564941406
      ],
      [
        1677.8184814453125,
        624.2161865234375,
        123.47291564941406
      ],
      [
        1677.8184814453125,
        624.5,
        123.47291564941406
      ],
      [
        1677.142822265625,
        624.5,
        122.99993133544922
      ],
      [
        1677.5736083984375,
        624.5,
        122.99993133544922
      ],
      [
        1674.984619140625,
        615.5,
        118.0
      ],
      [
        1674.984619140625,
        624.5,
        118.0
      ],
      [
        1680.0,
        560.0,
        125.0
      ],
      [
        1680.0,
        650.0,
        125.0
      ],
      [
        1680.0,
        560.0,
        125.0
      ],
      [
        1678.609130859375,
        560.0,
        125.0
      ],
      [
        1700.5,
        649.5,
        133.0
      ],
      [
        1700.5,
        650.0,
        133.0
      ],
      [
        1701.5,
        650.0,
        133.0
      ],
      [
        1701.5,
        649.5,
        133.0
      ],
      [
        1701.5,
        650.0,
        130.0
      ],
      [
        1700.5,
        650.0,
        130.0
      ],
      [
        1700.5,
        649.5,
        130.0
      ],
      [
        1701.5,
        649.5,
        130.0
      ],
      [
        1702.0,
        649.5,
        133.0
      ],
      [
        1702.0,
        649.5,
        130.0
      ],
      [
        1702.0,
        649.5,
        133.0
      ],
      [
        1702.0,
        649.5,
        130.0
      ],
      [
        1700.5,
        649.0,
        130.0
      ],
      [
        1700.5,
        649.0,
        133.0
      ],
      [
        1700.5,
        649.0,
        133.0
      ],
      [
        1700.5,
        649.0,
        130.0
      ],
      [
        1648.0,
        560.0,
        142.0
      ],
      [
        1645.6568603515625,
        560.0,
        136.34315490722656
      ],
      [
        1640.0,
        560.0,
        122.68580627441406
      ],
      [
        1760.0,
        650.0,
        85.0
      ],
      [
        1760.0,
        650.0,
        98.0
      ],
      [
        1760.0,
        510.0,
        75.99512481689453
      ],
      [
        1770.0,
        510.0,
        75.99349975585938
      ],
      [
        1624.6153564453125,
        510.0,
        75.99512481689453
      ],
      [
        1652.2601318359375,
        510.0,
        75.9950942993164
      ],
      [
        1652.2601318359375,
        510.0,
        85.0
      ],
      [
        1652.2601318359375,
        510.0,
        75.9950942993164
      ],
      [
        1760.0,
        599.029052734375,
        85.0
      ],
      [
        1763.599365234375,
        602.0033569335938,
        66.77178955078125
      ],
      [
        1770.0,
        607.29248046875,
        66.24962615966797
      ],
      [
        1652.2601318359375,
        510.0,
        88.0
      ],
      [
        1760.0,
        510.0,
        88.0
      ],
      [
        1745.0,
        510.0,
        88.0
      ],
      [
        1652.2601318359375,
        510.0,
        88.0
      ],
      [
        1675.8082275390625,
        510.0,
        88.0
      ],
      [
        1675.8082275390625,
        510.0,
        88.0
      ],
      [
        1678.947998046875,
        510.0,
        98.0
      ],
      [
        1743.0,
        510.0,
        98.0
      ],
      [
        1678.947998046875,
        510.0,
        98.0
      ],
      [
        1760.0,
        420.0,
        80.0
      ],
      [
        1760.0,
        470.0,
        80.0
      ],
      [
        1760.0,
        420.0,
        80.0
      ],
      [
        1760.0,
        470.0,
        80.0
      ],
      [
        1661.4000244140625,
        460.0,
        100.0
      ],
      [
        1661.4000244140625,
        470.0,
        100.0
      ],
      [
        1562.5999755859375,
        470.0,
        120.0
      ],
      [
        1562.5999755859375,
        470.0,
        120.0
      ],
      [
        1562.5999755859375,
        470.0,
        118.0
      ],
      [
        1628.056884765625,
        490.0,
        80.0
      ],
      [
        1652.2601318359375,
        510.0,
        80.0
      ],
      [
        1600.0,
        490.0,
        88.0
      ],
      [
        1624.6153564453125,
        510.0,
        88.0
      ],
      [
        1570.0,
        490.0,
        88.0
      ],
      [
        1600.0,
        490.0,
        88.0
      ],
      [
        1570.0,
        481.1708984375,
        120.0
      ],
      [
        1570.0,
        481.1764831542969,
        118.0
      ],
      [
        1570.0,
        470.0,
        120.0
      ],
      [
        1570.0,
        481.1708984375,
        120.0
      ],
      [
        1570.0,
        470.0,
        120.0
      ],
      [
        1570.0,
        481.1708984375,
        120.0
      ],
      [
        1570.0,
        481.1764831542969,
        118.0
      ],
      [
        1570.0,
        470.0,
        118.0
      ],
      [
        1289.6881103515625,
        621.091552734375,
        64.8908462524414
      ],
      [
        1290.0,
        454.65155029296875,
        80.0
      ],
      [
        1289.6881103515625,
        621.091552734375,
        64.8908462524414
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -6971.595703125,
        -5072.0185546875,
        -300.0
      ],
      "bbox_max": [
        7846.55615234375,
        5100.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3080.0,
        -3580.0,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3408.73486328125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3833.671875,
        -4714.78125,
        1040.098388671875
      ],
      "bbox_max": [
        -3000.0,
        -4327.0185546875,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -2619.10009765625,
        0.0
      ],
      "bbox_max": [
        -3605.199951171875,
        2921.382080078125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        -2323.521484375,
        0.0
      ],
      "bbox_max": [
        -3605.199951171875,
        2154.178466796875,
        1179.1292724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.738960862159729,
        0.6707490682601929,
        -0.06350246071815491
      ],
      "plane_d": 2243.716064453125,
      "bbox_min": [
        -3000.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2021.68505859375,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -3000.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2275.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -3000.0,
        -3565.30615234375,
        0.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2671.68505859375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3000.0,
        -3565.30615234375,
        0.0
      ],
      "bbox_max": [
        -2100.0,
        -3111.68505859375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3000.0,
        -5072.0185546875,
        1191.9580078125
      ],
      "bbox_max": [
        -2147.99658203125,
        -4650.2626953125,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -1100.0,
        -2100.0,
        0.0
      ],
      "bbox_max": [
        -800.0,
        -1452.5167236328125,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -900.0,
        -2100.0,
        287.1609191894531
      ],
      "bbox_max": [
        -800.0,
        -1855.504150390625,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 755.8018798828125,
      "bbox_min": [
        2400.0,
        -2050.0,
        -300.0
      ],
      "bbox_max": [
        7823.75537109375,
        -696.68505859375,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01684202253818512,
        0.7395898699760437,
        0.6728469729423523
      ],
      "plane_d": 720.988037109375,
      "bbox_min": [
        2400.0,
        -2050.0,
        0.0
      ],
      "bbox_max": [
        7823.75537109375,
        -796.68505859375,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        296.4333801269531
      ],
      "bbox_max": [
        7600.0,
        -1246.4334716796875,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1350.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.88427734375,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.4764099121094,
      "bbox_min": [
        650.0,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833810806274,
        0.3162277936935425
      ],
      "plane_d": 755.8018798828125,
      "bbox_min": [
        2272.3271484375,
        -796.68505859375,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -800.0,
        -2598.9130859375,
        0.0
      ],
      "bbox_max": [
        650.0,
        -1371.68505859375,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -800.0,
        -2500.0,
        0.0
      ],
      "bbox_max": [
        0.0,
        -1371.68505859375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791015625,
      "bbox_min": [
        -800.0,
        -1855.504150390625,
        0.0
      ],
      "bbox_max": [
        -551.24462890625,
        -1371.68505859375,
        287.160888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        252.5999755859375
      ],
      "bbox_max": [
        650.0,
        -1600.0,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26363566517829895,
        -0.09646245092153549,
        0.9597871899604797
      ],
      "plane_d": 575.6990966796875,
      "bbox_min": [
        3100.0,
        610.0,
        177.3913116455078
      ],
      "bbox_max": [
        4077.6171875,
        1690.0,
        611.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        3100.0,
        610.0,
        177.3913116455078
      ],
      "bbox_max": [
        3240.0,
        1690.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8564453125,
      "bbox_min": [
        3100.0,
        610.0,
        177.3913116455078
      ],
      "bbox_max": [
        3180.0,
        663.0787963867188,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7727262377738953,
        0.0,
        0.6347393989562988
      ],
      "plane_d": 2241.4580078125,
      "bbox_min": [
        3100.0,
        660.0,
        241.80979919433594
      ],
      "bbox_max": [
        3180.0,
        680.8695678710938,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8564453125,
      "bbox_min": [
        3100.0,
        660.0,
        241.80979919433594
      ],
      "bbox_max": [
        3180.0,
        663.478271484375,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1770.0,
        -80.0,
        60.0
      ],
      "bbox_max": [
        3100.0,
        1221.72412109375,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        1905.0,
        630.8695678710938,
        60.0
      ],
      "bbox_max": [
        3100.0,
        1221.72412109375,
        266.89654541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7727262377738953,
        0.0,
        0.6347393989562988
      ],
      "plane_d": 2241.4580078125,
      "bbox_min": [
        1905.0,
        650.0,
        60.0
      ],
      "bbox_max": [
        3100.0,
        760.0,
        242.60870361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8564453125,
      "bbox_min": [
        2950.0,
        663.0787963867188,
        60.0
      ],
      "bbox_max": [
        3100.0,
        670.0,
        242.60870361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1905.0,
        650.0,
        144.0
      ],
      "bbox_max": [
        1910.0,
        760.0,
        199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1905.0,
      "bbox_min": [
        1905.0,
        650.0,
        144.0
      ],
      "bbox_max": [
        1910.0,
        760.0,
        199.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -149.0,
      "bbox_min": [
        1905.0,
        670.0,
        144.0
      ],
      "bbox_max": [
        1910.0,
        760.0,
        199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1905.0,
        670.0,
        144.0
      ],
      "bbox_max": [
        1910.0,
        670.0,
        149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1905.0,
        670.0,
        149.0
      ],
      "bbox_max": [
        1910.0,
        670.0,
        199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -420.0,
      "bbox_min": [
        1770.0,
        -80.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        370.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        1770.0,
        -80.0,
        140.0
      ],
      "bbox_max": [
        1790.0,
        -80.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.001050728838890791,
        0.09950366616249084,
        0.9950367212295532
      ],
      "plane_d": -124.48885345458984,
      "bbox_min": [
        1770.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1770.0,
        420.0,
        80.0
      ],
      "bbox_max": [
        1790.0,
        470.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0001616392401047051,
        0.0997437834739685,
        0.9950131773948669
      ],
      "plane_d": -126.76995849609375,
      "bbox_min": [
        1770.0,
        469.78875732421875,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1770.0,
        469.78875732421875,
        80.0
      ],
      "bbox_max": [
        1790.0,
        470.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1770.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1770.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1770.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        1770.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1790.0,
        720.0,
        60.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1770.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1790.0,
        670.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        310.0,
        -80.0,
        59.99999237060547
      ],
      "bbox_max": [
        1770.0,
        2011.7158203125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        500.0
      ],
      "bbox_max": [
        1588.2841796875,
        2011.7158203125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1549.9998779296875,
        1508.2841796875,
        500.0
      ],
      "bbox_max": [
        1550.0001220703125,
        2011.7158203125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        310.0,
        -80.0,
        59.99999237060547
      ],
      "bbox_max": [
        1770.0,
        1415.0,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1400.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1270.0,
        693.0362548828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1455.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1455.0,
      "bbox_min": [
        1455.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        310.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1250.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        515.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1530.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        515.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1494.5458984375,
      "bbox_min": [
        1600.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1030.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1600.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1605.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1600.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1600.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1600.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1700.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1600.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1655.0,
        960.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        1600.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        1600.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1600.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1605.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1600.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        740.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        1600.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        740.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        1600.0,
        740.0,
        80.0
      ],
      "bbox_max": [
        1750.0,
        740.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1639.0,
        700.0,
        80.0
      ],
      "bbox_max": [
        1659.0,
        720.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547001957893372,
        0.0
      ],
      "plane_d": 1009.5543212890625,
      "bbox_min": [
        1660.0,
        670.0,
        258.0
      ],
      "bbox_max": [
        1680.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35897910594940186,
        0.0,
        0.9333456754684448
      ],
      "plane_d": 520.878662109375,
      "bbox_min": [
        1600.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1770.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1711.0,
        670.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1711.0,
      "bbox_min": [
        1711.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1711.0,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1600.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1750.0,
        700.0,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1690.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1740.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1740.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1600.0,
        670.0,
        78.0
      ],
      "bbox_max": [
        1659.0,
        700.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1600.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1639.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1530.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1600.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1494.5458984375,
      "bbox_min": [
        1530.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1659.7220458984375,
      "bbox_min": [
        1530.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1564.9998779296875,
        980.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1570.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1530.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1530.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1535.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1530.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1535.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1535.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1535.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1530.0,
        840.0,
        98.0
      ],
      "bbox_max": [
        1600.0,
        960.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1530.0,
        840.0,
        98.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1550.0,
        840.0,
        135.0
      ],
      "bbox_max": [
        1580.0,
        900.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1530.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1562.5999755859375,
        840.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1550.0,
        810.0,
        135.0
      ],
      "bbox_max": [
        1562.5999755859375,
        840.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1530.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1530.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1562.5999755859375,
        720.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4819187819957733,
        0.0,
        0.876215934753418
      ],
      "plane_d": -809.8425903320312,
      "bbox_min": [
        1535.0,
        670.0,
        64.82001495361328
      ],
      "bbox_max": [
        1562.5999755859375,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1535.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1538.6363525390625,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1535.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1562.5999755859375,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1530.0,
        720.0,
        105.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1530.0,
        720.0,
        105.0
      ],
      "bbox_max": [
        1535.0,
        720.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1535.0,
        720.0,
        105.0
      ],
      "bbox_max": [
        1562.5999755859375,
        720.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1535.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        725.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1530.0,
        720.0,
        130.0
      ],
      "bbox_max": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1530.0,
        720.0,
        130.0
      ],
      "bbox_max": [
        1562.5999755859375,
        720.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1562.5999755859375,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1600.0,
        840.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1562.5999755859375,
        760.0,
        135.0
      ],
      "bbox_max": [
        1600.0,
        840.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1580.0,
        760.0,
        135.0
      ],
      "bbox_max": [
        1600.0,
        840.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1580.0,
        760.0,
        135.0
      ],
      "bbox_max": [
        1580.0,
        810.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1562.5999755859375,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1600.0,
        760.0,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1562.5999755859375,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1600.0,
        760.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1562.5999755859375,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1600.0,
        720.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1562.5999755859375,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1600.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4819187819957733,
        0.0,
        0.876215934753418
      ],
      "plane_d": -809.8425903320312,
      "bbox_min": [
        1562.5999755859375,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1571.3636474609375,
        680.0,
        64.82001495361328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        130.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1562.5999755859375,
        720.0,
        130.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1250.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1380.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1414.94287109375,
      "bbox_min": [
        1485.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1485.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1525.0001220703125,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1525.0,
      "bbox_min": [
        1525.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1490.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1490.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1490.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1491.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1519.0001220703125,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1518.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1518.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1518.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1518.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1405.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1445.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1445.0,
      "bbox_min": [
        1445.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1445.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1410.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1440.0001220703125,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1410.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1440.0001220703125,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1411.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1439.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1380.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1412.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1380.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1412.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1380.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1412.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1380.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1412.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1438.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1455.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1438.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1455.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1438.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1455.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1455.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1492.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1455.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1492.0,
        980.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1455.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1492.0,
        980.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1455.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1492.0,
        970.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1250.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1380.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1380.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1380.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1380.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": 11.940444946289062,
      "bbox_min": [
        1480.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1480.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        81.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 490.1461181640625,
      "bbox_min": [
        1510.0,
        933.3333129882812,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        81.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1519.9998779296875,
      "bbox_min": [
        1520.0,
        933.3333129882812,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        81.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1480.0,
        720.0,
        81.33333587646484
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1480.0,
        720.0,
        81.33333587646484
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1500.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1530.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1520.0,
      "bbox_min": [
        1500.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1520.0,
        904.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 880.0,
      "bbox_min": [
        1500.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1520.0,
        880.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 490.1461181640625,
      "bbox_min": [
        1510.0,
        900.0,
        81.33333587646484
      ],
      "bbox_max": [
        1520.0,
        936.6666870117188,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1519.9998779296875,
      "bbox_min": [
        1520.0,
        900.0,
        81.33333587646484
      ],
      "bbox_max": [
        1520.0,
        936.6666870117188,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1438.0,
      "bbox_min": [
        1250.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        720.0,
        338.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        1438.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        720.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1438.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1472.0,
        720.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        1440.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1470.0,
        675.0,
        338.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1469.9000244140625,
      "bbox_min": [
        1440.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1470.0,
        675.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1469.9000244140625,
        670.0,
        160.0
      ],
      "bbox_max": [
        1470.0,
        675.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        1469.9000244140625,
        670.0,
        338.0
      ],
      "bbox_max": [
        1470.0,
        675.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 678.0,
      "bbox_min": [
        1440.0,
        675.0,
        160.0
      ],
      "bbox_max": [
        1470.0,
        678.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1440.0,
        675.0,
        160.0
      ],
      "bbox_max": [
        1470.0,
        678.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        1440.0,
        675.0,
        160.0
      ],
      "bbox_max": [
        1470.0,
        678.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        1440.0,
        675.0,
        338.0
      ],
      "bbox_max": [
        1470.0,
        678.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1438.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1472.0,
        720.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1438.0,
        700.0,
        98.0
      ],
      "bbox_max": [
        1472.0,
        720.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        1438.0,
        700.0,
        98.0
      ],
      "bbox_max": [
        1472.0,
        700.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1438.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        1472.0,
        700.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1472.0,
        670.0,
        60.000030517578125
      ],
      "bbox_max": [
        1530.0,
        720.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4640069603919983,
        0.0,
        0.8858315348625183
      ],
      "plane_d": 632.1040649414062,
      "bbox_min": [
        1472.0,
        670.0,
        60.000030517578125
      ],
      "bbox_max": [
        1515.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1511.181884765625,
        680.0,
        78.0
      ],
      "bbox_max": [
        1515.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1472.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1515.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1472.0,
        700.0,
        98.0
      ],
      "bbox_max": [
        1500.0,
        720.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1500.0,
        700.0,
        98.0
      ],
      "bbox_max": [
        1500.0,
        720.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1438.0,
        720.0,
        338.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1270.0,
        670.0,
        98.0
      ],
      "bbox_max": [
        1438.0,
        700.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        1390.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1438.0,
        700.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -711.0697021484375,
      "bbox_min": [
        1390.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1394.0,
        700.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1390.0,
        680.0,
        98.0
      ],
      "bbox_max": [
        1394.0,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 689.9999389648438,
      "bbox_min": [
        1390.0,
        690.0,
        98.0
      ],
      "bbox_max": [
        1394.0,
        690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        1270.0,
        670.0,
        98.0
      ],
      "bbox_max": [
        1270.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 689.9999389648438,
      "bbox_min": [
        1270.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1438.0,
        700.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1430.0,
        690.0,
        80.0
      ],
      "bbox_max": [
        1438.0,
        700.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09839963912963867,
        0.09839963912963867,
        0.99027019739151
      ],
      "plane_d": -252.27951049804688,
      "bbox_min": [
        1270.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1438.0,
        690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06931208819150925,
        0.09031800925731659,
        0.9934980273246765
      ],
      "plane_d": -209.95565795898438,
      "bbox_min": [
        1270.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1275.7142333984375,
        690.0,
        61.818180084228516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1430.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1438.0,
        690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1430.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1438.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1260.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1390.0,
        700.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        -0.0
      ],
      "plane_d": -1528.1990966796875,
      "bbox_min": [
        1370.0,
        670.0,
        258.0
      ],
      "bbox_max": [
        1390.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1300.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1360.0,
        700.0,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1360.0,
      "bbox_min": [
        1310.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1360.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        1310.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1310.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        950.0,
        891.7157592773438,
        220.0
      ],
      "bbox_max": [
        1180.0,
        1093.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        997.1622924804688,
        944.4000244140625,
        220.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        997.1622924804688,
        944.4000244140625,
        220.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        242.46412658691406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        950.0,
        891.7157592773438,
        220.0
      ],
      "bbox_max": [
        1002.6842651367188,
        945.186279296875,
        337.72265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        310.0,
        670.0,
        160.0
      ],
      "bbox_max": [
        950.0,
        1045.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35496851801872253,
        -0.9348782300949097,
        0.0
      ],
      "plane_d": 598.481689453125,
      "bbox_min": [
        865.0,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        946.9471435546875,
        1045.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        -0.4117816090583801,
        0.0
      ],
      "plane_d": -432.6246337890625,
      "bbox_min": [
        922.2498779296875,
        990.3443603515625,
        170.0
      ],
      "bbox_max": [
        946.9471435546875,
        1045.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        310.0,
        670.0,
        160.0
      ],
      "bbox_max": [
        950.0,
        970.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        410.0213928222656,
        701.7157592773438,
        220.0
      ],
      "bbox_max": [
        950.0,
        924.773681640625,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.597613875987008e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9581909179688,
      "bbox_min": [
        410.0213928222656,
        749.9893188476562,
        260.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071070671081543,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 176.77639770507812,
      "bbox_min": [
        410.0213928222656,
        749.9893188476562,
        260.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6504544615745544,
        -0.7595453858375549,
        0.0
      ],
      "plane_d": 302.95068359375,
      "bbox_min": [
        410.0213928222656,
        749.9893188476562,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4225330054759979,
        -0.49339815974235535,
        0.7602789998054504
      ],
      "plane_d": -152.93255615234375,
      "bbox_min": [
        450.3636474609375,
        749.9961547851562,
        410.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48428842425346375,
        -0.4842880964279175,
        0.7286493182182312
      ],
      "plane_d": -177.67437744140625,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        410.0
      ],
      "bbox_max": [
        549.9862060546875,
        837.8707885742188,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        310.0,
        -80.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 510.0,
      "bbox_min": [
        1290.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        390.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 1294.6552734375,
      "bbox_min": [
        1290.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -317.0,
      "bbox_min": [
        1290.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        348.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1390.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        132.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1390.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        132.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1390.0,
        520.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        132.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1127.6021728515625,
      "bbox_min": [
        1410.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        605.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.4536830484867096,
        -0.8911631107330322
      ],
      "plane_d": -140.96580505371094,
      "bbox_min": [
        1410.0,
        522.5,
        118.0
      ],
      "bbox_max": [
        1480.0,
        590.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1410.0,
        522.5,
        118.0
      ],
      "bbox_max": [
        1430.0,
        545.6636962890625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.12215520441532135,
        -0.9925110340118408
      ],
      "plane_d": 185.37051391601562,
      "bbox_min": [
        1410.0,
        522.5,
        118.0
      ],
      "bbox_max": [
        1430.0,
        545.6636962890625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1430.0,
      "bbox_min": [
        1410.0,
        522.5,
        118.0
      ],
      "bbox_max": [
        1430.0,
        545.6636962890625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        522.5,
        118.0
      ],
      "bbox_max": [
        1430.0,
        545.6636962890625,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -522.5,
      "bbox_min": [
        1410.0,
        522.5,
        118.0
      ],
      "bbox_max": [
        1430.0,
        522.5,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        1410.0,
        542.5,
        118.0
      ],
      "bbox_max": [
        1480.0,
        590.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1460.0,
        570.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        590.0,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        1460.0,
        570.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        590.0,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -570.0,
      "bbox_min": [
        1460.0,
        570.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        570.0,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.12215520441532135,
        -0.9925110340118408
      ],
      "plane_d": 185.37051391601562,
      "bbox_min": [
        1410.0,
        542.5,
        118.0
      ],
      "bbox_max": [
        1430.0,
        558.75,
        119.6106185913086
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        542.5,
        118.0
      ],
      "bbox_max": [
        1410.0,
        558.75,
        119.6106185913086
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1440.0,
        570.0,
        118.0
      ],
      "bbox_max": [
        1460.0,
        590.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        1440.0,
        590.0,
        118.0
      ],
      "bbox_max": [
        1460.0,
        590.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        -0.0,
        0.5812382102012634
      ],
      "plane_d": -1272.91162109375,
      "bbox_min": [
        1470.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        605.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 590.0,
      "bbox_min": [
        1470.0,
        570.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        590.0,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -570.0,
      "bbox_min": [
        1470.0,
        570.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        570.0,
        125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6311687231063843,
        -0.6311687231063843,
        0.45083484053611755
      ],
      "plane_d": -608.626953125,
      "bbox_min": [
        1475.0,
        600.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311687231063843,
        -0.6311687231063843,
        -0.45083484053611755
      ],
      "plane_d": -495.9183349609375,
      "bbox_min": [
        1475.0,
        600.0,
        125.0
      ],
      "bbox_max": [
        1480.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 621.0,
      "bbox_min": [
        1390.0,
        522.5,
        98.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        118.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.3826892673969269,
        -0.9238771200180054
      ],
      "plane_d": -137.30300903320312,
      "bbox_min": [
        1390.0,
        621.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9238730072975159,
        -0.38269925117492676
      ],
      "plane_d": 627.198486328125,
      "bbox_min": [
        1410.0,
        621.0,
        108.61512756347656
      ],
      "bbox_max": [
        1480.0,
        643.65673828125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9238730072975159,
        -0.38269925117492676
      ],
      "plane_d": -544.2724609375,
      "bbox_min": [
        1410.0,
        629.9999389648438,
        113.17156219482422
      ],
      "bbox_max": [
        1480.0,
        643.65673828125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3826892673969269,
        -0.9238771200180054
      ],
      "plane_d": 347.9469909667969,
      "bbox_min": [
        1410.0,
        629.9999389648438,
        113.17156219482422
      ],
      "bbox_max": [
        1480.0,
        638.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        636.8283081054688,
        115.17152404785156
      ],
      "bbox_max": [
        1410.0,
        643.65673828125,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.3826892673969269,
        -0.9238771200180054
      ],
      "plane_d": 353.68731689453125,
      "bbox_min": [
        1390.0,
        644.9999389648438,
        108.34353637695312
      ],
      "bbox_max": [
        1480.0,
        653.0000610351562,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3826892673969269,
        -0.9238771200180054
      ],
      "plane_d": -143.04335021972656,
      "bbox_min": [
        1390.0,
        644.9999389648438,
        113.17155456542969
      ],
      "bbox_max": [
        1480.0,
        653.0000610351562,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1390.0,
        644.9999389648438,
        113.99998474121094
      ],
      "bbox_max": [
        1410.0,
        653.0000610351562,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        650.0,
        114.4142074584961
      ],
      "bbox_max": [
        1410.0,
        653.0000610351562,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        644.9999389648438,
        113.99998474121094
      ],
      "bbox_max": [
        1410.0,
        650.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1390.0,
        649.0,
        113.17155456542969
      ],
      "bbox_max": [
        1410.0,
        651.8284301757812,
        115.17158508300781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        650.0,
        113.17155456542969
      ],
      "bbox_max": [
        1410.0,
        651.8284301757812,
        115.17158508300781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1390.0,
        646.1715698242188,
        108.34353637695312
      ],
      "bbox_max": [
        1410.0,
        650.9999389648438,
        115.17158508300781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        650.0,
        110.75762939453125
      ],
      "bbox_max": [
        1410.0,
        650.9999389648438,
        113.58575439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1410.0,
      "bbox_min": [
        1410.0,
        646.1715698242188,
        108.34353637695312
      ],
      "bbox_max": [
        1410.0,
        650.0,
        115.17158508300781
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 103.0,
      "bbox_min": [
        1410.0,
        621.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        649.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        1410.0,
        621.0,
        103.0
      ],
      "bbox_max": [
        1480.0,
        649.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -622.0,
      "bbox_min": [
        1410.0,
        621.0,
        103.0
      ],
      "bbox_max": [
        1480.0,
        647.2008056640625,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        621.0,
        103.0
      ],
      "bbox_max": [
        1410.0,
        622.0,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1410.0,
      "bbox_min": [
        1410.0,
        622.0,
        103.0
      ],
      "bbox_max": [
        1480.0,
        647.2008056640625,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1479.0,
      "bbox_min": [
        1479.0,
        622.0,
        103.0
      ],
      "bbox_max": [
        1480.0,
        634.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 598.2123413085938,
      "bbox_min": [
        1479.0,
        633.0,
        103.0
      ],
      "bbox_max": [
        1480.0,
        634.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1410.0,
      "bbox_min": [
        1410.0,
        621.0,
        104.0
      ],
      "bbox_max": [
        1410.0,
        649.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        621.0,
        98.0
      ],
      "bbox_max": [
        1410.0,
        646.7865600585938,
        103.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.0,
      "bbox_min": [
        1390.0,
        644.7153930664062,
        98.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        118.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -107.0,
      "bbox_min": [
        1410.0,
        669.0,
        98.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1410.0,
        669.0,
        98.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 931.9666748046875,
      "bbox_min": [
        1410.0,
        669.0,
        106.0
      ],
      "bbox_max": [
        1466.0,
        670.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1111.57177734375,
      "bbox_min": [
        1465.0,
        669.0,
        106.0
      ],
      "bbox_max": [
        1466.0,
        670.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        669.0,
        106.0
      ],
      "bbox_max": [
        1410.0,
        670.0,
        107.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1422.0,
      "bbox_min": [
        1410.0,
        669.0,
        98.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1468.0,
      "bbox_min": [
        1422.0,
        669.0,
        98.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -932.673828125,
      "bbox_min": [
        1422.0,
        669.0,
        98.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 931.9666748046875,
      "bbox_min": [
        1422.0,
        669.0,
        104.0
      ],
      "bbox_max": [
        1424.0,
        670.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1423.0,
      "bbox_min": [
        1423.0,
        669.0,
        98.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.0,
        -0.7071067690849304
      ],
      "plane_d": 1110.86474609375,
      "bbox_min": [
        1465.0,
        669.0,
        98.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1111.57177734375,
      "bbox_min": [
        1466.0,
        669.0,
        104.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1467.0,
      "bbox_min": [
        1467.0,
        669.0,
        98.0
      ],
      "bbox_max": [
        1467.0,
        670.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        669.0,
        98.0
      ],
      "bbox_max": [
        1410.0,
        670.0,
        106.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        669.0,
        107.0
      ],
      "bbox_max": [
        1410.0,
        670.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1390.0,
        644.7153930664062,
        98.0
      ],
      "bbox_max": [
        1464.58251953125,
        669.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1390.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1410.0,
        650.0,
        110.7575912475586
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -103.25,
      "bbox_min": [
        1425.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1464.58251953125,
        659.58251953125,
        118.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.41312819719314575,
        -0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": -577.1795043945312,
      "bbox_min": [
        1425.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1464.58251953125,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41312819719314575,
        -0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": -569.9497680664062,
      "bbox_min": [
        1425.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1447.08251953125,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41312575340270996,
        0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": -795.0550537109375,
      "bbox_min": [
        1425.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1429.58251953125,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711857169866562,
        -0.41312819719314575,
        0.8944386839866638
      ],
      "plane_d": 423.2355041503906,
      "bbox_min": [
        1425.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1428.972412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711846888065338,
        -0.41312575340270996,
        0.8944399952888489
      ],
      "plane_d": -65.50000762939453,
      "bbox_min": [
        1425.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1428.972412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711857169866562,
        0.41312819719314575,
        0.8944386839866638
      ],
      "plane_d": -608.7633056640625,
      "bbox_min": [
        1425.41748046875,
        656.027587890625,
        102.75
      ],
      "bbox_max": [
        1428.972412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41312819719314575,
        0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": 384.4219665527344,
      "bbox_min": [
        1425.41748046875,
        656.027587890625,
        102.75
      ],
      "bbox_max": [
        1427.5,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41312575340270996,
        -0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": 609.5269165039062,
      "bbox_min": [
        1425.41748046875,
        656.027587890625,
        102.75
      ],
      "bbox_max": [
        1427.5,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711835116147995,
        -0.4131283462047577,
        -0.8944390416145325
      ],
      "plane_d": 120.03138732910156,
      "bbox_min": [
        1426.027587890625,
        658.20703125,
        102.75
      ],
      "bbox_max": [
        1427.5,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41312575340270996,
        0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": -802.2847290039062,
      "bbox_min": [
        1442.91748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1447.08251953125,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711857169866562,
        -0.41312819719314575,
        0.8944386839866638
      ],
      "plane_d": 426.2312316894531,
      "bbox_min": [
        1442.91748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1446.472412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711846888065338,
        -0.41312575340270996,
        0.8944399952888489
      ],
      "plane_d": -68.49573516845703,
      "bbox_min": [
        1442.91748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1446.472412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711857169866562,
        0.41312819719314575,
        0.8944386839866638
      ],
      "plane_d": -611.759033203125,
      "bbox_min": [
        1442.91748046875,
        656.027587890625,
        102.75
      ],
      "bbox_max": [
        1446.472412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41312575340270996,
        -0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": 616.756591796875,
      "bbox_min": [
        1442.91748046875,
        656.027587890625,
        102.75
      ],
      "bbox_max": [
        1445.0,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41312819719314575,
        0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": 391.6517028808594,
      "bbox_min": [
        1442.91748046875,
        657.5,
        102.75
      ],
      "bbox_max": [
        1445.0,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711846888065338,
        0.41312575340270996,
        0.8944399952888489
      ],
      "plane_d": -117.03235626220703,
      "bbox_min": [
        1443.527587890625,
        658.20703125,
        102.75
      ],
      "bbox_max": [
        1445.0,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41312819719314575,
        -0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": -584.4092407226562,
      "bbox_min": [
        1460.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1464.58251953125,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41312575340270996,
        0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": -809.5144653320312,
      "bbox_min": [
        1460.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1464.58251953125,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41312575340270996,
        -0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": 623.9862670898438,
      "bbox_min": [
        1460.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1463.972412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711857169866562,
        -0.41312819719314575,
        0.8944386839866638
      ],
      "plane_d": 429.2269592285156,
      "bbox_min": [
        1460.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1463.972412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711846888065338,
        -0.41312575340270996,
        0.8944399952888489
      ],
      "plane_d": -71.49146270751953,
      "bbox_min": [
        1460.41748046875,
        655.41748046875,
        102.75
      ],
      "bbox_max": [
        1463.972412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711846888065338,
        0.41312575340270996,
        0.8944399952888489
      ],
      "plane_d": -114.03662872314453,
      "bbox_min": [
        1460.41748046875,
        657.5,
        102.75
      ],
      "bbox_max": [
        1463.972412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41312819719314575,
        0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": 398.8814392089844,
      "bbox_min": [
        1460.41748046875,
        657.5,
        102.75
      ],
      "bbox_max": [
        1463.972412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711830198764801,
        -0.41312718391418457,
        -0.8944396376609802
      ],
      "plane_d": 614.7503051757812,
      "bbox_min": [
        1462.5,
        658.20703125,
        102.75
      ],
      "bbox_max": [
        1463.972412109375,
        659.58251953125,
        103.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1445.25,
      "bbox_min": [
        1427.25,
        657.25,
        103.25
      ],
      "bbox_max": [
        1462.75,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1427.75,
      "bbox_min": [
        1427.25,
        657.25,
        103.25
      ],
      "bbox_max": [
        1445.25,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 657.25,
      "bbox_min": [
        1427.25,
        657.25,
        103.25
      ],
      "bbox_max": [
        1427.75,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1427.25,
      "bbox_min": [
        1427.25,
        657.25,
        103.25
      ],
      "bbox_max": [
        1427.75,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -657.75,
      "bbox_min": [
        1427.25,
        657.75,
        103.25
      ],
      "bbox_max": [
        1427.75,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 657.25,
      "bbox_min": [
        1444.75,
        657.25,
        103.25
      ],
      "bbox_max": [
        1445.25,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1444.75,
      "bbox_min": [
        1444.75,
        657.25,
        103.25
      ],
      "bbox_max": [
        1445.25,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -657.75,
      "bbox_min": [
        1444.75,
        657.75,
        103.25
      ],
      "bbox_max": [
        1445.25,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 657.25,
      "bbox_min": [
        1462.25,
        657.25,
        103.25
      ],
      "bbox_max": [
        1462.75,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1462.75,
      "bbox_min": [
        1462.25,
        657.25,
        103.25
      ],
      "bbox_max": [
        1462.75,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1462.25,
      "bbox_min": [
        1462.25,
        657.25,
        103.25
      ],
      "bbox_max": [
        1462.75,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -657.75,
      "bbox_min": [
        1462.25,
        657.75,
        103.25
      ],
      "bbox_max": [
        1462.75,
        657.75,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1390.0,
        522.5,
        98.0
      ],
      "bbox_max": [
        1480.0,
        621.0,
        118.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1430.0,
      "bbox_min": [
        1390.0,
        522.5,
        116.0
      ],
      "bbox_max": [
        1460.0,
        620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -522.5,
      "bbox_min": [
        1430.0,
        522.5,
        116.0
      ],
      "bbox_max": [
        1440.0,
        542.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 542.5,
      "bbox_min": [
        1430.0,
        542.5,
        116.0
      ],
      "bbox_max": [
        1440.0,
        542.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        1440.0,
        522.5,
        116.0
      ],
      "bbox_max": [
        1460.0,
        570.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.4536830484867096,
        0.8911631107330322
      ],
      "plane_d": 153.44207763671875,
      "bbox_min": [
        1440.0,
        522.5,
        116.0
      ],
      "bbox_max": [
        1460.0,
        570.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -522.5,
      "bbox_min": [
        1440.0,
        522.5,
        116.0
      ],
      "bbox_max": [
        1460.0,
        522.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1390.0,
        522.5,
        116.0
      ],
      "bbox_max": [
        1430.0,
        620.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1390.0,
        610.0,
        116.0
      ],
      "bbox_max": [
        1410.0,
        610.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.12215520441532135,
        -0.9925110340118408
      ],
      "plane_d": 185.37051391601562,
      "bbox_min": [
        1410.0,
        522.5,
        116.0
      ],
      "bbox_max": [
        1430.0,
        575.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -522.5,
      "bbox_min": [
        1410.0,
        522.5,
        116.0
      ],
      "bbox_max": [
        1430.0,
        522.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1390.0,
        522.5,
        98.0
      ],
      "bbox_max": [
        1480.0,
        621.0,
        116.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1390.0,
        610.0,
        98.0
      ],
      "bbox_max": [
        1422.0,
        620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1390.0,
        610.0,
        98.0
      ],
      "bbox_max": [
        1422.0,
        620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1410.0,
      "bbox_min": [
        1410.0,
        610.0,
        98.0
      ],
      "bbox_max": [
        1422.0,
        620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1416.0,
      "bbox_min": [
        1416.0,
        612.0,
        98.0
      ],
      "bbox_max": [
        1422.0,
        618.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 618.0,
      "bbox_min": [
        1416.0,
        612.0,
        98.0
      ],
      "bbox_max": [
        1422.0,
        618.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -612.0,
      "bbox_min": [
        1416.0,
        612.0,
        98.0
      ],
      "bbox_max": [
        1422.0,
        618.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1422.0,
      "bbox_min": [
        1422.0,
        612.0,
        98.0
      ],
      "bbox_max": [
        1422.0,
        618.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1390.0,
        522.5,
        100.0
      ],
      "bbox_max": [
        1480.0,
        621.0,
        116.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1430.0,
      "bbox_min": [
        1390.0,
        522.5,
        100.0
      ],
      "bbox_max": [
        1460.0,
        600.0,
        116.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        1430.0,
        522.5,
        104.0
      ],
      "bbox_max": [
        1460.0,
        566.0714111328125,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        1430.0,
        522.5,
        104.0
      ],
      "bbox_max": [
        1460.0,
        566.0714111328125,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -522.5,
      "bbox_min": [
        1430.0,
        522.5,
        104.0
      ],
      "bbox_max": [
        1440.0,
        542.5,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 542.5,
      "bbox_min": [
        1430.0,
        542.5,
        104.0
      ],
      "bbox_max": [
        1440.0,
        542.5,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        1440.0,
        522.5,
        104.0
      ],
      "bbox_max": [
        1460.0,
        566.0714111328125,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -522.5,
      "bbox_min": [
        1440.0,
        522.5,
        104.0
      ],
      "bbox_max": [
        1460.0,
        522.5,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.12215520441532135,
        0.9925110340118408
      ],
      "plane_d": -169.4903564453125,
      "bbox_min": [
        1390.0,
        522.5,
        100.0
      ],
      "bbox_max": [
        1430.0,
        580.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        1410.0,
        522.5,
        104.0
      ],
      "bbox_max": [
        1430.0,
        542.5,
        106.4615478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -522.5,
      "bbox_min": [
        1410.0,
        522.5,
        104.0
      ],
      "bbox_max": [
        1430.0,
        542.5,
        106.4615478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        522.5,
        104.0
      ],
      "bbox_max": [
        1410.0,
        542.5,
        106.4615478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1390.0,
        522.5,
        100.0
      ],
      "bbox_max": [
        1430.0,
        580.0,
        116.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        620.0,
        100.0
      ],
      "bbox_max": [
        1412.0,
        621.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1410.0,
        620.0,
        102.0
      ],
      "bbox_max": [
        1412.0,
        621.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        1410.0,
        620.0,
        102.0
      ],
      "bbox_max": [
        1412.0,
        621.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1412.0,
      "bbox_min": [
        1412.0,
        620.0,
        102.0
      ],
      "bbox_max": [
        1412.0,
        621.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1390.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1412.0,
        620.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1412.0,
        610.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1410.0,
        600.0,
        102.0
      ],
      "bbox_max": [
        1412.0,
        610.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        1410.0,
        600.0,
        102.0
      ],
      "bbox_max": [
        1412.0,
        610.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1412.0,
      "bbox_min": [
        1412.0,
        600.0,
        102.0
      ],
      "bbox_max": [
        1412.0,
        610.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1409.0,
        610.0,
        100.0
      ],
      "bbox_max": [
        1412.0,
        620.0,
        116.0
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -109.0,
      "bbox_min": [
        1409.0,
        611.0,
        102.0
      ],
      "bbox_max": [
        1410.0,
        619.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        1409.0,
        611.0,
        102.0
      ],
      "bbox_max": [
        1410.0,
        619.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1409.0,
      "bbox_min": [
        1409.0,
        611.0,
        102.0
      ],
      "bbox_max": [
        1410.0,
        619.0,
        109.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 611.0,
      "bbox_min": [
        1409.0,
        611.0,
        102.0
      ],
      "bbox_max": [
        1410.0,
        619.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -619.0,
      "bbox_min": [
        1409.0,
        612.0,
        102.0
      ],
      "bbox_max": [
        1410.0,
        619.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        1409.0,
        612.0,
        103.0
      ],
      "bbox_max": [
        1410.0,
        618.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1409.0,
        612.0,
        103.0
      ],
      "bbox_max": [
        1410.0,
        618.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -612.0,
      "bbox_min": [
        1409.0,
        612.0,
        103.0
      ],
      "bbox_max": [
        1410.0,
        618.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 618.0,
      "bbox_min": [
        1409.0,
        618.0,
        103.0
      ],
      "bbox_max": [
        1410.0,
        618.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1410.0,
        610.0,
        102.0
      ],
      "bbox_max": [
        1412.0,
        620.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        1410.0,
        610.0,
        102.0
      ],
      "bbox_max": [
        1412.0,
        620.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1412.0,
      "bbox_min": [
        1412.0,
        610.0,
        102.0
      ],
      "bbox_max": [
        1412.0,
        620.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 610.0,
      "bbox_min": [
        1390.0,
        522.5,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        98.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -91.0,
      "bbox_min": [
        1390.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        98.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1390.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        91.0
      ],
      "face_count": 20
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1390.0,
        620.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        91.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1390.0,
        620.0,
        80.0
      ],
      "bbox_max": [
        1410.0,
        650.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1390.0,
        620.0,
        80.0
      ],
      "bbox_max": [
        1410.0,
        621.0,
        91.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        1391.800048828125,
        620.0,
        80.0
      ],
      "bbox_max": [
        1410.0,
        621.0,
        91.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1409.5,
      "bbox_min": [
        1409.5,
        620.0,
        90.0
      ],
      "bbox_max": [
        1409.5,
        621.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9153183102607727,
        -0.0,
        0.40273112058639526
      ],
      "plane_d": -1308.1722412109375,
      "bbox_min": [
        1391.800048828125,
        620.0,
        80.0
      ],
      "bbox_max": [
        1408.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9153183102607727,
        0.0,
        -0.40273112058639526
      ],
      "plane_d": -1239.7078857421875,
      "bbox_min": [
        1391.800048828125,
        620.0,
        80.0
      ],
      "bbox_max": [
        1408.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 1275.7269287109375,
      "bbox_min": [
        1406.0,
        620.0,
        80.0
      ],
      "bbox_max": [
        1408.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9284766912460327,
        0.0,
        -0.3713906705379486
      ],
      "plane_d": 1338.8634033203125,
      "bbox_min": [
        1406.0,
        620.0,
        85.0
      ],
      "bbox_max": [
        1408.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1414.0,
      "bbox_min": [
        1410.0,
        620.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        91.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -84.0,
      "bbox_min": [
        1410.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1414.0,
        670.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 83.5,
      "bbox_min": [
        1410.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1414.0,
        650.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1410.0,
        621.0,
        83.5
      ],
      "bbox_max": [
        1414.0,
        650.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1410.0,
        621.0,
        83.5
      ],
      "bbox_max": [
        1414.0,
        621.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1410.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1414.0,
        650.0,
        83.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1410.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1414.0,
        650.0,
        83.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -86.0,
      "bbox_min": [
        1410.0,
        621.0,
        84.0
      ],
      "bbox_max": [
        1414.0,
        670.0,
        91.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -854.23828125,
      "bbox_min": [
        1410.0,
        621.0,
        84.0
      ],
      "bbox_max": [
        1414.0,
        666.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1410.0,
        621.0,
        84.0
      ],
      "bbox_max": [
        1414.0,
        621.0,
        86.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.48507124185562134,
        -0.48507124185562134,
        0.7276068925857544
      ],
      "plane_d": -425.4075012207031,
      "bbox_min": [
        1411.0,
        621.0,
        84.0
      ],
      "bbox_max": [
        1414.0,
        666.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1411.0,
        621.0,
        84.0
      ],
      "bbox_max": [
        1414.0,
        621.0,
        86.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1410.0,
        621.0,
        86.0
      ],
      "bbox_max": [
        1414.0,
        621.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1472.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        621.0,
        91.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -86.0,
      "bbox_min": [
        1472.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        86.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1476.0,
      "bbox_min": [
        1472.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        669.0,
        86.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 748.8452758789062,
      "bbox_min": [
        1476.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        666.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -84.0,
      "bbox_min": [
        1476.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        650.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 83.5,
      "bbox_min": [
        1476.0,
        640.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        650.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1476.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        650.0,
        83.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1476.0,
        650.0,
        84.0
      ],
      "bbox_max": [
        1480.0,
        650.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48507124185562134,
        -0.48507124185562134,
        0.7276068925857544
      ],
      "plane_d": 976.4483642578125,
      "bbox_min": [
        1472.0,
        663.0,
        84.0
      ],
      "bbox_max": [
        1476.0,
        669.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 299.5380859375,
      "bbox_min": [
        1472.0,
        666.0,
        84.0
      ],
      "bbox_max": [
        1473.0,
        669.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1472.0,
        666.0,
        80.0
      ],
      "bbox_max": [
        1473.0,
        666.9998779296875,
        84.66658782958984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 299.5380859375,
      "bbox_min": [
        1472.0,
        666.0,
        84.0
      ],
      "bbox_max": [
        1473.0,
        666.9998779296875,
        84.66658782958984
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1414.0,
        620.0,
        80.0
      ],
      "bbox_max": [
        1472.0,
        670.0,
        91.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -86.0,
      "bbox_min": [
        1414.0,
        666.0,
        84.0
      ],
      "bbox_max": [
        1472.0,
        670.0,
        91.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 299.5380859375,
      "bbox_min": [
        1414.0,
        666.0,
        84.0
      ],
      "bbox_max": [
        1472.0,
        669.0,
        86.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1450.0,
      "bbox_min": [
        1440.0,
        666.0,
        84.0
      ],
      "bbox_max": [
        1450.0,
        669.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        1423.0,
        666.0,
        86.0
      ],
      "bbox_max": [
        1467.0,
        670.0,
        91.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.0,
      "bbox_min": [
        1423.0,
        666.875,
        89.0
      ],
      "bbox_max": [
        1467.0,
        670.0,
        91.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        1423.0,
        669.0,
        89.0
      ],
      "bbox_max": [
        1467.0,
        670.0,
        91.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1450.0,
      "bbox_min": [
        1424.0,
        669.0,
        89.0
      ],
      "bbox_max": [
        1466.0,
        670.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1440.0,
        669.0,
        89.0
      ],
      "bbox_max": [
        1440.0,
        670.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -972.9788818359375,
      "bbox_min": [
        1465.0,
        669.0,
        89.0
      ],
      "bbox_max": [
        1466.0,
        670.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -1071.2667236328125,
      "bbox_min": [
        1423.0,
        669.0,
        90.0
      ],
      "bbox_max": [
        1467.0,
        670.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 1070.5595703125,
      "bbox_min": [
        1423.0,
        669.0,
        90.0
      ],
      "bbox_max": [
        1424.0,
        670.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 972.2718505859375,
      "bbox_min": [
        1465.0,
        669.0,
        90.0
      ],
      "bbox_max": [
        1467.0,
        670.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -972.9788818359375,
      "bbox_min": [
        1466.0,
        669.0,
        90.0
      ],
      "bbox_max": [
        1467.0,
        670.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        1440.0,
        666.875,
        89.0
      ],
      "bbox_max": [
        1450.0,
        669.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1450.0,
      "bbox_min": [
        1440.0,
        666.875,
        89.0
      ],
      "bbox_max": [
        1450.0,
        669.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1440.0,
        666.0,
        86.0
      ],
      "bbox_max": [
        1440.0,
        670.0,
        89.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1414.0,
        620.0,
        80.0
      ],
      "bbox_max": [
        1472.0,
        666.0,
        91.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1430.0,
      "bbox_min": [
        1417.5,
        620.0,
        80.0
      ],
      "bbox_max": [
        1470.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        1438.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1470.0,
        621.0,
        90.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1450.0,
      "bbox_min": [
        1438.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1470.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1438.0,
      "bbox_min": [
        1438.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1446.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1446.0,
      "bbox_min": [
        1438.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1446.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        1438.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1446.0,
        621.0,
        83.02912902832031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7171837091445923,
        0.0,
        0.6968841552734375
      ],
      "plane_d": 979.1859130859375,
      "bbox_min": [
        1438.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1446.0,
        621.0,
        83.02912902832031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7171759605407715,
        0.0,
        0.6968921422958374
      ],
      "plane_d": -1089.161376953125,
      "bbox_min": [
        1438.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1439.0,
        621.0,
        83.02910614013672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1462.0,
      "bbox_min": [
        1450.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1470.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1458.0,
      "bbox_min": [
        1450.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1458.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        1450.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1458.0,
        621.0,
        83.02912902832031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7171837091445923,
        0.0,
        0.6968841552734375
      ],
      "plane_d": 987.7921142578125,
      "bbox_min": [
        1450.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1458.0,
        621.0,
        83.02912902832031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7171837091445923,
        -1.595041248947382e-05,
        0.6968841552734375
      ],
      "plane_d": -1097.7681884765625,
      "bbox_min": [
        1450.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1451.0,
        621.0,
        83.02912902832031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1462.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1470.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        1462.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1470.0,
        621.0,
        83.02912902832031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7171837091445923,
        0.0,
        0.6968841552734375
      ],
      "plane_d": 996.3983154296875,
      "bbox_min": [
        1462.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1470.0,
        621.0,
        83.02912902832031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7171759605407715,
        0.0,
        0.6968921422958374
      ],
      "plane_d": -1106.37353515625,
      "bbox_min": [
        1462.0,
        620.0,
        82.0
      ],
      "bbox_max": [
        1463.0,
        621.0,
        83.02910614013672
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        1417.5,
        620.0,
        80.0
      ],
      "bbox_max": [
        1430.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1229.8372802734375,
      "bbox_min": [
        1417.5,
        620.0,
        80.0
      ],
      "bbox_max": [
        1420.0,
        621.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -1305.8636474609375,
      "bbox_min": [
        1417.5,
        620.0,
        80.0
      ],
      "bbox_max": [
        1420.0,
        621.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1455.0,
      "bbox_min": [
        1414.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1463.0,
        666.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 84.0,
      "bbox_min": [
        1455.0,
        636.0,
        80.0
      ],
      "bbox_max": [
        1463.0,
        650.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        1455.0,
        636.0,
        84.0
      ],
      "bbox_max": [
        1463.0,
        650.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1463.0,
      "bbox_min": [
        1455.0,
        636.0,
        84.0
      ],
      "bbox_max": [
        1463.0,
        650.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 636.0,
      "bbox_min": [
        1455.0,
        636.0,
        84.0
      ],
      "bbox_max": [
        1463.0,
        650.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1455.0,
        650.0,
        84.0
      ],
      "bbox_max": [
        1463.0,
        650.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1462.0,
      "bbox_min": [
        1455.5,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1462.5,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1462.5,
      "bbox_min": [
        1462.0,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1462.5,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 250.13885498046875,
      "bbox_min": [
        1462.0,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1462.5,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -392.8408203125,
      "bbox_min": [
        1462.0,
        639.862548828125,
        80.0
      ],
      "bbox_max": [
        1462.5,
        647.137451171875,
        84.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -250.6363525390625,
      "bbox_min": [
        1462.0,
        639.862548828125,
        80.0
      ],
      "bbox_max": [
        1462.5,
        646.137451171875,
        81.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 392.3394775390625,
      "bbox_min": [
        1462.0,
        643.0,
        80.0
      ],
      "bbox_max": [
        1462.5,
        646.137451171875,
        81.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -250.64535522460938,
      "bbox_min": [
        1462.0,
        643.5,
        82.09999084472656
      ],
      "bbox_max": [
        1462.5,
        646.791015625,
        84.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 392.3428039550781,
      "bbox_min": [
        1462.0,
        639.208984375,
        82.0999984741211
      ],
      "bbox_max": [
        1462.5,
        643.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -392.84161376953125,
      "bbox_min": [
        1462.0,
        640.208984375,
        82.388671875
      ],
      "bbox_max": [
        1462.5,
        643.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1455.5,
      "bbox_min": [
        1455.5,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1456.0,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1456.0,
      "bbox_min": [
        1455.5,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1456.0,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 250.13885498046875,
      "bbox_min": [
        1455.5,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1456.0,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -392.8408203125,
      "bbox_min": [
        1455.5,
        639.862548828125,
        80.0
      ],
      "bbox_max": [
        1456.0,
        647.137451171875,
        84.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -250.6363525390625,
      "bbox_min": [
        1455.5,
        639.862548828125,
        80.0
      ],
      "bbox_max": [
        1456.0,
        646.137451171875,
        81.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 392.3394775390625,
      "bbox_min": [
        1455.5,
        643.0,
        80.0
      ],
      "bbox_max": [
        1456.0,
        646.137451171875,
        81.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -250.64535522460938,
      "bbox_min": [
        1455.5,
        643.5,
        82.09999084472656
      ],
      "bbox_max": [
        1456.0,
        646.791015625,
        84.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 392.3428039550781,
      "bbox_min": [
        1455.5,
        639.208984375,
        82.0999984741211
      ],
      "bbox_max": [
        1456.0,
        643.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -392.84161376953125,
      "bbox_min": [
        1455.5,
        640.208984375,
        82.388671875
      ],
      "bbox_max": [
        1456.0,
        643.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1427.0,
      "bbox_min": [
        1414.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1450.0,
        666.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1435.0,
      "bbox_min": [
        1427.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1450.0,
        666.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 84.0,
      "bbox_min": [
        1427.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1435.0,
        650.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -85.0,
      "bbox_min": [
        1427.0,
        621.0,
        84.0
      ],
      "bbox_max": [
        1435.0,
        650.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 636.0,
      "bbox_min": [
        1427.0,
        621.0,
        84.0
      ],
      "bbox_max": [
        1435.0,
        650.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1427.0,
        650.0,
        84.0
      ],
      "bbox_max": [
        1435.0,
        650.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        1430.0,
        621.0,
        84.0
      ],
      "bbox_max": [
        1435.0,
        626.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1430.0,
      "bbox_min": [
        1430.0,
        621.0,
        84.0
      ],
      "bbox_max": [
        1430.0,
        626.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        1430.0,
        621.0,
        85.0
      ],
      "bbox_max": [
        1435.0,
        626.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1430.0,
      "bbox_min": [
        1430.0,
        621.0,
        85.0
      ],
      "bbox_max": [
        1430.0,
        626.0,
        91.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1430.0,
      "bbox_min": [
        1427.5,
        621.0,
        80.0
      ],
      "bbox_max": [
        1435.0,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        1430.0,
        626.0,
        80.0
      ],
      "bbox_max": [
        1435.0,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1434.5,
      "bbox_min": [
        1434.0,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1434.5,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1434.0,
      "bbox_min": [
        1434.0,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1434.5,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 250.13885498046875,
      "bbox_min": [
        1434.0,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1434.5,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -392.8408203125,
      "bbox_min": [
        1434.0,
        639.862548828125,
        80.0
      ],
      "bbox_max": [
        1434.5,
        647.137451171875,
        84.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -250.6363525390625,
      "bbox_min": [
        1434.0,
        639.862548828125,
        80.0
      ],
      "bbox_max": [
        1434.5,
        646.137451171875,
        81.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 392.3394775390625,
      "bbox_min": [
        1434.0,
        643.0,
        80.0
      ],
      "bbox_max": [
        1434.5,
        646.137451171875,
        81.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -250.64535522460938,
      "bbox_min": [
        1434.0,
        643.5,
        82.09999084472656
      ],
      "bbox_max": [
        1434.5,
        646.791015625,
        84.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 392.3428039550781,
      "bbox_min": [
        1434.0,
        639.208984375,
        82.0999984741211
      ],
      "bbox_max": [
        1434.5,
        643.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -392.84161376953125,
      "bbox_min": [
        1434.0,
        640.208984375,
        82.388671875
      ],
      "bbox_max": [
        1434.5,
        643.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1428.0,
      "bbox_min": [
        1427.5,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1428.0,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1427.5,
      "bbox_min": [
        1427.5,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1428.0,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 250.13885498046875,
      "bbox_min": [
        1427.5,
        638.862548828125,
        80.0
      ],
      "bbox_max": [
        1428.0,
        647.137451171875,
        84.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -392.8408203125,
      "bbox_min": [
        1427.5,
        639.862548828125,
        80.0
      ],
      "bbox_max": [
        1428.0,
        647.137451171875,
        84.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -250.6363525390625,
      "bbox_min": [
        1427.5,
        639.862548828125,
        80.0
      ],
      "bbox_max": [
        1428.0,
        646.137451171875,
        81.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 392.3394775390625,
      "bbox_min": [
        1427.5,
        643.0,
        80.0
      ],
      "bbox_max": [
        1428.0,
        646.137451171875,
        81.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -250.64535522460938,
      "bbox_min": [
        1427.5,
        643.5,
        82.09999084472656
      ],
      "bbox_max": [
        1428.0,
        646.791015625,
        84.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 392.3428039550781,
      "bbox_min": [
        1427.5,
        639.208984375,
        82.0999984741211
      ],
      "bbox_max": [
        1428.0,
        643.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -392.84161376953125,
      "bbox_min": [
        1427.5,
        640.208984375,
        82.388671875
      ],
      "bbox_max": [
        1428.0,
        643.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1442.5,
      "bbox_min": [
        1435.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1450.0,
        666.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -84.0,
      "bbox_min": [
        1442.5,
        635.0,
        80.0
      ],
      "bbox_max": [
        1450.0,
        666.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1447.5,
      "bbox_min": [
        1442.5,
        635.0,
        80.0
      ],
      "bbox_max": [
        1450.0,
        666.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1442.5,
        635.0,
        80.0
      ],
      "bbox_max": [
        1447.5,
        665.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 635.0,
      "bbox_min": [
        1442.5,
        635.0,
        80.0
      ],
      "bbox_max": [
        1447.5,
        635.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1442.5,
        665.0,
        80.0
      ],
      "bbox_max": [
        1447.5,
        665.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1447.5,
        665.0,
        80.0
      ],
      "bbox_max": [
        1450.0,
        666.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 518.3389892578125,
      "bbox_min": [
        1442.5,
        665.0,
        84.0
      ],
      "bbox_max": [
        1450.0,
        666.0,
        87.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1450.0,
      "bbox_min": [
        1450.0,
        665.0,
        84.0
      ],
      "bbox_max": [
        1450.0,
        666.0,
        87.5999984741211
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1445.0,
      "bbox_min": [
        1444.0,
        639.0,
        84.0
      ],
      "bbox_max": [
        1446.0,
        646.0,
        84.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 639.0,
      "bbox_min": [
        1444.0,
        639.0,
        84.0
      ],
      "bbox_max": [
        1445.0,
        640.0,
        84.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1444.0,
      "bbox_min": [
        1444.0,
        639.0,
        84.0
      ],
      "bbox_max": [
        1445.0,
        640.0,
        84.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1444.0,
        640.0,
        84.0
      ],
      "bbox_max": [
        1445.0,
        640.0,
        84.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        1445.0,
        645.0,
        84.0
      ],
      "bbox_max": [
        1446.0,
        646.0,
        84.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1446.0,
      "bbox_min": [
        1445.0,
        645.0,
        84.0
      ],
      "bbox_max": [
        1446.0,
        646.0,
        84.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -646.0,
      "bbox_min": [
        1445.0,
        646.0,
        84.0
      ],
      "bbox_max": [
        1446.0,
        646.0,
        84.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1444.75,
      "bbox_min": [
        1444.25,
        639.25,
        84.5
      ],
      "bbox_max": [
        1445.75,
        645.75,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 639.25,
      "bbox_min": [
        1444.25,
        639.25,
        84.5
      ],
      "bbox_max": [
        1444.75,
        639.75,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1444.25,
      "bbox_min": [
        1444.25,
        639.25,
        84.5
      ],
      "bbox_max": [
        1444.75,
        639.75,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -639.75,
      "bbox_min": [
        1444.25,
        639.75,
        84.5
      ],
      "bbox_max": [
        1444.75,
        639.75,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1445.75,
      "bbox_min": [
        1445.25,
        645.25,
        84.5
      ],
      "bbox_max": [
        1445.75,
        645.75,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 645.25,
      "bbox_min": [
        1445.25,
        645.25,
        84.5
      ],
      "bbox_max": [
        1445.75,
        645.75,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1445.25,
      "bbox_min": [
        1445.25,
        645.25,
        84.5
      ],
      "bbox_max": [
        1445.75,
        645.75,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -645.75,
      "bbox_min": [
        1445.25,
        645.75,
        84.5
      ],
      "bbox_max": [
        1445.75,
        645.75,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1438.0,
      "bbox_min": [
        1435.0,
        621.0,
        80.0
      ],
      "bbox_max": [
        1442.5,
        666.0,
        91.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -626.0,
      "bbox_min": [
        1435.0,
        626.0,
        80.0
      ],
      "bbox_max": [
        1438.0,
        626.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1440.0,
        665.0,
        80.0
      ],
      "bbox_max": [
        1442.5,
        666.0,
        87.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1440.0,
        665.0,
        80.0
      ],
      "bbox_max": [
        1442.5,
        666.0,
        87.5999984741211
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.48507124185562134,
        -0.48507124185562134,
        0.7276068925857544
      ],
      "plane_d": -425.4075012207031,
      "bbox_min": [
        1414.0,
        663.0,
        84.0
      ],
      "bbox_max": [
        1417.0,
        666.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1409.5,
        610.0,
        90.0
      ],
      "bbox_max": [
        1478.0,
        620.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1409.5,
      "bbox_min": [
        1409.5,
        610.0,
        90.0
      ],
      "bbox_max": [
        1409.5,
        620.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1478.0,
      "bbox_min": [
        1478.0,
        610.0,
        90.0
      ],
      "bbox_max": [
        1478.0,
        620.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1390.0,
        610.0,
        91.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        98.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1390.0,
        610.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        621.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        620.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        621.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1409.5,
        610.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        620.0,
        98.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -96.5,
      "bbox_min": [
        1409.5,
        612.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        619.0,
        96.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1409.5,
      "bbox_min": [
        1409.5,
        612.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        619.0,
        96.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 612.0,
      "bbox_min": [
        1409.5,
        612.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        619.0,
        96.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -619.0,
      "bbox_min": [
        1409.5,
        612.5,
        91.0
      ],
      "bbox_max": [
        1410.0,
        619.0,
        96.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 96.0,
      "bbox_min": [
        1409.5,
        612.5,
        91.0
      ],
      "bbox_max": [
        1410.0,
        618.5,
        96.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 618.5,
      "bbox_min": [
        1409.5,
        612.5,
        91.0
      ],
      "bbox_max": [
        1410.0,
        618.5,
        96.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -612.5,
      "bbox_min": [
        1409.5,
        612.5,
        91.0
      ],
      "bbox_max": [
        1410.0,
        612.5,
        96.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1390.0,
        650.0,
        91.0
      ],
      "bbox_max": [
        1410.0,
        650.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1472.0,
      "bbox_min": [
        1422.0,
        621.0,
        91.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1472.0,
        640.0,
        91.0
      ],
      "bbox_max": [
        1480.0,
        640.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238802194595337,
        0.0,
        0.3826816976070404
      ],
      "plane_d": -1369.5999755859375,
      "bbox_min": [
        1422.0,
        637.41748046875,
        91.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.0,
      "bbox_min": [
        1422.0,
        637.41748046875,
        91.0
      ],
      "bbox_max": [
        1444.75,
        670.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1423.0,
      "bbox_min": [
        1422.0,
        669.0,
        91.0
      ],
      "bbox_max": [
        1424.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1422.0,
      "bbox_min": [
        1422.0,
        669.0,
        91.0
      ],
      "bbox_max": [
        1423.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 1070.5595703125,
      "bbox_min": [
        1422.0,
        669.0,
        91.0
      ],
      "bbox_max": [
        1423.0,
        670.0,
        92.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": -1071.2667236328125,
      "bbox_min": [
        1423.0,
        669.0,
        91.0
      ],
      "bbox_max": [
        1424.0,
        670.0,
        92.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -95.75,
      "bbox_min": [
        1429.91748046875,
        637.41748046875,
        91.0
      ],
      "bbox_max": [
        1444.75,
        641.58251953125,
        95.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.382682740688324,
        0.0,
        0.9238798022270203
      ],
      "plane_d": -639.524658203125,
      "bbox_min": [
        1429.91748046875,
        637.41748046875,
        91.0
      ],
      "bbox_max": [
        1444.75,
        641.58251953125,
        95.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 95.25,
      "bbox_min": [
        1429.91748046875,
        637.41748046875,
        91.0
      ],
      "bbox_max": [
        1444.75,
        641.58251953125,
        95.75
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 639.25,
      "bbox_min": [
        1432.0,
        639.25,
        95.25
      ],
      "bbox_max": [
        1441.2071533203125,
        639.75,
        95.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1432.0,
      "bbox_min": [
        1432.0,
        639.25,
        95.25
      ],
      "bbox_max": [
        1432.0,
        639.75,
        95.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41312819719314575,
        -0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": -567.7347412109375,
      "bbox_min": [
        1429.91748046875,
        637.41748046875,
        91.0
      ],
      "bbox_max": [
        1444.75,
        641.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41312575340270996,
        -0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": 615.4601440429688,
      "bbox_min": [
        1429.91748046875,
        637.41748046875,
        94.75
      ],
      "bbox_max": [
        1434.08251953125,
        641.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711857169866562,
        -0.41312819719314575,
        0.8944386839866638
      ],
      "plane_d": 423.7250061035156,
      "bbox_min": [
        1429.91748046875,
        637.41748046875,
        94.75
      ],
      "bbox_max": [
        1434.08251953125,
        641.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711846888065338,
        -0.41312575340270996,
        0.8944399952888489
      ],
      "plane_d": -66.55109405517578,
      "bbox_min": [
        1429.91748046875,
        637.41748046875,
        94.75
      ],
      "bbox_max": [
        1434.08251953125,
        641.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41312575340270996,
        0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": -786.67724609375,
      "bbox_min": [
        1429.91748046875,
        639.5,
        94.75
      ],
      "bbox_max": [
        1434.08251953125,
        641.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711857169866562,
        0.41312819719314575,
        0.8944386839866638
      ],
      "plane_d": -594.94189453125,
      "bbox_min": [
        1429.91748046875,
        639.5,
        94.75
      ],
      "bbox_max": [
        1433.472412109375,
        641.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711846888065338,
        0.41312575340270996,
        0.8944399952888489
      ],
      "plane_d": -104.6659927368164,
      "bbox_min": [
        1429.91748046875,
        639.5,
        94.75
      ],
      "bbox_max": [
        1432.0,
        641.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41312819719314575,
        0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": 396.5179138183594,
      "bbox_min": [
        1429.91748046875,
        639.5,
        94.75
      ],
      "bbox_max": [
        1431.29296875,
        640.972412109375,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 639.25,
      "bbox_min": [
        1440.0,
        639.25,
        91.0
      ],
      "bbox_max": [
        1444.75,
        639.75,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -639.75,
      "bbox_min": [
        1440.0,
        639.25,
        91.0
      ],
      "bbox_max": [
        1444.75,
        639.75,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.923884391784668,
        0.0,
        -0.38267162442207336
      ],
      "plane_d": 1369.1431884765625,
      "bbox_min": [
        1443.0052490234375,
        639.25,
        91.0
      ],
      "bbox_max": [
        1444.25,
        639.75,
        94.00520324707031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.0,
      "bbox_min": [
        1445.25,
        643.41748046875,
        91.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1467.0,
      "bbox_min": [
        1466.0,
        669.0,
        91.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1468.0,
      "bbox_min": [
        1467.0,
        669.0,
        91.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -972.9788818359375,
      "bbox_min": [
        1467.0,
        669.0,
        91.0
      ],
      "bbox_max": [
        1468.0,
        670.0,
        92.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 972.2718505859375,
      "bbox_min": [
        1466.0,
        669.0,
        91.0
      ],
      "bbox_max": [
        1467.0,
        670.0,
        92.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -95.75,
      "bbox_min": [
        1445.25,
        643.41748046875,
        91.0
      ],
      "bbox_max": [
        1460.08251953125,
        647.58251953125,
        95.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.382682740688324,
        0.0,
        0.9238798022270203
      ],
      "plane_d": 466.428466796875,
      "bbox_min": [
        1445.25,
        643.41748046875,
        91.0
      ],
      "bbox_max": [
        1460.08251953125,
        647.58251953125,
        95.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802194595337,
        0.0,
        0.3826816976070404
      ],
      "plane_d": 1300.413818359375,
      "bbox_min": [
        1445.25,
        643.41748046875,
        91.0
      ],
      "bbox_max": [
        1460.08251953125,
        647.58251953125,
        95.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.25,
      "bbox_min": [
        1445.25,
        643.41748046875,
        91.0
      ],
      "bbox_max": [
        1460.08251953125,
        647.58251953125,
        95.75
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 645.25,
      "bbox_min": [
        1448.7928466796875,
        645.25,
        95.25
      ],
      "bbox_max": [
        1458.0,
        645.75,
        95.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1458.0,
      "bbox_min": [
        1458.0,
        645.25,
        95.25
      ],
      "bbox_max": [
        1458.0,
        645.75,
        95.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41312819719314575,
        0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": 406.2321472167969,
      "bbox_min": [
        1445.25,
        643.41748046875,
        91.0
      ],
      "bbox_max": [
        1460.08251953125,
        647.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41312819719314575,
        -0.1711857169866562,
        0.8944386839866638
      ],
      "plane_d": -577.448974609375,
      "bbox_min": [
        1455.91748046875,
        643.41748046875,
        94.75
      ],
      "bbox_max": [
        1460.08251953125,
        647.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.41312575340270996,
        0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": -798.4456176757812,
      "bbox_min": [
        1455.91748046875,
        643.41748046875,
        94.75
      ],
      "bbox_max": [
        1460.08251953125,
        647.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711857169866562,
        0.41312819719314575,
        0.8944386839866638
      ],
      "plane_d": -601.8714599609375,
      "bbox_min": [
        1455.91748046875,
        643.41748046875,
        94.75
      ],
      "bbox_max": [
        1459.472412109375,
        647.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711846888065338,
        0.41312575340270996,
        0.8944399952888489
      ],
      "plane_d": -102.69391632080078,
      "bbox_min": [
        1455.91748046875,
        643.41748046875,
        94.75
      ],
      "bbox_max": [
        1459.472412109375,
        647.58251953125,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.41312575340270996,
        -0.1711846888065338,
        0.8944399952888489
      ],
      "plane_d": 627.2284545898438,
      "bbox_min": [
        1455.91748046875,
        643.41748046875,
        94.75
      ],
      "bbox_max": [
        1459.472412109375,
        645.5,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1711857169866562,
        -0.41312819719314575,
        0.8944386839866638
      ],
      "plane_d": 430.6546325683594,
      "bbox_min": [
        1456.527587890625,
        643.41748046875,
        94.75
      ],
      "bbox_max": [
        1459.472412109375,
        644.79296875,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1711846888065338,
        -0.41312575340270996,
        0.8944399952888489
      ],
      "plane_d": -68.52313995361328,
      "bbox_min": [
        1458.0,
        643.41748046875,
        94.75
      ],
      "bbox_max": [
        1459.472412109375,
        644.79296875,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 645.25,
      "bbox_min": [
        1445.25,
        645.25,
        91.0
      ],
      "bbox_max": [
        1450.0,
        645.75,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -645.75,
      "bbox_min": [
        1445.25,
        645.25,
        91.0
      ],
      "bbox_max": [
        1450.0,
        645.75,
        95.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.923884391784668,
        0.0,
        -0.38267162442207336
      ],
      "plane_d": -1300.8826904296875,
      "bbox_min": [
        1445.75,
        645.25,
        91.0
      ],
      "bbox_max": [
        1446.9947509765625,
        645.75,
        94.00520324707031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1390.0,
        522.5,
        80.0
      ],
      "bbox_max": [
        1410.0,
        560.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1390.0,
        560.0,
        80.0
      ],
      "bbox_max": [
        1410.0,
        560.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1290.0,
        538.75,
        80.0
      ],
      "bbox_max": [
        1390.0,
        670.0,
        127.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1290.0,
        565.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        670.0,
        127.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 127.0,
      "bbox_min": [
        1360.0,
        565.0,
        118.0
      ],
      "bbox_max": [
        1380.0,
        574.800048828125,
        127.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        1360.0,
        565.0,
        118.0
      ],
      "bbox_max": [
        1380.0,
        574.800048828125,
        127.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 574.800048828125,
      "bbox_min": [
        1360.0,
        565.0,
        118.0
      ],
      "bbox_max": [
        1380.0,
        574.800048828125,
        127.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        1360.0,
        565.0,
        118.0
      ],
      "bbox_max": [
        1380.0,
        574.800048828125,
        127.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1360.0,
      "bbox_min": [
        1360.0,
        565.0,
        118.0
      ],
      "bbox_max": [
        1360.0,
        574.800048828125,
        127.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -620.0,
      "bbox_min": [
        1290.0,
        565.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        670.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1340.0,
        565.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        620.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1360.0,
        565.0,
        116.0
      ],
      "bbox_max": [
        1389.0,
        620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        1360.0,
        565.0,
        116.0
      ],
      "bbox_max": [
        1380.0,
        574.800048828125,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 574.800048828125,
      "bbox_min": [
        1360.0,
        565.0,
        116.0
      ],
      "bbox_max": [
        1380.0,
        574.800048828125,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -117.0,
      "bbox_min": [
        1360.0,
        565.0,
        116.0
      ],
      "bbox_max": [
        1380.0,
        574.800048828125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1360.0,
      "bbox_min": [
        1360.0,
        565.0,
        116.0
      ],
      "bbox_max": [
        1370.0,
        574.800048828125,
        117.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        1370.0,
        565.0,
        116.0
      ],
      "bbox_max": [
        1370.0,
        574.800048828125,
        117.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        1360.0,
        565.0,
        117.0
      ],
      "bbox_max": [
        1380.0,
        574.800048828125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1360.0,
      "bbox_min": [
        1360.0,
        565.0,
        117.0
      ],
      "bbox_max": [
        1360.0,
        574.800048828125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7828646898269653,
        0.6221920251846313,
        -0.0
      ],
      "plane_d": -1450.4549560546875,
      "bbox_min": [
        1360.0,
        610.0,
        116.0
      ],
      "bbox_max": [
        1389.0,
        620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1389.0,
      "bbox_min": [
        1389.0,
        610.0,
        116.0
      ],
      "bbox_max": [
        1389.0,
        620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1340.0,
        565.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        620.0,
        116.00296020507812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1340.0,
        610.0,
        98.0
      ],
      "bbox_max": [
        1389.0,
        620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7828646898269653,
        0.6221920251846313,
        -0.0
      ],
      "plane_d": -1450.4549560546875,
      "bbox_min": [
        1340.0,
        610.0,
        98.0
      ],
      "bbox_max": [
        1389.0,
        620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.1961161345243454,
        0.9805806875228882
      ],
      "plane_d": -217.68890380859375,
      "bbox_min": [
        1340.0,
        610.0,
        98.0
      ],
      "bbox_max": [
        1350.0,
        620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        610.0,
        98.0
      ],
      "bbox_max": [
        1350.0,
        620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7828646898269653,
        0.6221920251846313,
        -0.0
      ],
      "plane_d": -1450.4549560546875,
      "bbox_min": [
        1340.0,
        610.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        620.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1340.0,
      "bbox_min": [
        1340.0,
        610.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        620.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        610.0,
        100.0
      ],
      "bbox_max": [
        1350.0,
        620.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1389.0,
      "bbox_min": [
        1389.0,
        610.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        620.0,
        116.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -101.0,
      "bbox_min": [
        1389.0,
        612.0,
        101.0
      ],
      "bbox_max": [
        1390.0,
        618.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1389.0,
        612.0,
        101.0
      ],
      "bbox_max": [
        1390.0,
        618.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -612.0,
      "bbox_min": [
        1389.0,
        612.0,
        101.0
      ],
      "bbox_max": [
        1390.0,
        618.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 618.0,
      "bbox_min": [
        1389.0,
        618.0,
        101.0
      ],
      "bbox_max": [
        1390.0,
        618.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1340.0,
      "bbox_min": [
        1340.0,
        565.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        610.0,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        1340.0,
        565.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        610.0,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9906256794929504,
        0.13660459220409393
      ],
      "plane_d": 589.7537841796875,
      "bbox_min": [
        1340.0,
        565.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        610.0,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -104.9000015258789,
      "bbox_min": [
        1351.9761962890625,
        609.1243896484375,
        100.0
      ],
      "bbox_max": [
        1389.300048828125,
        610.0,
        104.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.854218065738678,
        0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": -1440.8565673828125,
      "bbox_min": [
        1351.9761962890625,
        609.1243896484375,
        100.0
      ],
      "bbox_max": [
        1357.699951171875,
        610.0,
        104.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542176485061646,
        0.49323606491088867,
        -0.16440916061401367
      ],
      "plane_d": 871.169921875,
      "bbox_min": [
        1351.9761962890625,
        609.1243896484375,
        100.0
      ],
      "bbox_max": [
        1354.6239013671875,
        609.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1351.9761962890625,
        609.5380249023438,
        103.0
      ],
      "bbox_max": [
        1354.6239013671875,
        609.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1357.699951171875,
      "bbox_min": [
        1357.699951171875,
        609.1243896484375,
        100.0
      ],
      "bbox_max": [
        1357.699951171875,
        610.0,
        104.9000015258789
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.854218065738678,
        0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": -1440.8565673828125,
      "bbox_min": [
        1352.0311279296875,
        608.7997436523438,
        100.0
      ],
      "bbox_max": [
        1357.699951171875,
        609.400146484375,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542176485061646,
        0.49323606491088867,
        -0.16440916061401367
      ],
      "plane_d": 871.169921875,
      "bbox_min": [
        1352.0311279296875,
        608.7997436523438,
        100.0
      ],
      "bbox_max": [
        1352.314697265625,
        609.400146484375,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.854218065738678,
        0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": -1440.8565673828125,
      "bbox_min": [
        1351.9881591796875,
        609.2998657226562,
        102.0
      ],
      "bbox_max": [
        1354.6119384765625,
        609.5233154296875,
        102.8934555053711
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542176485061646,
        0.49323606491088867,
        -0.16440916061401367
      ],
      "plane_d": 871.169921875,
      "bbox_min": [
        1351.9881591796875,
        609.2998657226562,
        102.0
      ],
      "bbox_max": [
        1352.0889892578125,
        609.5233154296875,
        102.8934555053711
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -580.0,
      "bbox_min": [
        1340.0,
        565.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        609.53955078125,
        116.00296020507812
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1360.0,
      "bbox_min": [
        1360.0,
        565.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        580.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 578.0,
      "bbox_min": [
        1360.0,
        575.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        580.0,
        116.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 112.0,
      "bbox_min": [
        1360.0,
        578.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        580.0,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        1370.0,
        578.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        580.0,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1372.0,
      "bbox_min": [
        1370.0,
        578.0,
        100.0
      ],
      "bbox_max": [
        1372.0,
        580.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        1370.0,
        578.0,
        100.0
      ],
      "bbox_max": [
        1370.0,
        580.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1372.0,
      "bbox_min": [
        1370.0,
        578.0,
        105.0
      ],
      "bbox_max": [
        1372.0,
        580.0,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        1370.0,
        578.0,
        105.0
      ],
      "bbox_max": [
        1370.0,
        580.0,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7295368909835815,
        -0.6839414834976196
      ],
      "plane_d": 498.2737731933594,
      "bbox_min": [
        1372.0,
        575.0,
        103.0
      ],
      "bbox_max": [
        1390.0,
        578.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 575.0,
      "bbox_min": [
        1372.0,
        575.0,
        112.0
      ],
      "bbox_max": [
        1390.0,
        578.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1372.0,
      "bbox_min": [
        1372.0,
        575.0,
        112.0
      ],
      "bbox_max": [
        1372.0,
        578.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.5,
      "bbox_min": [
        1372.0,
        576.0,
        103.0
      ],
      "bbox_max": [
        1390.0,
        578.0,
        103.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 103.0,
      "bbox_min": [
        1372.0,
        576.0,
        103.0
      ],
      "bbox_max": [
        1390.0,
        578.0,
        103.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 576.0,
      "bbox_min": [
        1372.0,
        576.0,
        103.0
      ],
      "bbox_max": [
        1390.0,
        578.0,
        103.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1372.0,
      "bbox_min": [
        1372.0,
        576.0,
        103.0
      ],
      "bbox_max": [
        1372.0,
        578.0,
        103.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.894253134727478,
        -0.44756150245666504
      ],
      "plane_d": 588.462890625,
      "bbox_min": [
        1343.082275390625,
        580.26806640625,
        100.0
      ],
      "bbox_max": [
        1389.300048828125,
        609.53955078125,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -102.0,
      "bbox_min": [
        1350.97265625,
        606.145263671875,
        100.0
      ],
      "bbox_max": [
        1389.300048828125,
        609.53955078125,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 101.5999984741211,
      "bbox_min": [
        1351.1651611328125,
        607.0,
        100.0
      ],
      "bbox_max": [
        1389.300048828125,
        609.2999877929688,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1357.699951171875,
      "bbox_min": [
        1351.1651611328125,
        607.0,
        101.5999984741211
      ],
      "bbox_max": [
        1357.699951171875,
        609.2999877929688,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542176485061646,
        0.49323606491088867,
        -0.16440916061401367
      ],
      "plane_d": 871.169921875,
      "bbox_min": [
        1351.1651611328125,
        607.0,
        101.5999984741211
      ],
      "bbox_max": [
        1355.4349365234375,
        609.2998657226562,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542529940605164,
        -0.49317699670791626,
        -0.16440272331237793
      ],
      "plane_d": -841.3623046875,
      "bbox_min": [
        1351.1651611328125,
        607.0,
        101.5999984741211
      ],
      "bbox_max": [
        1355.4349365234375,
        607.800048828125,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542515635490417,
        -0.4931761622428894,
        -0.16441284120082855
      ],
      "plane_d": 1470.7574462890625,
      "bbox_min": [
        1351.1651611328125,
        607.0,
        101.5999984741211
      ],
      "bbox_max": [
        1351.6270751953125,
        607.800048828125,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542515635490417,
        -0.4931761622428894,
        -0.16441284120082855
      ],
      "plane_d": 1470.7574462890625,
      "bbox_min": [
        1351.2421875,
        607.2001953125,
        100.40135192871094
      ],
      "bbox_max": [
        1351.5885009765625,
        607.800048828125,
        101.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542176485061646,
        0.49323606491088867,
        -0.16440916061401367
      ],
      "plane_d": 871.169921875,
      "bbox_min": [
        1350.97265625,
        606.49951171875,
        102.0
      ],
      "bbox_max": [
        1355.62744140625,
        609.5380249023438,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542529940605164,
        -0.49317699670791626,
        -0.16440272331237793
      ],
      "plane_d": -841.3623046875,
      "bbox_min": [
        1350.97265625,
        606.49951171875,
        102.0
      ],
      "bbox_max": [
        1355.62744140625,
        607.800048828125,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542515635490417,
        -0.4931761622428894,
        -0.16441284120082855
      ],
      "plane_d": 1470.7574462890625,
      "bbox_min": [
        1350.97265625,
        606.49951171875,
        102.0
      ],
      "bbox_max": [
        1351.7235107421875,
        607.800048828125,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -1386.7496337890625,
      "bbox_min": [
        1351.62060546875,
        606.145263671875,
        103.0
      ],
      "bbox_max": [
        1355.0853271484375,
        609.53955078125,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": -527.2054443359375,
      "bbox_min": [
        1351.62060546875,
        606.145263671875,
        103.0
      ],
      "bbox_max": [
        1354.7425537109375,
        609.53955078125,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": 604.0836791992188,
      "bbox_min": [
        1351.62060546875,
        606.41748046875,
        103.0
      ],
      "bbox_max": [
        1353.3529052734375,
        609.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 224.23406982421875,
      "bbox_min": [
        1351.96337890625,
        606.41748046875,
        103.16371154785156
      ],
      "bbox_max": [
        1354.7425537109375,
        607.80712890625,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": -527.2054443359375,
      "bbox_min": [
        1353.3529052734375,
        606.4175415039062,
        103.0
      ],
      "bbox_max": [
        1355.0853271484375,
        609.53955078125,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": -770.395263671875,
      "bbox_min": [
        1353.3529052734375,
        606.4175415039062,
        103.0
      ],
      "bbox_max": [
        1355.0853271484375,
        609.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107254981995,
        -0.5000253915786743,
        -0.0
      ],
      "plane_d": 1463.59326171875,
      "bbox_min": [
        1343.082275390625,
        580.26806640625,
        100.0
      ],
      "bbox_max": [
        1358.0,
        608.0009155273438,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -583.73193359375,
      "bbox_min": [
        1351.4727783203125,
        580.26806640625,
        100.0
      ],
      "bbox_max": [
        1358.0,
        608.0009155273438,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107254981995,
        0.5000253915786743,
        0.0
      ],
      "plane_d": -1467.057373046875,
      "bbox_min": [
        1354.0,
        580.26806640625,
        100.0
      ],
      "bbox_max": [
        1358.0,
        583.73193359375,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660107254981995,
        -0.5000253915786743,
        0.0
      ],
      "plane_d": -885.0277099609375,
      "bbox_min": [
        1354.0,
        580.26806640625,
        100.0
      ],
      "bbox_max": [
        1358.0,
        583.73193359375,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660107254981995,
        0.5000253915786743,
        0.0
      ],
      "plane_d": 881.5637817382812,
      "bbox_min": [
        1354.0,
        580.26806640625,
        100.0
      ],
      "bbox_max": [
        1358.0,
        583.73193359375,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        1354.0,
        580.26806640625,
        100.0
      ],
      "bbox_max": [
        1358.0,
        583.73193359375,
        105.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -580.51806640625,
      "bbox_min": [
        1354.2886962890625,
        580.51806640625,
        100.0
      ],
      "bbox_max": [
        1357.7113037109375,
        583.48193359375,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 583.48193359375,
      "bbox_min": [
        1354.2886962890625,
        580.51806640625,
        100.0
      ],
      "bbox_max": [
        1357.7113037109375,
        583.48193359375,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660264015197754,
        0.4999982714653015,
        0.0
      ],
      "plane_d": -1463.8487548828125,
      "bbox_min": [
        1354.2886962890625,
        580.51806640625,
        100.0
      ],
      "bbox_max": [
        1357.7113037109375,
        583.48193359375,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660264015197754,
        -0.4999982714653015,
        0.0
      ],
      "plane_d": -881.8507080078125,
      "bbox_min": [
        1354.2886962890625,
        580.51806640625,
        100.0
      ],
      "bbox_max": [
        1357.7113037109375,
        583.48193359375,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660264015197754,
        -0.4999982714653015,
        -0.0
      ],
      "plane_d": 1466.8128662109375,
      "bbox_min": [
        1356.855712890625,
        580.51806640625,
        100.0
      ],
      "bbox_max": [
        1357.7113037109375,
        583.48193359375,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660264015197754,
        0.4999982714653015,
        0.0
      ],
      "plane_d": 884.8148193359375,
      "bbox_min": [
        1356.855712890625,
        580.51806640625,
        100.0
      ],
      "bbox_max": [
        1357.7113037109375,
        582.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": 614.4751586914062,
      "bbox_min": [
        1351.4727783203125,
        605.784423828125,
        100.0
      ],
      "bbox_max": [
        1355.1273193359375,
        608.0009155273438,
        103.70777130126953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1351.4727783203125,
        605.784423828125,
        100.0
      ],
      "bbox_max": [
        1355.1273193359375,
        608.0009155273438,
        103.70777130126953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542529940605164,
        -0.49317699670791626,
        -0.16440272331237793
      ],
      "plane_d": -841.3623046875,
      "bbox_min": [
        1351.4727783203125,
        605.784423828125,
        100.0
      ],
      "bbox_max": [
        1355.1273193359375,
        608.0009155273438,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542515635490417,
        -0.4931761622428894,
        -0.16441284120082855
      ],
      "plane_d": 1470.7574462890625,
      "bbox_min": [
        1351.4727783203125,
        605.784423828125,
        100.0
      ],
      "bbox_max": [
        1355.1273193359375,
        608.0009155273438,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.854218065738678,
        0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": -1440.8565673828125,
      "bbox_min": [
        1351.4727783203125,
        607.800048828125,
        100.0
      ],
      "bbox_max": [
        1355.1273193359375,
        608.0009155273438,
        100.40135192871094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542176485061646,
        0.49323606491088867,
        -0.16440916061401367
      ],
      "plane_d": 871.169921875,
      "bbox_min": [
        1351.4727783203125,
        607.800048828125,
        100.0
      ],
      "bbox_max": [
        1351.666015625,
        608.0009155273438,
        100.40135192871094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": -527.2054443359375,
      "bbox_min": [
        1351.683837890625,
        606.145263671875,
        103.0
      ],
      "bbox_max": [
        1355.02197265625,
        606.49951171875,
        103.70777130126953
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": 604.0836791992188,
      "bbox_min": [
        1351.683837890625,
        606.145263671875,
        103.0
      ],
      "bbox_max": [
        1351.96337890625,
        606.49951171875,
        103.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 1386.7496337890625,
      "bbox_min": [
        1351.691162109375,
        606.145263671875,
        103.0
      ],
      "bbox_max": [
        1355.02197265625,
        606.4994506835938,
        103.70722198486328
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": -770.395263671875,
      "bbox_min": [
        1354.7425537109375,
        606.1455078125,
        103.0
      ],
      "bbox_max": [
        1355.02197265625,
        606.4994506835938,
        103.16371154785156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 224.23406982421875,
      "bbox_min": [
        1351.691162109375,
        606.145263671875,
        103.0
      ],
      "bbox_max": [
        1355.0146484375,
        606.4175415039062,
        103.163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6124089360237122,
        0.6123769283294678,
        -0.49994975328445435
      ],
      "plane_d": -1127.8839111328125,
      "bbox_min": [
        1343.082275390625,
        583.011474609375,
        109.18524932861328
      ],
      "bbox_max": [
        1347.8350830078125,
        587.71435546875,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6123732924461365,
        -0.6123732924461365,
        0.4999978542327881
      ],
      "plane_d": 1126.828369140625,
      "bbox_min": [
        1343.082275390625,
        583.011474609375,
        109.18524932861328
      ],
      "bbox_max": [
        1347.8350830078125,
        587.71435546875,
        116.00296020507812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.042371902614831924,
        0.042371902614831924,
        0.9982029795646667
      ],
      "plane_d": -193.7558135986328,
      "bbox_min": [
        1344.2529296875,
        584.132080078125,
        109.18524932861328
      ],
      "bbox_max": [
        1347.8350830078125,
        587.71435546875,
        112.11011505126953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5900675654411316,
        -0.5901118516921997,
        -0.5509884357452393
      ],
      "plane_d": 1199.536865234375,
      "bbox_min": [
        1344.2529296875,
        584.132080078125,
        109.18524932861328
      ],
      "bbox_max": [
        1347.8350830078125,
        587.71435546875,
        112.11011505126953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.906368613243103,
        0.35843294858932495,
        0.22365540266036987
      ],
      "plane_d": 983.8049926757812,
      "bbox_min": [
        1344.2529296875,
        584.132080078125,
        109.18524932861328
      ],
      "bbox_max": [
        1347.8350830078125,
        587.71435546875,
        112.11011505126953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3585982620716095,
        -0.906336784362793,
        0.22351938486099243
      ],
      "plane_d": 22.176868438720703,
      "bbox_min": [
        1345.8792724609375,
        584.132080078125,
        109.18524932861328
      ],
      "bbox_max": [
        1347.8350830078125,
        585.380615234375,
        112.11011505126953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 115.50296020507812,
      "bbox_min": [
        1343.082275390625,
        583.011474609375,
        110.46466827392578
      ],
      "bbox_max": [
        1346.6177978515625,
        586.547119140625,
        116.00296020507812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5000698566436768,
        0.5000123381614685,
        -0.7070486545562744
      ],
      "plane_d": 461.2579345703125,
      "bbox_min": [
        1343.082275390625,
        583.011474609375,
        115.50296020507812
      ],
      "bbox_max": [
        1346.6177978515625,
        586.547119140625,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49996912479400635,
        -0.5000267028808594,
        -0.7071096897125244
      ],
      "plane_d": 1045.9317626953125,
      "bbox_min": [
        1343.082275390625,
        583.011474609375,
        115.50296020507812
      ],
      "bbox_max": [
        1346.6177978515625,
        586.547119140625,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000410676002502,
        0.499983549118042,
        -0.707089364528656
      ],
      "plane_d": -883.7197875976562,
      "bbox_min": [
        1344.85009765625,
        583.011474609375,
        115.50296020507812
      ],
      "bbox_max": [
        1346.6177978515625,
        586.547119140625,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4998972415924072,
        -0.49995478987693787,
        -0.7072113752365112
      ],
      "plane_d": -298.76885986328125,
      "bbox_min": [
        1344.85009765625,
        583.011474609375,
        115.50296020507812
      ],
      "bbox_max": [
        1346.6177978515625,
        584.779296875,
        116.00296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.491021990776062,
        -0.4908524751663208,
        -0.7196952700614929
      ],
      "plane_d": 1027.2186279296875,
      "bbox_min": [
        1344.3272705078125,
        584.2060546875,
        110.46466827392578
      ],
      "bbox_max": [
        1346.26806640625,
        586.147216796875,
        115.50296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7069846987724304,
        0.7072288393974304,
        0.0
      ],
      "plane_d": 536.9656372070312,
      "bbox_min": [
        1344.3272705078125,
        584.2060546875,
        110.46466827392578
      ],
      "bbox_max": [
        1346.26806640625,
        586.147216796875,
        115.50296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -537.701171875,
      "bbox_min": [
        1344.4788818359375,
        584.2060546875,
        110.46466827392578
      ],
      "bbox_max": [
        1346.26806640625,
        585.818603515625,
        115.50296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7069846987724304,
        -0.7072288393974304,
        0.0
      ],
      "plane_d": 1364.1112060546875,
      "bbox_min": [
        1344.4788818359375,
        584.4080810546875,
        111.1834945678711
      ],
      "bbox_max": [
        1345.8895263671875,
        585.818603515625,
        115.50296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -1364.7039794921875,
      "bbox_min": [
        1344.4964599609375,
        584.42578125,
        111.20000457763672
      ],
      "bbox_max": [
        1345.8895263671875,
        585.818603515625,
        115.50296020507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6124948859214783,
        -0.61228346824646,
        0.49995893239974976
      ],
      "plane_d": 1125.939208984375,
      "bbox_min": [
        1344.4964599609375,
        584.42578125,
        111.22642517089844
      ],
      "bbox_max": [
        1345.20361328125,
        585.1328735351562,
        112.04952239990234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19524668157100677,
        0.19521299004554749,
        0.9611298441886902
      ],
      "plane_d": -484.49029541015625,
      "bbox_min": [
        1344.8323974609375,
        584.7616577148438,
        112.0423355102539
      ],
      "bbox_max": [
        1345.20361328125,
        585.1328735351562,
        112.04952239990234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19524668157100677,
        0.19521299004554749,
        0.9611298441886902
      ],
      "plane_d": -484.49029541015625,
      "bbox_min": [
        1344.85009765625,
        584.7793579101562,
        111.76371002197266
      ],
      "bbox_max": [
        1345.8895263671875,
        585.818603515625,
        112.0423355102539
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6124948859214783,
        -0.61228346824646,
        0.49995893239974976
      ],
      "plane_d": 1125.939208984375,
      "bbox_min": [
        1344.4788818359375,
        584.4080810546875,
        111.1834945678711
      ],
      "bbox_max": [
        1344.85009765625,
        584.7792358398438,
        111.22683715820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5385600924491882,
        -0.8339270353317261,
        0.12049391120672226
      ],
      "plane_d": -250.593505859375,
      "bbox_min": [
        1344.8323974609375,
        584.2060546875,
        110.46466827392578
      ],
      "bbox_max": [
        1346.26806640625,
        585.4652099609375,
        112.04952239990234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19524668157100677,
        0.19521299004554749,
        0.9611298441886902
      ],
      "plane_d": -484.49029541015625,
      "bbox_min": [
        1344.8323974609375,
        584.2060546875,
        111.1834945678711
      ],
      "bbox_max": [
        1346.26806640625,
        585.4652099609375,
        112.04952239990234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6124948859214783,
        -0.61228346824646,
        0.49995893239974976
      ],
      "plane_d": 1125.939208984375,
      "bbox_min": [
        1344.8323974609375,
        584.2060546875,
        111.1834945678711
      ],
      "bbox_max": [
        1345.387939453125,
        584.7616577148438,
        112.04952239990234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8340355157852173,
        0.5383455157279968,
        0.12070169299840927
      ],
      "plane_d": 792.9111328125,
      "bbox_min": [
        1344.3272705078125,
        584.76171875,
        110.46466827392578
      ],
      "bbox_max": [
        1345.5361328125,
        586.147216796875,
        112.04952239990234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19524668157100677,
        0.19521299004554749,
        0.9611298441886902
      ],
      "plane_d": -484.49029541015625,
      "bbox_min": [
        1344.3272705078125,
        584.76171875,
        111.1834945678711
      ],
      "bbox_max": [
        1345.5361328125,
        586.147216796875,
        112.04952239990234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6124948859214783,
        -0.61228346824646,
        0.49995893239974976
      ],
      "plane_d": 1125.939208984375,
      "bbox_min": [
        1344.3272705078125,
        584.76171875,
        111.1834945678711
      ],
      "bbox_max": [
        1344.8323974609375,
        585.266845703125,
        112.04952239990234
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1309.5,
      "bbox_min": [
        1290.0,
        620.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        670.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        1290.0,
        644.0,
        98.0
      ],
      "bbox_max": [
        1309.5,
        670.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1295.5,
      "bbox_min": [
        1290.0,
        654.0,
        98.0
      ],
      "bbox_max": [
        1309.5,
        670.0,
        109.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1295.5,
        654.0,
        98.0
      ],
      "bbox_max": [
        1309.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1303.5,
      "bbox_min": [
        1295.5,
        654.0,
        98.0
      ],
      "bbox_max": [
        1309.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        1295.5,
        654.0,
        98.0
      ],
      "bbox_max": [
        1303.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1295.5,
        654.0,
        102.0
      ],
      "bbox_max": [
        1303.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        1295.5,
        654.0,
        102.0
      ],
      "bbox_max": [
        1303.5,
        654.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1295.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1303.5,
        668.0,
        102.00003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1296.5,
      "bbox_min": [
        1296.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1303.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1296.0,
      "bbox_min": [
        1296.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1296.5,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 243.5499725341797,
      "bbox_min": [
        1296.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1296.5,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -417.42913818359375,
      "bbox_min": [
        1296.0,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1296.5,
        665.137451171875,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 416.92779541015625,
      "bbox_min": [
        1296.0,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1296.5,
        664.137451171875,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -244.04736328125,
      "bbox_min": [
        1296.0,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1296.5,
        661.0,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -244.0567169189453,
      "bbox_min": [
        1296.0,
        661.5,
        100.09999084472656
      ],
      "bbox_max": [
        1296.5,
        664.791015625,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 416.93115234375,
      "bbox_min": [
        1296.0,
        657.208984375,
        100.0999984741211
      ],
      "bbox_max": [
        1296.5,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -417.4299621582031,
      "bbox_min": [
        1296.0,
        658.208984375,
        100.388671875
      ],
      "bbox_max": [
        1296.5,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1303.0,
      "bbox_min": [
        1302.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1303.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1302.5,
      "bbox_min": [
        1302.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1303.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 243.5499725341797,
      "bbox_min": [
        1302.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1303.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -417.42913818359375,
      "bbox_min": [
        1302.5,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1303.0,
        665.137451171875,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 416.92779541015625,
      "bbox_min": [
        1302.5,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1303.0,
        664.137451171875,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -244.04736328125,
      "bbox_min": [
        1302.5,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1303.0,
        661.0,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -244.0567169189453,
      "bbox_min": [
        1302.5,
        661.5,
        100.09999084472656
      ],
      "bbox_max": [
        1303.0,
        664.791015625,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 416.93115234375,
      "bbox_min": [
        1302.5,
        657.208984375,
        100.0999984741211
      ],
      "bbox_max": [
        1303.0,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -417.4299621582031,
      "bbox_min": [
        1302.5,
        658.208984375,
        100.388671875
      ],
      "bbox_max": [
        1303.0,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1303.5,
        666.0,
        98.0
      ],
      "bbox_max": [
        1309.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1303.5,
        666.0,
        98.0
      ],
      "bbox_max": [
        1305.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1305.5,
      "bbox_min": [
        1305.5,
        666.0,
        98.0
      ],
      "bbox_max": [
        1305.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        1295.5,
        666.0,
        103.0
      ],
      "bbox_max": [
        1309.5,
        670.0,
        108.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1295.5,
        666.0,
        103.0
      ],
      "bbox_max": [
        1309.5,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 205.71826171875,
      "bbox_min": [
        1305.5,
        666.0,
        103.0
      ],
      "bbox_max": [
        1309.5,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1305.5,
      "bbox_min": [
        1305.5,
        666.0,
        103.0
      ],
      "bbox_max": [
        1305.5,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1295.5,
        669.0,
        106.0
      ],
      "bbox_max": [
        1303.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1303.5,
      "bbox_min": [
        1303.5,
        669.0,
        106.0
      ],
      "bbox_max": [
        1303.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 665.5,
      "bbox_min": [
        1290.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1294.5,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        0.49991968274116516,
        0.0
      ],
      "plane_d": -1454.4512939453125,
      "bbox_min": [
        1290.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1294.5,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        -0.49991968274116516,
        0.0
      ],
      "plane_d": -787.8084106445312,
      "bbox_min": [
        1290.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1294.5,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1291.0,
      "bbox_min": [
        1290.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1294.5,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -109.0,
      "bbox_min": [
        1291.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1294.5,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1291.5,
      "bbox_min": [
        1291.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1294.5,
        668.0,
        109.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1291.0,
        665.5,
        98.5
      ],
      "bbox_max": [
        1291.5,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1291.0,
        667.0,
        98.5
      ],
      "bbox_max": [
        1291.5,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1291.0,
        667.0,
        98.5
      ],
      "bbox_max": [
        1291.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 209.5195770263672,
      "bbox_min": [
        1291.0,
        665.5,
        98.5
      ],
      "bbox_max": [
        1291.5,
        666.5,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        1291.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1294.5,
        668.0,
        108.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -108.25,
      "bbox_min": [
        1291.5,
        666.5,
        108.0
      ],
      "bbox_max": [
        1294.0,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1291.5,
        666.5,
        108.0
      ],
      "bbox_max": [
        1294.0,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1291.5,
        666.5,
        108.0
      ],
      "bbox_max": [
        1294.0,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1294.0,
      "bbox_min": [
        1294.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1294.0,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1292.5,
      "bbox_min": [
        1291.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1294.5,
        668.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": -666.1246337890625,
      "bbox_min": [
        1291.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1292.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1291.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1292.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.18310546875,
      "bbox_min": [
        1293.5,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1294.5,
        667.18310546875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 666.31689453125,
      "bbox_min": [
        1293.5,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1294.5,
        667.18310546875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1293.5,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1294.5,
        667.18310546875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": 488.804443359375,
      "bbox_min": [
        1290.0,
        665.5,
        98.5
      ],
      "bbox_max": [
        1291.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 209.5195770263672,
      "bbox_min": [
        1290.0,
        665.5,
        98.5
      ],
      "bbox_max": [
        1291.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 117.0,
      "bbox_min": [
        1290.0,
        644.0,
        117.0
      ],
      "bbox_max": [
        1309.5,
        645.0,
        117.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1349.5,
      "bbox_min": [
        1309.5,
        620.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        670.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        1309.5,
        620.0,
        98.0
      ],
      "bbox_max": [
        1349.5,
        670.0,
        118.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1330.5,
      "bbox_min": [
        1309.5,
        645.0,
        98.0
      ],
      "bbox_max": [
        1349.5,
        670.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1329.5,
      "bbox_min": [
        1309.5,
        645.0,
        98.0
      ],
      "bbox_max": [
        1330.5,
        670.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 117.0,
      "bbox_min": [
        1329.5,
        645.0,
        117.0
      ],
      "bbox_max": [
        1330.5,
        670.0,
        117.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1310.5,
      "bbox_min": [
        1309.5,
        645.0,
        98.0
      ],
      "bbox_max": [
        1329.5,
        670.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 117.0,
      "bbox_min": [
        1309.5,
        645.0,
        117.0
      ],
      "bbox_max": [
        1310.5,
        670.0,
        117.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1310.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1329.5,
        670.0,
        109.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        1315.5,
        668.0,
        98.0
      ],
      "bbox_max": [
        1329.5,
        670.0,
        108.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1315.5,
      "bbox_min": [
        1315.5,
        668.0,
        98.0
      ],
      "bbox_max": [
        1315.5,
        670.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.0,
      "bbox_min": [
        1315.5,
        669.0,
        106.0
      ],
      "bbox_max": [
        1323.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -108.0,
      "bbox_min": [
        1315.5,
        669.0,
        106.0
      ],
      "bbox_max": [
        1323.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1315.5,
        669.0,
        106.0
      ],
      "bbox_max": [
        1323.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1315.5,
      "bbox_min": [
        1315.5,
        669.0,
        106.0
      ],
      "bbox_max": [
        1323.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1323.5,
      "bbox_min": [
        1323.5,
        669.0,
        106.0
      ],
      "bbox_max": [
        1323.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1325.5,
      "bbox_min": [
        1310.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1329.5,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1325.5,
        666.0,
        98.0
      ],
      "bbox_max": [
        1329.5,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 205.71826171875,
      "bbox_min": [
        1325.5,
        666.0,
        103.0
      ],
      "bbox_max": [
        1329.5,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 665.5,
      "bbox_min": [
        1310.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1315.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        0.49991968274116516,
        0.0
      ],
      "plane_d": -1472.205810546875,
      "bbox_min": [
        1310.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1315.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        -0.49991968274116516,
        0.0
      ],
      "plane_d": -805.5629272460938,
      "bbox_min": [
        1310.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1315.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1311.5,
      "bbox_min": [
        1310.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1315.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -109.0,
      "bbox_min": [
        1311.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1315.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1312.0,
      "bbox_min": [
        1311.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1315.0,
        668.0,
        109.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1311.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1312.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1311.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1312.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1311.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1312.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 209.5195770263672,
      "bbox_min": [
        1311.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1312.0,
        666.5,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        1312.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1315.0,
        668.0,
        108.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -108.25,
      "bbox_min": [
        1312.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1314.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1312.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1314.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1312.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1314.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1314.5,
      "bbox_min": [
        1314.5,
        666.5,
        108.0
      ],
      "bbox_max": [
        1314.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1313.0,
      "bbox_min": [
        1312.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1315.0,
        668.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": -675.29248046875,
      "bbox_min": [
        1312.0,
        665.5,
        98.5
      ],
      "bbox_max": [
        1313.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1312.0,
        667.0,
        98.5
      ],
      "bbox_max": [
        1313.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.18310546875,
      "bbox_min": [
        1314.0,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1315.0,
        667.18310546875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 666.31689453125,
      "bbox_min": [
        1314.0,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1315.0,
        667.18310546875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1314.0,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1315.0,
        667.18310546875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": 497.97235107421875,
      "bbox_min": [
        1310.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1311.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1310.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1311.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1335.5,
      "bbox_min": [
        1330.5,
        654.0,
        98.0
      ],
      "bbox_max": [
        1349.5,
        670.0,
        109.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1335.5,
        654.0,
        98.0
      ],
      "bbox_max": [
        1349.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1343.5,
      "bbox_min": [
        1335.5,
        654.0,
        98.0
      ],
      "bbox_max": [
        1349.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        1335.5,
        654.0,
        98.0
      ],
      "bbox_max": [
        1343.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1335.5,
        654.0,
        102.0
      ],
      "bbox_max": [
        1343.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        1335.5,
        654.0,
        102.0
      ],
      "bbox_max": [
        1343.5,
        654.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1335.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1343.5,
        668.0,
        102.00003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1336.5,
      "bbox_min": [
        1336.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1343.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1336.0,
      "bbox_min": [
        1336.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1336.5,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 243.5499725341797,
      "bbox_min": [
        1336.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1336.5,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -417.42913818359375,
      "bbox_min": [
        1336.0,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1336.5,
        665.137451171875,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 416.92779541015625,
      "bbox_min": [
        1336.0,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1336.5,
        664.137451171875,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -244.04736328125,
      "bbox_min": [
        1336.0,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1336.5,
        661.0,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -244.0567169189453,
      "bbox_min": [
        1336.0,
        661.5,
        100.09999084472656
      ],
      "bbox_max": [
        1336.5,
        664.791015625,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 416.93115234375,
      "bbox_min": [
        1336.0,
        657.208984375,
        100.0999984741211
      ],
      "bbox_max": [
        1336.5,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -417.4299621582031,
      "bbox_min": [
        1336.0,
        658.208984375,
        100.388671875
      ],
      "bbox_max": [
        1336.5,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1343.0,
      "bbox_min": [
        1342.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1343.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1342.5,
      "bbox_min": [
        1342.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1343.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 243.5499725341797,
      "bbox_min": [
        1342.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1343.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -417.42913818359375,
      "bbox_min": [
        1342.5,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1343.0,
        665.137451171875,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 416.92779541015625,
      "bbox_min": [
        1342.5,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1343.0,
        664.137451171875,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -244.04736328125,
      "bbox_min": [
        1342.5,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1343.0,
        661.0,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -244.0567169189453,
      "bbox_min": [
        1342.5,
        661.5,
        100.09999084472656
      ],
      "bbox_max": [
        1343.0,
        664.791015625,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 416.93115234375,
      "bbox_min": [
        1342.5,
        657.208984375,
        100.0999984741211
      ],
      "bbox_max": [
        1343.0,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -417.4299621582031,
      "bbox_min": [
        1342.5,
        658.208984375,
        100.388671875
      ],
      "bbox_max": [
        1343.0,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1343.5,
        666.0,
        98.0
      ],
      "bbox_max": [
        1349.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1343.5,
        666.0,
        98.0
      ],
      "bbox_max": [
        1345.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1345.5,
      "bbox_min": [
        1345.5,
        666.0,
        98.0
      ],
      "bbox_max": [
        1345.5,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        1335.5,
        666.0,
        103.0
      ],
      "bbox_max": [
        1349.5,
        670.0,
        108.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1335.5,
        666.0,
        103.0
      ],
      "bbox_max": [
        1349.5,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 205.71826171875,
      "bbox_min": [
        1345.5,
        666.0,
        103.0
      ],
      "bbox_max": [
        1349.5,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1345.5,
      "bbox_min": [
        1345.5,
        666.0,
        103.0
      ],
      "bbox_max": [
        1345.5,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1335.5,
        669.0,
        106.0
      ],
      "bbox_max": [
        1343.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1343.5,
      "bbox_min": [
        1343.5,
        669.0,
        106.0
      ],
      "bbox_max": [
        1343.5,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 665.5,
      "bbox_min": [
        1330.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1335.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        1330.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1335.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        0.49991968274116516,
        0.0
      ],
      "plane_d": -1489.5272216796875,
      "bbox_min": [
        1330.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1335.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        -0.49991968274116516,
        0.0
      ],
      "plane_d": -822.8843383789062,
      "bbox_min": [
        1330.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1335.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1331.5,
      "bbox_min": [
        1330.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1335.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -109.0,
      "bbox_min": [
        1331.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1335.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1332.0,
      "bbox_min": [
        1331.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1335.0,
        668.0,
        109.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1331.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1332.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1331.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1332.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1331.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1332.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 209.5195770263672,
      "bbox_min": [
        1331.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1332.0,
        666.5,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        1332.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1335.0,
        668.0,
        108.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -108.25,
      "bbox_min": [
        1332.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1334.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1332.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1334.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1332.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1334.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1334.5,
      "bbox_min": [
        1334.5,
        666.5,
        108.0
      ],
      "bbox_max": [
        1334.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1333.0,
      "bbox_min": [
        1332.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1335.0,
        668.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": -684.2367553710938,
      "bbox_min": [
        1332.0,
        665.5,
        98.5
      ],
      "bbox_max": [
        1333.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1332.0,
        667.0,
        98.5
      ],
      "bbox_max": [
        1333.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.18310546875,
      "bbox_min": [
        1334.0,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1335.0,
        667.18310546875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 666.31689453125,
      "bbox_min": [
        1334.0,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1335.0,
        667.18310546875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1334.0,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1335.0,
        667.18310546875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": 506.9166259765625,
      "bbox_min": [
        1330.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1331.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 209.5195770263672,
      "bbox_min": [
        1330.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1331.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1330.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1331.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 644.0,
      "bbox_min": [
        1309.5,
        620.0,
        98.0
      ],
      "bbox_max": [
        1349.5,
        645.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 117.0,
      "bbox_min": [
        1309.5,
        644.0,
        117.0
      ],
      "bbox_max": [
        1349.5,
        645.0,
        117.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        1312.5,
        620.0,
        98.0
      ],
      "bbox_max": [
        1326.5,
        628.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1312.5,
        620.0,
        102.0
      ],
      "bbox_max": [
        1326.5,
        628.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -628.0,
      "bbox_min": [
        1312.5,
        620.0,
        102.0
      ],
      "bbox_max": [
        1326.5,
        628.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1326.5,
      "bbox_min": [
        1312.5,
        620.0,
        102.0
      ],
      "bbox_max": [
        1326.5,
        628.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1312.5,
      "bbox_min": [
        1312.5,
        620.0,
        102.0
      ],
      "bbox_max": [
        1312.5,
        628.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 627.0,
      "bbox_min": [
        1315.362548828125,
        620.5,
        98.0
      ],
      "bbox_max": [
        1323.637451171875,
        627.5,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -627.5,
      "bbox_min": [
        1315.362548828125,
        627.0,
        98.0
      ],
      "bbox_max": [
        1323.637451171875,
        627.5,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.49998483061790466,
        0.0,
        0.8660341501235962
      ],
      "plane_d": -746.6699829101562,
      "bbox_min": [
        1315.362548828125,
        627.0,
        98.0
      ],
      "bbox_max": [
        1323.637451171875,
        627.5,
        102.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49998345971107483,
        0.0,
        0.8660349249839783
      ],
      "plane_d": 572.7881469726562,
      "bbox_min": [
        1315.362548828125,
        627.0,
        98.0
      ],
      "bbox_max": [
        1322.637451171875,
        627.5,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49998119473457336,
        0.0,
        -0.8660362362861633
      ],
      "plane_d": -573.284912109375,
      "bbox_min": [
        1316.362548828125,
        627.0,
        98.0
      ],
      "bbox_max": [
        1322.637451171875,
        627.5,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49998119473457336,
        0.0,
        -0.8660362362861633
      ],
      "plane_d": 746.1654052734375,
      "bbox_min": [
        1319.5,
        627.0,
        98.0
      ],
      "bbox_max": [
        1322.637451171875,
        627.5,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999942481517792,
        -0.0,
        -0.8660287261009216
      ],
      "plane_d": 746.181884765625,
      "bbox_min": [
        1315.708984375,
        627.0,
        100.09999084472656
      ],
      "bbox_max": [
        1319.0,
        627.5,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999867379665375,
        0.0,
        -0.8660330772399902
      ],
      "plane_d": -573.2926025390625,
      "bbox_min": [
        1319.5,
        627.0,
        100.0999984741211
      ],
      "bbox_max": [
        1323.291015625,
        627.5,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999847710132599,
        0.0,
        0.866034209728241
      ],
      "plane_d": 572.7899169921875,
      "bbox_min": [
        1319.5,
        627.0,
        100.388671875
      ],
      "bbox_max": [
        1322.291015625,
        627.5,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1315.362548828125,
        620.5,
        98.0
      ],
      "bbox_max": [
        1323.637451171875,
        621.0,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.49998483061790466,
        0.0,
        0.8660341501235962
      ],
      "plane_d": -746.6699829101562,
      "bbox_min": [
        1315.362548828125,
        620.5,
        98.0
      ],
      "bbox_max": [
        1323.637451171875,
        621.0,
        102.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49998345971107483,
        0.0,
        0.8660349249839783
      ],
      "plane_d": 572.7881469726562,
      "bbox_min": [
        1315.362548828125,
        620.5,
        98.0
      ],
      "bbox_max": [
        1322.637451171875,
        621.0,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49998119473457336,
        0.0,
        -0.8660362362861633
      ],
      "plane_d": -573.284912109375,
      "bbox_min": [
        1316.362548828125,
        620.5,
        98.0
      ],
      "bbox_max": [
        1322.637451171875,
        621.0,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49998119473457336,
        0.0,
        -0.8660362362861633
      ],
      "plane_d": 746.1654052734375,
      "bbox_min": [
        1319.5,
        620.5,
        98.0
      ],
      "bbox_max": [
        1322.637451171875,
        621.0,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999942481517792,
        -0.0,
        -0.8660287261009216
      ],
      "plane_d": 746.181884765625,
      "bbox_min": [
        1315.708984375,
        620.5,
        100.09999084472656
      ],
      "bbox_max": [
        1319.0,
        621.0,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999867379665375,
        0.0,
        -0.8660330772399902
      ],
      "plane_d": -573.2926025390625,
      "bbox_min": [
        1319.5,
        620.5,
        100.0999984741211
      ],
      "bbox_max": [
        1323.291015625,
        621.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999847710132599,
        0.0,
        0.866034209728241
      ],
      "plane_d": 572.7899169921875,
      "bbox_min": [
        1319.5,
        620.5,
        100.388671875
      ],
      "bbox_max": [
        1322.291015625,
        621.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1389.0,
      "bbox_min": [
        1349.5,
        620.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        670.0,
        118.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        1389.0,
        627.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        644.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": 499.2323913574219,
      "bbox_min": [
        1389.0,
        627.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        644.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -484.6549987792969,
      "bbox_min": [
        1389.0,
        627.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        644.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": 605.218505859375,
      "bbox_min": [
        1389.0,
        627.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        644.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -590.64111328125,
      "bbox_min": [
        1389.0,
        627.0,
        98.0
      ],
      "bbox_max": [
        1390.0,
        630.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 117.0,
      "bbox_min": [
        1349.5,
        644.0,
        98.0
      ],
      "bbox_max": [
        1389.0,
        670.0,
        118.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1350.5,
      "bbox_min": [
        1349.5,
        644.0,
        117.0
      ],
      "bbox_max": [
        1371.0,
        670.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 644.0,
      "bbox_min": [
        1349.5,
        644.0,
        117.0
      ],
      "bbox_max": [
        1350.5,
        644.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1371.0,
      "bbox_min": [
        1350.5,
        644.0,
        117.0
      ],
      "bbox_max": [
        1371.0,
        670.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        1350.5,
        644.0,
        117.0
      ],
      "bbox_max": [
        1371.0,
        670.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        -0.25881466269493103,
        0.0
      ],
      "plane_d": -1156.056396484375,
      "bbox_min": [
        1370.0,
        646.8038330078125,
        117.0
      ],
      "bbox_max": [
        1371.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070870995521545,
        -0.7071264386177063,
        0.0
      ],
      "plane_d": -511.3372497558594,
      "bbox_min": [
        1370.0,
        646.8038330078125,
        117.0
      ],
      "bbox_max": [
        1370.1961669921875,
        647.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 644.0,
      "bbox_min": [
        1350.5,
        644.0,
        117.0
      ],
      "bbox_max": [
        1370.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        1350.5,
        644.0,
        117.0
      ],
      "bbox_max": [
        1370.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588513493537903,
        -0.96591717004776,
        0.0
      ],
      "plane_d": 268.71856689453125,
      "bbox_min": [
        1365.0,
        644.0,
        117.0
      ],
      "bbox_max": [
        1368.196044921875,
        645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070870995521545,
        -0.7071264386177063,
        0.0
      ],
      "plane_d": -511.3372497558594,
      "bbox_min": [
        1368.0,
        644.803955078125,
        117.0
      ],
      "bbox_max": [
        1368.196044921875,
        645.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 510.4109191894531,
      "bbox_min": [
        1365.0,
        645.0,
        117.0
      ],
      "bbox_max": [
        1370.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070870995521545,
        -0.7071264386177063,
        0.0
      ],
      "plane_d": -511.3372497558594,
      "bbox_min": [
        1368.196044921875,
        645.0,
        117.0
      ],
      "bbox_max": [
        1370.0,
        646.8038330078125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659211039543152,
        0.25883665680885315,
        0.0
      ],
      "plane_d": 1155.068115234375,
      "bbox_min": [
        1365.0,
        645.0,
        117.0
      ],
      "bbox_max": [
        1370.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25883665680885315,
        0.9659211039543152,
        0.0
      ],
      "plane_d": -269.7070617675781,
      "bbox_min": [
        1365.0,
        645.0,
        117.0
      ],
      "bbox_max": [
        1367.5,
        645.669921875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        1350.5,
        645.0,
        98.0
      ],
      "bbox_max": [
        1389.0,
        670.0,
        117.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        1350.5,
        645.0,
        98.0
      ],
      "bbox_max": [
        1370.0,
        670.0,
        117.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659211039543152,
        -0.25883665680885315,
        0.0
      ],
      "plane_d": -1155.068115234375,
      "bbox_min": [
        1350.5,
        645.0,
        98.0
      ],
      "bbox_max": [
        1370.0,
        670.0,
        117.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25883665680885315,
        -0.9659211039543152,
        0.0
      ],
      "plane_d": 269.7070617675781,
      "bbox_min": [
        1350.5,
        645.0,
        98.0
      ],
      "bbox_max": [
        1370.0,
        670.0,
        117.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -510.4109191894531,
      "bbox_min": [
        1350.5,
        645.669921875,
        98.0
      ],
      "bbox_max": [
        1370.0,
        670.0,
        117.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1356.0,
      "bbox_min": [
        1350.5,
        654.0,
        98.0
      ],
      "bbox_max": [
        1370.0,
        670.0,
        109.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1356.0,
        654.0,
        98.0
      ],
      "bbox_max": [
        1370.0,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1364.0,
      "bbox_min": [
        1356.0,
        654.0,
        98.0
      ],
      "bbox_max": [
        1370.0,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 102.0,
      "bbox_min": [
        1356.0,
        654.0,
        98.0
      ],
      "bbox_max": [
        1364.0,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1356.0,
        654.0,
        102.0
      ],
      "bbox_max": [
        1364.0,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        1356.0,
        654.0,
        102.0
      ],
      "bbox_max": [
        1364.0,
        654.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1356.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1364.0,
        668.0,
        102.00003814697266
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1357.0,
      "bbox_min": [
        1356.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1363.5,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1356.5,
      "bbox_min": [
        1356.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1357.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 243.5499725341797,
      "bbox_min": [
        1356.5,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1357.0,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -417.42913818359375,
      "bbox_min": [
        1356.5,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1357.0,
        665.137451171875,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 416.92779541015625,
      "bbox_min": [
        1356.5,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1357.0,
        664.137451171875,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -244.04736328125,
      "bbox_min": [
        1356.5,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1357.0,
        661.0,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -244.0567169189453,
      "bbox_min": [
        1356.5,
        661.5,
        100.09999084472656
      ],
      "bbox_max": [
        1357.0,
        664.791015625,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 416.93115234375,
      "bbox_min": [
        1356.5,
        657.208984375,
        100.0999984741211
      ],
      "bbox_max": [
        1357.0,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -417.4299621582031,
      "bbox_min": [
        1356.5,
        658.208984375,
        100.388671875
      ],
      "bbox_max": [
        1357.0,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1363.5,
      "bbox_min": [
        1363.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1363.5,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1363.0,
      "bbox_min": [
        1363.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1363.5,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.49998483061790466,
        0.8660341501235962
      ],
      "plane_d": 243.5499725341797,
      "bbox_min": [
        1363.0,
        656.862548828125,
        98.0
      ],
      "bbox_max": [
        1363.5,
        665.137451171875,
        102.00003814697266
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998345971107483,
        0.8660349249839783
      ],
      "plane_d": -417.42913818359375,
      "bbox_min": [
        1363.0,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1363.5,
        665.137451171875,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": 416.92779541015625,
      "bbox_min": [
        1363.0,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1363.5,
        664.137451171875,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49998119473457336,
        -0.8660362362861633
      ],
      "plane_d": -244.04736328125,
      "bbox_min": [
        1363.0,
        657.862548828125,
        98.0
      ],
      "bbox_max": [
        1363.5,
        661.0,
        99.81131744384766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999942481517792,
        -0.8660287261009216
      ],
      "plane_d": -244.0567169189453,
      "bbox_min": [
        1363.0,
        661.5,
        100.09999084472656
      ],
      "bbox_max": [
        1363.5,
        664.791015625,
        102.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999867379665375,
        -0.8660330772399902
      ],
      "plane_d": 416.93115234375,
      "bbox_min": [
        1363.0,
        657.208984375,
        100.0999984741211
      ],
      "bbox_max": [
        1363.5,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -417.4299621582031,
      "bbox_min": [
        1363.0,
        658.208984375,
        100.388671875
      ],
      "bbox_max": [
        1363.5,
        661.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1364.0,
        666.0,
        98.0
      ],
      "bbox_max": [
        1370.0,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1364.0,
        666.0,
        98.0
      ],
      "bbox_max": [
        1366.0,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1366.0,
      "bbox_min": [
        1366.0,
        666.0,
        98.0
      ],
      "bbox_max": [
        1366.0,
        668.0,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        1356.0,
        666.0,
        103.0
      ],
      "bbox_max": [
        1370.0,
        670.0,
        108.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1356.0,
        666.0,
        103.0
      ],
      "bbox_max": [
        1370.0,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 205.71826171875,
      "bbox_min": [
        1366.0,
        666.0,
        103.0
      ],
      "bbox_max": [
        1370.0,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1366.0,
      "bbox_min": [
        1366.0,
        666.0,
        103.0
      ],
      "bbox_max": [
        1366.0,
        668.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1356.0,
        669.0,
        106.0
      ],
      "bbox_max": [
        1364.0,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1364.0,
      "bbox_min": [
        1364.0,
        669.0,
        106.0
      ],
      "bbox_max": [
        1364.0,
        670.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 665.5,
      "bbox_min": [
        1350.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -668.0,
      "bbox_min": [
        1350.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.5,
      "bbox_min": [
        1350.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        0.49991968274116516,
        0.0
      ],
      "plane_d": -1506.8486328125,
      "bbox_min": [
        1350.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        -0.49991968274116516,
        0.0
      ],
      "plane_d": -840.2057495117188,
      "bbox_min": [
        1350.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1351.5,
      "bbox_min": [
        1350.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -109.0,
      "bbox_min": [
        1351.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1352.0,
      "bbox_min": [
        1351.5,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        109.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1351.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1352.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1351.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1352.0,
        668.0,
        109.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1351.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1352.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 209.5195770263672,
      "bbox_min": [
        1351.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1352.0,
        666.5,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        1352.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        108.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -108.25,
      "bbox_min": [
        1352.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1354.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1352.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1354.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1352.0,
        666.5,
        108.0
      ],
      "bbox_max": [
        1354.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1354.5,
      "bbox_min": [
        1354.5,
        666.5,
        108.0
      ],
      "bbox_max": [
        1354.5,
        667.0,
        108.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1353.0,
      "bbox_min": [
        1352.0,
        665.5,
        98.0
      ],
      "bbox_max": [
        1355.0,
        668.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": -693.1810302734375,
      "bbox_min": [
        1352.0,
        665.5,
        98.5
      ],
      "bbox_max": [
        1353.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1352.0,
        667.0,
        98.5
      ],
      "bbox_max": [
        1353.0,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.18310546875,
      "bbox_min": [
        1354.0,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1355.0,
        667.18310546875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 666.31689453125,
      "bbox_min": [
        1354.0,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1355.0,
        667.18310546875,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1354.0,
        666.31689453125,
        106.0
      ],
      "bbox_max": [
        1355.0,
        667.18310546875,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": 515.8609008789062,
      "bbox_min": [
        1350.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1351.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 209.5195770263672,
      "bbox_min": [
        1350.5,
        665.5,
        98.5
      ],
      "bbox_max": [
        1351.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -386.83978271484375,
      "bbox_min": [
        1350.5,
        667.0,
        98.5
      ],
      "bbox_max": [
        1351.5,
        668.0,
        99.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.0,
      "bbox_min": [
        1370.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1389.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1385.0,
      "bbox_min": [
        1370.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1389.0,
        669.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547001957893372,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 683.390625,
      "bbox_min": [
        1385.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1389.0,
        666.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1385.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1389.0,
        650.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48507124185562134,
        -0.48507124185562134,
        0.7276068925857544
      ],
      "plane_d": 919.2099609375,
      "bbox_min": [
        1385.0,
        663.0,
        102.0
      ],
      "bbox_max": [
        1388.0,
        666.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320503234863281
      ],
      "plane_d": 284.5611877441406,
      "bbox_min": [
        1370.0,
        666.0,
        102.0
      ],
      "bbox_max": [
        1385.0,
        669.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48507124185562134,
        -0.48507124185562134,
        0.7276068925857544
      ],
      "plane_d": 919.2099609375,
      "bbox_min": [
        1382.0,
        666.0,
        102.0
      ],
      "bbox_max": [
        1385.0,
        669.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48507124185562134,
        -0.48507124185562134,
        0.7276068925857544
      ],
      "plane_d": 919.2099609375,
      "bbox_min": [
        1382.0,
        663.0,
        102.0
      ],
      "bbox_max": [
        1385.0,
        666.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1370.0,
        650.0,
        106.0
      ],
      "bbox_max": [
        1389.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 106.0,
      "bbox_min": [
        1370.0,
        650.0,
        106.0
      ],
      "bbox_max": [
        1389.0,
        670.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1388.5,
      "bbox_min": [
        1370.0,
        650.0,
        106.0
      ],
      "bbox_max": [
        1389.0,
        670.0,
        110.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1388.5,
        650.0,
        106.0
      ],
      "bbox_max": [
        1389.0,
        664.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -664.0,
      "bbox_min": [
        1388.5,
        664.0,
        106.0
      ],
      "bbox_max": [
        1389.0,
        664.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.5,
      "bbox_min": [
        1370.0,
        669.5,
        106.0
      ],
      "bbox_max": [
        1384.0,
        670.0,
        110.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1384.0,
      "bbox_min": [
        1384.0,
        669.5,
        106.0
      ],
      "bbox_max": [
        1384.0,
        670.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660250306129456,
        -0.0,
        -0.5000005960464478
      ],
      "plane_d": 1257.948974609375,
      "bbox_min": [
        1370.0,
        650.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 655.0,
      "bbox_min": [
        1386.40087890625,
        650.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        664.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        1386.40087890625,
        655.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        664.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999901354312897,
        0.0,
        0.8660311102867126
      ],
      "plane_d": 593.9552001953125,
      "bbox_min": [
        1386.40087890625,
        660.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        664.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -664.0,
      "bbox_min": [
        1386.40087890625,
        660.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        664.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999040365219116,
        0.0,
        -0.8660309314727783
      ],
      "plane_d": -597.95556640625,
      "bbox_min": [
        1388.40087890625,
        660.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        664.0,
        111.4638442993164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999901354312897,
        0.0,
        0.8660311102867126
      ],
      "plane_d": 593.9552001953125,
      "bbox_min": [
        1386.40087890625,
        655.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        659.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -659.0,
      "bbox_min": [
        1386.40087890625,
        655.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        659.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999040365219116,
        0.0,
        -0.8660309314727783
      ],
      "plane_d": -597.95556640625,
      "bbox_min": [
        1388.40087890625,
        655.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        659.0,
        111.4638442993164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4999901354312897,
        0.0,
        0.8660311102867126
      ],
      "plane_d": 593.9552001953125,
      "bbox_min": [
        1386.40087890625,
        650.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        654.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1386.40087890625,
        650.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        654.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -654.0,
      "bbox_min": [
        1386.40087890625,
        650.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        654.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999040365219116,
        0.0,
        -0.8660309314727783
      ],
      "plane_d": -597.95556640625,
      "bbox_min": [
        1388.40087890625,
        650.0,
        111.11795043945312
      ],
      "bbox_max": [
        1389.0,
        654.0,
        111.4638442993164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8660250306129456,
        -0.5000005960464478
      ],
      "plane_d": 635.2769165039062,
      "bbox_min": [
        1370.0,
        667.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1384.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1379.0,
      "bbox_min": [
        1370.0,
        667.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1384.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999901354312897,
        0.8660311102867126
      ],
      "plane_d": 234.46221923828125,
      "bbox_min": [
        1370.0,
        667.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1379.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1374.0,
      "bbox_min": [
        1370.0,
        667.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1379.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49999040365219116,
        -0.8660309314727783
      ],
      "plane_d": -238.4624481201172,
      "bbox_min": [
        1370.0,
        669.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1374.0,
        670.0,
        111.4638442993164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1375.0,
      "bbox_min": [
        1375.0,
        667.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1379.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49999040365219116,
        -0.8660309314727783
      ],
      "plane_d": -238.4624481201172,
      "bbox_min": [
        1375.0,
        669.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1379.0,
        670.0,
        111.4638442993164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999901354312897,
        0.8660311102867126
      ],
      "plane_d": 234.46221923828125,
      "bbox_min": [
        1380.0,
        667.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1384.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1384.0,
      "bbox_min": [
        1380.0,
        667.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1384.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        1380.0,
        667.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1384.0,
        670.0,
        116.08204650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49999040365219116,
        -0.8660309314727783
      ],
      "plane_d": -238.4624481201172,
      "bbox_min": [
        1380.0,
        669.40087890625,
        111.11795043945312
      ],
      "bbox_max": [
        1384.0,
        670.0,
        111.4638442993164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1290.0,
        538.75,
        80.0
      ],
      "bbox_max": [
        1390.0,
        670.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1285.5201416015625,
      "bbox_min": [
        1390.0,
        510.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        1390.0,
        589.784423828125,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        338.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        1390.0,
        590.0,
        331.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        338.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        1390.0,
        590.0,
        331.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1410.0,
        590.0,
        331.0
      ],
      "bbox_max": [
        1480.0,
        625.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        600.0,
        335.0
      ],
      "bbox_max": [
        1410.0,
        625.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        1410.0,
        590.0,
        331.0
      ],
      "bbox_max": [
        1480.0,
        600.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        590.0,
        331.0
      ],
      "bbox_max": [
        1410.0,
        600.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1390.0,
        625.0,
        331.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1390.0,
        650.0,
        331.0
      ],
      "bbox_max": [
        1390.0,
        670.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        625.0,
        331.0
      ],
      "bbox_max": [
        1410.0,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        1390.0,
        589.784423828125,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        1418.5118408203125,
        589.784423828125,
        318.70654296875
      ],
      "bbox_max": [
        1471.4881591796875,
        590.0,
        320.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8542529940605164,
        -0.49317699670791626,
        -0.16440272331237793
      ],
      "plane_d": -870.3855590820312,
      "bbox_min": [
        1418.5118408203125,
        589.784423828125,
        318.70654296875
      ],
      "bbox_max": [
        1471.4881591796875,
        590.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.854218065738678,
        -0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": 1555.337890625,
      "bbox_min": [
        1418.5118408203125,
        589.784423828125,
        318.70654296875
      ],
      "bbox_max": [
        1418.7608642578125,
        590.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542450070381165,
        -0.49318787455558777,
        -0.16441157460212708
      ],
      "plane_d": 1598.403076171875,
      "bbox_min": [
        1468.9117431640625,
        589.784423828125,
        318.70654296875
      ],
      "bbox_max": [
        1471.4881591796875,
        590.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": -913.422607421875,
      "bbox_min": [
        1471.2391357421875,
        589.784423828125,
        318.70654296875
      ],
      "bbox_max": [
        1471.4881591796875,
        590.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        1390.0,
        590.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1390.0,
        645.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1390.0,
        650.0,
        317.0
      ],
      "bbox_max": [
        1390.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1444.5,
      "bbox_min": [
        1410.0,
        645.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        1444.5,
        645.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1445.5,
      "bbox_min": [
        1445.5,
        645.0,
        330.0
      ],
      "bbox_max": [
        1445.5,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1474.5,
      "bbox_min": [
        1451.5,
        654.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        670.0,
        328.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1466.5,
      "bbox_min": [
        1451.5,
        654.0,
        317.0
      ],
      "bbox_max": [
        1474.5,
        670.0,
        328.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 321.0,
      "bbox_min": [
        1466.5,
        654.0,
        317.0
      ],
      "bbox_max": [
        1474.5,
        670.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -322.0,
      "bbox_min": [
        1466.5,
        654.0,
        321.0
      ],
      "bbox_max": [
        1474.5,
        670.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1466.5,
        654.0,
        321.0
      ],
      "bbox_max": [
        1474.5,
        668.0,
        322.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        1466.5,
        654.0,
        321.0
      ],
      "bbox_max": [
        1474.5,
        654.0,
        322.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -323.0,
      "bbox_min": [
        1466.5,
        668.0,
        322.0
      ],
      "bbox_max": [
        1474.5,
        670.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1466.5,
        668.0,
        322.0
      ],
      "bbox_max": [
        1474.5,
        668.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        1466.5,
        669.0,
        325.0
      ],
      "bbox_max": [
        1474.5,
        670.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1466.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1474.5,
        668.0,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1467.5,
      "bbox_min": [
        1467.0,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1474.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1467.0,
      "bbox_min": [
        1467.0,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1467.5,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.4999862015247345,
        0.8660333752632141
      ],
      "plane_d": 53.889617919921875,
      "bbox_min": [
        1467.0,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1467.5,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998074769973755,
        0.8660365343093872
      ],
      "plane_d": -607.0894775390625,
      "bbox_min": [
        1467.0,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1467.5,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4999796152114868,
        -0.8660371899604797
      ],
      "plane_d": 606.5889892578125,
      "bbox_min": [
        1467.0,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1467.5,
        664.137451171875,
        318.8113098144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999796152114868,
        -0.8660371899604797
      ],
      "plane_d": -54.384063720703125,
      "bbox_min": [
        1467.0,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1467.5,
        661.0,
        318.8113098144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49999725818634033,
        -0.8660269975662231
      ],
      "plane_d": -54.399017333984375,
      "bbox_min": [
        1467.0,
        661.5,
        319.0999755859375
      ],
      "bbox_max": [
        1467.5,
        664.791015625,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999852180480957,
        -0.8660339117050171
      ],
      "plane_d": 606.5916748046875,
      "bbox_min": [
        1467.0,
        657.208984375,
        319.1000061035156
      ],
      "bbox_max": [
        1467.5,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -607.0914306640625,
      "bbox_min": [
        1467.0,
        658.208984375,
        319.388671875
      ],
      "bbox_max": [
        1467.5,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1474.0,
      "bbox_min": [
        1473.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1474.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1473.5,
      "bbox_min": [
        1473.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1474.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.4999862015247345,
        0.8660333752632141
      ],
      "plane_d": 53.889617919921875,
      "bbox_min": [
        1473.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1474.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998074769973755,
        0.8660365343093872
      ],
      "plane_d": -607.0894775390625,
      "bbox_min": [
        1473.5,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1474.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4999796152114868,
        -0.8660371899604797
      ],
      "plane_d": 606.5889892578125,
      "bbox_min": [
        1473.5,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1474.0,
        664.137451171875,
        318.8113098144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999796152114868,
        -0.8660371899604797
      ],
      "plane_d": -54.384063720703125,
      "bbox_min": [
        1473.5,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1474.0,
        661.0,
        318.8113098144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49999725818634033,
        -0.8660269975662231
      ],
      "plane_d": -54.399017333984375,
      "bbox_min": [
        1473.5,
        661.5,
        319.0999755859375
      ],
      "bbox_max": [
        1474.0,
        664.791015625,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999852180480957,
        -0.8660339117050171
      ],
      "plane_d": 606.5916748046875,
      "bbox_min": [
        1473.5,
        657.208984375,
        319.1000061035156
      ],
      "bbox_max": [
        1474.0,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -607.0914306640625,
      "bbox_min": [
        1473.5,
        658.208984375,
        319.388671875
      ],
      "bbox_max": [
        1474.0,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1458.5,
      "bbox_min": [
        1451.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1451.5,
      "bbox_min": [
        1451.5,
        669.5,
        320.5
      ],
      "bbox_max": [
        1458.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.5,
      "bbox_min": [
        1451.5,
        669.5,
        320.5
      ],
      "bbox_max": [
        1458.5,
        670.0,
        328.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.5,
      "bbox_min": [
        1451.5,
        669.5,
        320.5
      ],
      "bbox_max": [
        1458.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        1451.5,
        669.5,
        321.0
      ],
      "bbox_max": [
        1458.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1458.0,
      "bbox_min": [
        1452.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1458.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1452.0,
      "bbox_min": [
        1452.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1458.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -321.0,
      "bbox_min": [
        1452.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1458.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 328.0,
      "bbox_min": [
        1452.0,
        669.5,
        328.0
      ],
      "bbox_max": [
        1458.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1460.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1460.5,
      "bbox_min": [
        1460.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1460.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -323.0,
      "bbox_min": [
        1460.5,
        668.0,
        323.0
      ],
      "bbox_max": [
        1466.5,
        670.0,
        323.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1464.5,
      "bbox_min": [
        1460.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1464.5,
        668.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 9.83868408203125,
      "bbox_min": [
        1460.5,
        666.0,
        322.0
      ],
      "bbox_max": [
        1464.5,
        668.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 665.5,
      "bbox_min": [
        1475.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1480.0,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660717606544495,
        0.49991968274116516,
        0.0
      ],
      "plane_d": 944.5675048828125,
      "bbox_min": [
        1475.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1480.0,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660717606544495,
        -0.49991968274116516,
        0.0
      ],
      "plane_d": 1611.210205078125,
      "bbox_min": [
        1475.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1480.0,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1479.0,
      "bbox_min": [
        1475.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1480.0,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -328.0,
      "bbox_min": [
        1475.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1479.0,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1478.5,
      "bbox_min": [
        1475.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1479.0,
        668.0,
        328.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1478.5,
        665.5,
        317.5
      ],
      "bbox_max": [
        1479.0,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1478.5,
        667.0,
        317.5
      ],
      "bbox_max": [
        1479.0,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -582.7193603515625,
      "bbox_min": [
        1478.5,
        667.0,
        317.5
      ],
      "bbox_max": [
        1479.0,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 13.6400146484375,
      "bbox_min": [
        1478.5,
        665.5,
        317.5
      ],
      "bbox_max": [
        1479.0,
        666.5,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        1475.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1478.5,
        668.0,
        327.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -327.25,
      "bbox_min": [
        1476.0,
        666.5,
        327.0
      ],
      "bbox_max": [
        1478.5,
        667.0,
        327.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1476.0,
        666.5,
        327.0
      ],
      "bbox_max": [
        1478.5,
        667.0,
        327.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1476.0,
        666.5,
        327.0
      ],
      "bbox_max": [
        1478.5,
        667.0,
        327.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1476.0,
      "bbox_min": [
        1476.0,
        666.5,
        327.0
      ],
      "bbox_max": [
        1476.0,
        667.0,
        327.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1477.5,
      "bbox_min": [
        1475.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1478.5,
        668.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": 376.7774658203125,
      "bbox_min": [
        1477.5,
        665.5,
        317.5
      ],
      "bbox_max": [
        1478.5,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -582.7193603515625,
      "bbox_min": [
        1477.5,
        667.0,
        317.5
      ],
      "bbox_max": [
        1478.5,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.18310546875,
      "bbox_min": [
        1475.5,
        666.31689453125,
        325.0
      ],
      "bbox_max": [
        1476.5,
        667.18310546875,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.31689453125,
      "bbox_min": [
        1475.5,
        666.31689453125,
        325.0
      ],
      "bbox_max": [
        1476.5,
        667.18310546875,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        1475.5,
        666.31689453125,
        325.0
      ],
      "bbox_max": [
        1476.5,
        667.18310546875,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": -945.8567504882812,
      "bbox_min": [
        1479.0,
        665.5,
        317.5
      ],
      "bbox_max": [
        1480.0,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -582.7193603515625,
      "bbox_min": [
        1479.0,
        667.0,
        317.5
      ],
      "bbox_max": [
        1480.0,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1415.5,
      "bbox_min": [
        1410.0,
        654.0,
        317.0
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1423.5,
      "bbox_min": [
        1415.5,
        654.0,
        317.0
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 321.0,
      "bbox_min": [
        1415.5,
        654.0,
        317.0
      ],
      "bbox_max": [
        1423.5,
        670.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -322.0,
      "bbox_min": [
        1415.5,
        654.0,
        321.0
      ],
      "bbox_max": [
        1423.5,
        670.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1415.5,
        654.0,
        321.0
      ],
      "bbox_max": [
        1423.5,
        668.0,
        322.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 654.0,
      "bbox_min": [
        1415.5,
        654.0,
        321.0
      ],
      "bbox_max": [
        1423.5,
        654.0,
        322.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -323.0,
      "bbox_min": [
        1415.5,
        668.0,
        322.0
      ],
      "bbox_max": [
        1423.5,
        670.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1415.5,
        668.0,
        322.0
      ],
      "bbox_max": [
        1423.5,
        668.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -327.0,
      "bbox_min": [
        1415.5,
        669.0,
        327.0
      ],
      "bbox_max": [
        1423.5,
        670.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1415.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.5,
        668.0,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1416.5,
      "bbox_min": [
        1416.0,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1416.0,
      "bbox_min": [
        1416.0,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1416.5,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.4999862015247345,
        0.8660333752632141
      ],
      "plane_d": 53.889617919921875,
      "bbox_min": [
        1416.0,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1416.5,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998074769973755,
        0.8660365343093872
      ],
      "plane_d": -607.0894775390625,
      "bbox_min": [
        1416.0,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1416.5,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4999796152114868,
        -0.8660371899604797
      ],
      "plane_d": 606.5889892578125,
      "bbox_min": [
        1416.0,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1416.5,
        664.137451171875,
        318.8113098144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999796152114868,
        -0.8660371899604797
      ],
      "plane_d": -54.384063720703125,
      "bbox_min": [
        1416.0,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1416.5,
        661.0,
        318.8113098144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49999725818634033,
        -0.8660269975662231
      ],
      "plane_d": -54.399017333984375,
      "bbox_min": [
        1416.0,
        661.5,
        319.0999755859375
      ],
      "bbox_max": [
        1416.5,
        664.791015625,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999852180480957,
        -0.8660339117050171
      ],
      "plane_d": 606.5916748046875,
      "bbox_min": [
        1416.0,
        657.208984375,
        319.1000061035156
      ],
      "bbox_max": [
        1416.5,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -607.0914306640625,
      "bbox_min": [
        1416.0,
        658.208984375,
        319.388671875
      ],
      "bbox_max": [
        1416.5,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1423.0,
      "bbox_min": [
        1422.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1422.5,
      "bbox_min": [
        1422.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.4999862015247345,
        0.8660333752632141
      ],
      "plane_d": 53.889617919921875,
      "bbox_min": [
        1422.5,
        656.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.49998074769973755,
        0.8660365343093872
      ],
      "plane_d": -607.0894775390625,
      "bbox_min": [
        1422.5,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.0,
        665.137451171875,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4999796152114868,
        -0.8660371899604797
      ],
      "plane_d": 606.5889892578125,
      "bbox_min": [
        1422.5,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.0,
        664.137451171875,
        318.8113098144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999796152114868,
        -0.8660371899604797
      ],
      "plane_d": -54.384063720703125,
      "bbox_min": [
        1422.5,
        657.862548828125,
        317.0
      ],
      "bbox_max": [
        1423.0,
        661.0,
        318.8113098144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49999725818634033,
        -0.8660269975662231
      ],
      "plane_d": -54.399017333984375,
      "bbox_min": [
        1422.5,
        661.5,
        319.0999755859375
      ],
      "bbox_max": [
        1423.0,
        664.791015625,
        321.0000305175781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4999852180480957,
        -0.8660339117050171
      ],
      "plane_d": 606.5916748046875,
      "bbox_min": [
        1422.5,
        657.208984375,
        319.1000061035156
      ],
      "bbox_max": [
        1423.0,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4999847710132599,
        0.866034209728241
      ],
      "plane_d": -607.0914306640625,
      "bbox_min": [
        1422.5,
        658.208984375,
        319.388671875
      ],
      "bbox_max": [
        1423.0,
        661.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1431.5,
      "bbox_min": [
        1423.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1438.5,
      "bbox_min": [
        1431.5,
        669.5,
        320.5
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.5,
      "bbox_min": [
        1431.5,
        669.5,
        320.5
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 320.5,
      "bbox_min": [
        1431.5,
        669.5,
        320.5
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -328.5,
      "bbox_min": [
        1431.5,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.5,
        670.0,
        328.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1438.0,
      "bbox_min": [
        1432.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1432.0,
      "bbox_min": [
        1432.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 328.0,
      "bbox_min": [
        1432.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.0,
        670.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -321.0,
      "bbox_min": [
        1432.0,
        669.5,
        321.0
      ],
      "bbox_max": [
        1438.0,
        670.0,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.0,
      "bbox_min": [
        1423.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1429.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1429.5,
      "bbox_min": [
        1423.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1429.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 668.0,
      "bbox_min": [
        1423.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1429.5,
        670.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -323.0,
      "bbox_min": [
        1423.5,
        668.0,
        323.0
      ],
      "bbox_max": [
        1429.5,
        670.0,
        323.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1425.5,
      "bbox_min": [
        1425.5,
        666.0,
        317.0
      ],
      "bbox_max": [
        1429.5,
        668.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 9.83868408203125,
      "bbox_min": [
        1425.5,
        666.0,
        322.0
      ],
      "bbox_max": [
        1429.5,
        668.0,
        323.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 665.5,
      "bbox_min": [
        1410.0,
        665.5,
        317.0
      ],
      "bbox_max": [
        1414.5,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        -0.49991968274116516,
        0.0
      ],
      "plane_d": -891.7371215820312,
      "bbox_min": [
        1410.0,
        665.5,
        317.0
      ],
      "bbox_max": [
        1414.5,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660717606544495,
        0.49991968274116516,
        0.0
      ],
      "plane_d": -1558.3798828125,
      "bbox_min": [
        1410.0,
        665.5,
        317.0
      ],
      "bbox_max": [
        1414.5,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1411.0,
      "bbox_min": [
        1410.0,
        665.5,
        317.0
      ],
      "bbox_max": [
        1414.5,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -328.0,
      "bbox_min": [
        1411.0,
        665.5,
        317.0
      ],
      "bbox_max": [
        1414.5,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1411.5,
      "bbox_min": [
        1411.0,
        665.5,
        317.0
      ],
      "bbox_max": [
        1414.5,
        668.0,
        328.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1411.0,
        665.5,
        317.5
      ],
      "bbox_max": [
        1411.5,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1411.0,
        667.0,
        317.5
      ],
      "bbox_max": [
        1411.5,
        668.0,
        328.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -582.7193603515625,
      "bbox_min": [
        1411.0,
        667.0,
        317.5
      ],
      "bbox_max": [
        1411.5,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 13.6400146484375,
      "bbox_min": [
        1411.0,
        665.5,
        317.5
      ],
      "bbox_max": [
        1411.5,
        666.5,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 327.0,
      "bbox_min": [
        1411.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1414.5,
        668.0,
        327.25
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -327.25,
      "bbox_min": [
        1411.5,
        666.5,
        327.0
      ],
      "bbox_max": [
        1414.0,
        667.0,
        327.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 666.5,
      "bbox_min": [
        1411.5,
        666.5,
        327.0
      ],
      "bbox_max": [
        1414.0,
        667.0,
        327.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.0,
      "bbox_min": [
        1411.5,
        666.5,
        327.0
      ],
      "bbox_max": [
        1414.0,
        667.0,
        327.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1414.0,
      "bbox_min": [
        1414.0,
        666.5,
        327.0
      ],
      "bbox_max": [
        1414.0,
        667.0,
        327.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1412.5,
      "bbox_min": [
        1411.5,
        665.5,
        317.0
      ],
      "bbox_max": [
        1414.5,
        668.0,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": -915.6698608398438,
      "bbox_min": [
        1411.5,
        665.5,
        317.5
      ],
      "bbox_max": [
        1412.5,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -582.7193603515625,
      "bbox_min": [
        1411.5,
        667.0,
        317.5
      ],
      "bbox_max": [
        1412.5,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 666.31689453125,
      "bbox_min": [
        1413.5,
        666.31689453125,
        325.0
      ],
      "bbox_max": [
        1414.5,
        667.18310546875,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -667.18310546875,
      "bbox_min": [
        1413.5,
        666.31689453125,
        325.0
      ],
      "bbox_max": [
        1414.5,
        667.18310546875,
        327.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 325.0,
      "bbox_min": [
        1413.5,
        666.31689453125,
        325.0
      ],
      "bbox_max": [
        1414.5,
        667.18310546875,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        0.8944271802902222
      ],
      "plane_d": 346.59051513671875,
      "bbox_min": [
        1410.0,
        665.5,
        317.5
      ],
      "bbox_max": [
        1411.0,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": 13.6400146484375,
      "bbox_min": [
        1410.0,
        665.5,
        317.5
      ],
      "bbox_max": [
        1411.0,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.4472135901451111,
        0.8944271802902222
      ],
      "plane_d": -582.7193603515625,
      "bbox_min": [
        1410.0,
        667.0,
        317.5
      ],
      "bbox_max": [
        1411.0,
        668.0,
        318.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 644.0,
      "bbox_min": [
        1410.0,
        590.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        645.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 330.0,
      "bbox_min": [
        1410.0,
        644.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        645.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        644.0,
        330.0
      ],
      "bbox_max": [
        1410.0,
        645.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        644.0,
        317.0
      ],
      "bbox_max": [
        1410.0,
        645.0,
        330.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1410.0,
        590.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        644.0,
        331.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -637.0,
      "bbox_min": [
        1410.0,
        590.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        637.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        -0.5812382102012634
      ],
      "plane_d": 705.0419311523438,
      "bbox_min": [
        1410.0,
        590.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        637.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        1440.0,
        630.0,
        321.2000427246094
      ],
      "bbox_max": [
        1450.0,
        637.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1450.0,
        630.0,
        321.2000427246094
      ],
      "bbox_max": [
        1450.0,
        637.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 328.39959716796875,
      "bbox_min": [
        1410.0,
        590.0,
        317.0
      ],
      "bbox_max": [
        1480.0,
        637.0,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1440.0,
      "bbox_min": [
        1440.0,
        630.0,
        317.0
      ],
      "bbox_max": [
        1450.0,
        637.0,
        324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1450.0,
        630.0,
        317.0
      ],
      "bbox_max": [
        1450.0,
        637.0,
        324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -320.0,
      "bbox_min": [
        1417.47265625,
        590.0,
        317.0
      ],
      "bbox_max": [
        1472.52734375,
        593.8154296875,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.854218065738678,
        0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": -1454.0941162109375,
      "bbox_min": [
        1417.47265625,
        590.0,
        317.0
      ],
      "bbox_max": [
        1472.52734375,
        593.8154296875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -533.1282348632812,
      "bbox_min": [
        1417.47265625,
        590.0,
        317.0
      ],
      "bbox_max": [
        1422.12744140625,
        593.8154296875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542530536651611,
        0.49317699670791626,
        -0.16440273821353912
      ],
      "plane_d": 971.6271362304688,
      "bbox_min": [
        1417.47265625,
        590.0,
        317.0
      ],
      "bbox_max": [
        1422.12744140625,
        593.8154296875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542529940605164,
        -0.49317699670791626,
        -0.16440272331237793
      ],
      "plane_d": -870.3855590820312,
      "bbox_min": [
        1417.47265625,
        590.0,
        317.0
      ],
      "bbox_max": [
        1422.12744140625,
        591.800048828125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.854218065738678,
        -0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": 1555.337890625,
      "bbox_min": [
        1417.47265625,
        590.0,
        317.0
      ],
      "bbox_max": [
        1418.925048828125,
        591.800048828125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -533.1282348632812,
      "bbox_min": [
        1467.87255859375,
        590.0,
        317.0
      ],
      "bbox_max": [
        1472.52734375,
        593.8154296875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -1497.1473388671875,
      "bbox_min": [
        1467.87255859375,
        590.0,
        317.0
      ],
      "bbox_max": [
        1472.52734375,
        593.8154296875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542195558547974,
        0.4932328760623932,
        -0.1644088178873062
      ],
      "plane_d": 1014.6010131835938,
      "bbox_min": [
        1467.87255859375,
        590.0,
        317.0
      ],
      "bbox_max": [
        1472.52734375,
        593.8154296875,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542450070381165,
        -0.49318787455558777,
        -0.16441157460212708
      ],
      "plane_d": 1598.403076171875,
      "bbox_min": [
        1467.87255859375,
        590.0,
        317.0
      ],
      "bbox_max": [
        1472.52734375,
        591.800048828125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542461395263672,
        -0.4931885004043579,
        -0.1644039750099182
      ],
      "plane_d": -913.422607421875,
      "bbox_min": [
        1471.074951171875,
        590.0,
        317.0
      ],
      "bbox_max": [
        1472.52734375,
        591.800048828125,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": -585.5424194335938,
      "bbox_min": [
        1418.12060546875,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1471.87939453125,
        593.53955078125,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -1422.45849609375,
      "bbox_min": [
        1418.12060546875,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1421.5853271484375,
        593.53955078125,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5078153610229492,
        -0.010555907152593136,
        0.8614012002944946
      ],
      "plane_d": 450.7603759765625,
      "bbox_min": [
        1418.12060546875,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1419.8529052734375,
        593.53955078125,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.489622978416264e-09,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -573.8651123046875,
      "bbox_min": [
        1418.12060546875,
        591.80712890625,
        320.0
      ],
      "bbox_max": [
        1421.5853271484375,
        593.53955078125,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -1422.45849609375,
      "bbox_min": [
        1418.191162109375,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1471.87939453125,
        593.53955078125,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 30.051727294921875,
      "bbox_min": [
        1418.191162109375,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1421.5146484375,
        591.80712890625,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": -991.2589111328125,
      "bbox_min": [
        1419.8529052734375,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1471.87939453125,
        593.53955078125,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        -0.7070940732955933,
        -0.0
      ],
      "plane_d": 1458.032958984375,
      "bbox_min": [
        1468.4146728515625,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1471.87939453125,
        593.53955078125,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -621.080078125,
      "bbox_min": [
        1468.4146728515625,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1471.87939453125,
        593.53955078125,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -573.8651123046875,
      "bbox_min": [
        1468.4146728515625,
        591.80712890625,
        320.0
      ],
      "bbox_max": [
        1471.87939453125,
        593.53955078125,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -1016.8260498046875,
      "bbox_min": [
        1470.1470947265625,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1471.87939453125,
        593.53955078125,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -621.080078125,
      "bbox_min": [
        1468.4146728515625,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1471.808837890625,
        593.53955078125,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": 476.2905578613281,
      "bbox_min": [
        1468.4146728515625,
        590.1455078125,
        320.0
      ],
      "bbox_max": [
        1470.1470947265625,
        593.53955078125,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 30.16119384765625,
      "bbox_min": [
        1468.4853515625,
        590.145263671875,
        320.0
      ],
      "bbox_max": [
        1471.808837890625,
        591.80712890625,
        321.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1480.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        338.0
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1480.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1480.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1480.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        98.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1480.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        98.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        98.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 628.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        98.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        1515.0,
        628.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": 1410.9588623046875,
      "bbox_min": [
        1515.0,
        628.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 1334.9324951171875,
      "bbox_min": [
        1515.0,
        628.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -1393.0703125,
      "bbox_min": [
        1515.0,
        628.0,
        80.0
      ],
      "bbox_max": [
        1517.5,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1317.0439453125,
      "bbox_min": [
        1515.0,
        628.0,
        85.0
      ],
      "bbox_max": [
        1517.5,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -91.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.5,
        621.0,
        96.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -621.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.5,
        621.0,
        91.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1480.5,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.5,
        621.0,
        91.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1480.5,
        620.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        1480.0,
        610.0,
        90.0
      ],
      "bbox_max": [
        1480.5,
        620.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -96.5,
      "bbox_min": [
        1480.0,
        612.0,
        91.0
      ],
      "bbox_max": [
        1480.5,
        619.0,
        96.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1480.5,
      "bbox_min": [
        1480.0,
        612.0,
        91.0
      ],
      "bbox_max": [
        1480.5,
        619.0,
        96.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -619.0,
      "bbox_min": [
        1480.0,
        612.0,
        91.0
      ],
      "bbox_max": [
        1480.5,
        619.0,
        96.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 612.0,
      "bbox_min": [
        1480.0,
        612.0,
        91.0
      ],
      "bbox_max": [
        1480.5,
        618.5,
        96.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 96.0,
      "bbox_min": [
        1480.0,
        612.5,
        91.0
      ],
      "bbox_max": [
        1480.5,
        618.5,
        96.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 618.5,
      "bbox_min": [
        1480.0,
        612.5,
        91.0
      ],
      "bbox_max": [
        1480.5,
        618.5,
        96.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -612.5,
      "bbox_min": [
        1480.0,
        612.5,
        91.0
      ],
      "bbox_max": [
        1480.5,
        612.5,
        96.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1480.0,
        510.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1480.0,
        510.0,
        116.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        140.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.6246950030326843,
        0.0,
        -0.7808688282966614
      ],
      "plane_d": -833.9677734375,
      "bbox_min": [
        1500.0,
        540.0,
        132.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950030326843,
        -0.0,
        -0.7808688282966614
      ],
      "plane_d": 1071.3519287109375,
      "bbox_min": [
        1500.0,
        540.0,
        132.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6246950030326843,
        -0.7808688282966614
      ],
      "plane_d": 477.8916931152344,
      "bbox_min": [
        1500.0,
        540.0,
        132.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6246950030326843,
        -0.7808688282966614
      ],
      "plane_d": -234.2606201171875,
      "bbox_min": [
        1500.0,
        540.0,
        132.0
      ],
      "bbox_max": [
        1550.0,
        550.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1480.0,
        510.0,
        116.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1500.0,
        540.0,
        116.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1500.0,
        540.0,
        116.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1500.0,
        540.0,
        116.0
      ],
      "bbox_max": [
        1550.0,
        600.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -540.0,
      "bbox_min": [
        1500.0,
        540.0,
        116.0
      ],
      "bbox_max": [
        1550.0,
        540.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1480.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -122.0,
      "bbox_min": [
        1480.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1500.0,
        625.0,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": 1424.6541748046875,
      "bbox_min": [
        1480.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1500.0,
        622.8571166992188,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311687231063843,
        -0.6311687231063843,
        0.45083484053611755
      ],
      "plane_d": -608.626953125,
      "bbox_min": [
        1498.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1500.0,
        622.8571166992188,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6963106393814087,
        0.6963106393814087,
        0.17407765984535217
      ],
      "plane_d": 604.7457885742188,
      "bbox_min": [
        1498.0,
        600.0,
        118.0
      ],
      "bbox_max": [
        1500.0,
        602.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1498.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1500.0,
        520.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1480.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1498.9998779296875,
        520.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6311687231063843,
        -0.6311687231063843,
        0.45083484053611755
      ],
      "plane_d": -608.626953125,
      "bbox_min": [
        1480.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1500.0,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1480.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1500.0,
        520.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -122.0,
      "bbox_min": [
        1550.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9701424837112427,
        -0.0,
        0.24253562092781067
      ],
      "plane_d": -1534.2803955078125,
      "bbox_min": [
        1550.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        622.8571166992188,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        0.45083484053611755
      ],
      "plane_d": 1316.4376220703125,
      "bbox_min": [
        1550.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1552.0,
        622.8571166992188,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6963106393814087,
        0.6963106393814087,
        0.17407765984535217
      ],
      "plane_d": -1519.0015869140625,
      "bbox_min": [
        1550.0,
        600.0,
        118.0
      ],
      "bbox_max": [
        1552.0,
        602.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1550.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1552.0,
        520.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        0.45083484053611755
      ],
      "plane_d": 1316.4376220703125,
      "bbox_min": [
        1551.0001220703125,
        520.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        621.8570556640625,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1551.0001220703125,
        520.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        520.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        -0.45083484053611755
      ],
      "plane_d": 1429.1463623046875,
      "bbox_min": [
        1550.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6311687231063843,
        -0.6311687231063843,
        0.45083484053611755
      ],
      "plane_d": 1316.4376220703125,
      "bbox_min": [
        1550.0,
        520.0,
        122.0
      ],
      "bbox_max": [
        1562.5999755859375,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137334585189819,
        0.5812382102012634
      ],
      "plane_d": 435.9286193847656,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        625.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": 493.31744384765625,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        602.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1500.0,
        539.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        602.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -612.6449584960938,
      "bbox_min": [
        1500.0,
        600.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        602.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -122.0,
      "bbox_min": [
        1500.0,
        600.0,
        122.0
      ],
      "bbox_max": [
        1550.0,
        601.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -540.0,
      "bbox_min": [
        1500.0,
        539.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        540.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -122.0,
      "bbox_min": [
        1500.0,
        539.0,
        122.0
      ],
      "bbox_max": [
        1550.0,
        540.0,
        122.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -445.4772644042969,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        520.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9417418837547302,
        -0.0,
        0.3363364040851593
      ],
      "plane_d": -1461.718017578125,
      "bbox_min": [
        1509.2857666015625,
        510.0,
        118.0
      ],
      "bbox_max": [
        1540.7142333984375,
        512.0,
        120.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9417418837547302,
        0.0,
        0.3363364040851593
      ],
      "plane_d": 1410.5947265625,
      "bbox_min": [
        1540.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1540.7142333984375,
        512.0,
        120.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1500.0,
        510.0,
        118.0
      ],
      "bbox_max": [
        1550.0,
        520.0,
        132.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9417418837547302,
        0.0,
        -0.3363364040851593
      ],
      "plane_d": -1377.6339111328125,
      "bbox_min": [
        1507.5,
        510.0,
        118.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9417418837547302,
        -0.0,
        0.3363364040851593
      ],
      "plane_d": -1461.718017578125,
      "bbox_min": [
        1507.5,
        510.0,
        118.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9417418837547302,
        0.0,
        -0.3363364040851593
      ],
      "plane_d": 1494.6788330078125,
      "bbox_min": [
        1540.0,
        510.0,
        125.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 598.0,
      "bbox_min": [
        1480.0,
        510.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1480.0,
        598.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826870322227478,
        0.923878014087677,
        0.0
      ],
      "plane_d": -1120.70361328125,
      "bbox_min": [
        1480.0,
        598.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        600.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1505.0,
      "bbox_min": [
        1505.0,
        598.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        600.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1545.0,
      "bbox_min": [
        1545.0,
        598.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        600.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.894253134727478,
        -0.44756150245666504
      ],
      "plane_d": 606.3479614257812,
      "bbox_min": [
        1480.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -102.0,
      "bbox_min": [
        1480.0,
        625.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 101.5999984741211,
      "bbox_min": [
        1480.0,
        626.9999389648438,
        100.0
      ],
      "bbox_max": [
        1558.0,
        630.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1544.800048828125,
      "bbox_min": [
        1497.800048828125,
        626.9999389648438,
        101.5999984741211
      ],
      "bbox_max": [
        1558.0,
        630.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1558.0,
      "bbox_min": [
        1558.0,
        626.9999389648438,
        101.5999984741211
      ],
      "bbox_max": [
        1558.0,
        630.0,
        102.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1497.800048828125,
      "bbox_min": [
        1497.800048828125,
        627.0,
        101.5999984741211
      ],
      "bbox_max": [
        1504.0,
        630.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1504.0,
      "bbox_min": [
        1504.0,
        627.0,
        101.5999984741211
      ],
      "bbox_max": [
        1504.0,
        630.0,
        102.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        5.805044111184543e-06,
        -0.9701215624809265,
        0.24261943995952606
      ],
      "plane_d": 585.7415771484375,
      "bbox_min": [
        1480.0,
        627.2001342773438,
        100.0
      ],
      "bbox_max": [
        1558.0,
        630.0,
        101.5999984741211
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1504.0,
      "bbox_min": [
        1497.800048828125,
        628.800048828125,
        100.0
      ],
      "bbox_max": [
        1558.0,
        630.0,
        101.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1544.800048828125,
      "bbox_min": [
        1544.800048828125,
        628.800048828125,
        100.0
      ],
      "bbox_max": [
        1558.0,
        630.0,
        101.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1558.0,
      "bbox_min": [
        1558.0,
        628.8001098632812,
        100.0
      ],
      "bbox_max": [
        1558.0,
        630.0,
        101.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1497.800048828125,
      "bbox_min": [
        1497.800048828125,
        628.800048828125,
        100.0
      ],
      "bbox_max": [
        1497.800048828125,
        630.0,
        101.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1558.0,
      "bbox_min": [
        1544.800048828125,
        627.2001342773438,
        100.0
      ],
      "bbox_max": [
        1558.0,
        629.2002563476562,
        101.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1544.800048828125,
      "bbox_min": [
        1544.800048828125,
        627.2001342773438,
        100.0
      ],
      "bbox_max": [
        1544.800048828125,
        629.2001953125,
        101.5999984741211
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -104.9000015258789,
      "bbox_min": [
        1480.0,
        625.0,
        102.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9906256794929504,
        0.13660459220409393
      ],
      "plane_d": 609.5662841796875,
      "bbox_min": [
        1480.0,
        625.548583984375,
        102.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        104.9000015258789
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1504.0,
      "bbox_min": [
        1497.800048828125,
        629.39990234375,
        102.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        104.9000015258789
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1558.0,
      "bbox_min": [
        1544.800048828125,
        629.400146484375,
        102.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        104.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1544.800048828125,
      "bbox_min": [
        1544.800048828125,
        629.400146484375,
        102.0
      ],
      "bbox_max": [
        1544.800048828125,
        630.0,
        104.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 104.0,
      "bbox_min": [
        1558.0,
        629.6759033203125,
        104.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 103.0,
      "bbox_min": [
        1497.800048828125,
        629.5380249023438,
        103.0
      ],
      "bbox_max": [
        1504.0001220703125,
        630.0,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.4000015258789,
      "bbox_min": [
        1497.800048828125,
        629.59326171875,
        103.4000015258789
      ],
      "bbox_max": [
        1504.0001220703125,
        630.0,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1544.800048828125,
      "bbox_min": [
        1497.800048828125,
        625.548583984375,
        102.0
      ],
      "bbox_max": [
        1562.5999755859375,
        629.800048828125,
        104.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1558.0,
      "bbox_min": [
        1558.0,
        625.548583984375,
        102.0
      ],
      "bbox_max": [
        1562.5999755859375,
        629.800048828125,
        104.9000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -104.5,
      "bbox_min": [
        1558.0,
        627.0,
        104.0
      ],
      "bbox_max": [
        1562.5999755859375,
        629.7449340820312,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 104.0,
      "bbox_min": [
        1558.0,
        627.0,
        104.0
      ],
      "bbox_max": [
        1562.5999755859375,
        629.6759033203125,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 627.0,
      "bbox_min": [
        1558.0,
        627.0,
        104.0
      ],
      "bbox_max": [
        1562.5999755859375,
        627.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.4000015258789,
      "bbox_min": [
        1497.800048828125,
        626.29931640625,
        103.0
      ],
      "bbox_max": [
        1504.0001220703125,
        629.59326171875,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 103.0,
      "bbox_min": [
        1497.800048828125,
        626.29931640625,
        103.0
      ],
      "bbox_max": [
        1504.0001220703125,
        629.59326171875,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.441406286379788e-05,
        0.0
      ],
      "plane_d": -1503.9847412109375,
      "bbox_min": [
        1497.800048828125,
        626.29931640625,
        103.0
      ],
      "bbox_max": [
        1504.0001220703125,
        629.59326171875,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1497.800048828125,
      "bbox_min": [
        1497.800048828125,
        626.29931640625,
        103.0
      ],
      "bbox_max": [
        1497.800048828125,
        629.59326171875,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1544.800048828125,
        625.0,
        104.9000015258789
      ],
      "bbox_max": [
        1558.0,
        630.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 625.0,
      "bbox_min": [
        1544.800048828125,
        625.0,
        104.9000015258789
      ],
      "bbox_max": [
        1558.0,
        630.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1558.0,
      "bbox_min": [
        1544.800048828125,
        625.0,
        104.9000015258789
      ],
      "bbox_max": [
        1558.0,
        630.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.314496785402298,
        0.94925856590271,
        0.0
      ],
      "plane_d": -86.34237670898438,
      "bbox_min": [
        1505.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        602.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        0.94925856590271,
        -0.0
      ],
      "plane_d": -1056.56494140625,
      "bbox_min": [
        1540.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        602.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        0.4597398340702057,
        0.0
      ],
      "plane_d": 1091.7587890625,
      "bbox_min": [
        1540.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        601.414306640625,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        0.4597398340702057,
        -0.0
      ],
      "plane_d": -1647.8868408203125,
      "bbox_min": [
        1544.267822265625,
        600.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        601.414306640625,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.314496785402298,
        0.94925856590271,
        0.0
      ],
      "plane_d": -1045.5576171875,
      "bbox_min": [
        1505.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1510.0,
        602.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8880536556243896,
        0.4597398340702057,
        0.0
      ],
      "plane_d": -1616.804931640625,
      "bbox_min": [
        1505.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1510.0,
        601.414306640625,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8880536556243896,
        0.4597398340702057,
        0.0
      ],
      "plane_d": 1060.6768798828125,
      "bbox_min": [
        1505.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1505.732177734375,
        601.414306640625,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 625.0,
      "bbox_min": [
        1497.800048828125,
        625.0,
        100.0
      ],
      "bbox_max": [
        1558.0,
        628.0009155273438,
        105.9960708618164
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1544.800048828125,
      "bbox_min": [
        1497.800048828125,
        625.0,
        100.0
      ],
      "bbox_max": [
        1558.0,
        628.0009155273438,
        105.9960708618164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1558.0,
      "bbox_min": [
        1558.0,
        625.0,
        100.0
      ],
      "bbox_max": [
        1558.0,
        628.0009155273438,
        105.9960708618164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 103.0,
      "bbox_min": [
        1497.800048828125,
        625.0,
        103.0
      ],
      "bbox_max": [
        1504.0,
        626.49951171875,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.4000015258789,
      "bbox_min": [
        1497.800048828125,
        625.0,
        103.0
      ],
      "bbox_max": [
        1504.0,
        626.49951171875,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -2.441406286379788e-05,
        0.0
      ],
      "plane_d": -1503.9847412109375,
      "bbox_min": [
        1497.800048828125,
        625.0,
        103.0
      ],
      "bbox_max": [
        1504.0,
        626.49951171875,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1497.800048828125,
      "bbox_min": [
        1497.800048828125,
        625.0,
        103.0
      ],
      "bbox_max": [
        1497.800048828125,
        626.49951171875,
        103.4000015258789
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1480.0,
        510.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        598.0,
        116.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9593654870986938,
        0.0,
        -0.28216633200645447
      ],
      "plane_d": 1510.1541748046875,
      "bbox_min": [
        1507.5,
        510.0,
        100.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9593654870986938,
        0.0,
        -0.28216633200645447
      ],
      "plane_d": -1415.91064453125,
      "bbox_min": [
        1507.5,
        510.0,
        100.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1429.3494873046875,
      "bbox_min": [
        1507.5,
        510.0,
        100.0
      ],
      "bbox_max": [
        1542.5,
        520.0,
        107.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9486833214759827,
        -0.0,
        0.3162277638912201
      ],
      "plane_d": -1464.1346435546875,
      "bbox_min": [
        1507.5,
        510.0,
        100.0
      ],
      "bbox_max": [
        1510.0,
        520.0,
        107.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        1480.0,
        520.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        598.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        1484.828369140625,
        595.0,
        100.0
      ],
      "bbox_max": [
        1535.0,
        598.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1515.0,
      "bbox_min": [
        1484.828369140625,
        595.0,
        100.0
      ],
      "bbox_max": [
        1535.0,
        598.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1535.0,
        595.0,
        100.0
      ],
      "bbox_max": [
        1535.0,
        598.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        0.923878014087677,
        0.0
      ],
      "plane_d": -1120.70361328125,
      "bbox_min": [
        1484.828369140625,
        595.0,
        100.0
      ],
      "bbox_max": [
        1487.928955078125,
        598.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": -1602.3636474609375,
      "bbox_min": [
        1487.071044921875,
        595.0,
        105.0
      ],
      "bbox_max": [
        1487.928955078125,
        597.071044921875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        -0.0
      ],
      "plane_d": -1579.40234375,
      "bbox_min": [
        1487.071044921875,
        522.928955078125,
        100.0
      ],
      "bbox_max": [
        1490.0,
        537.071044921875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1173.754150390625,
      "bbox_min": [
        1487.071044921875,
        522.928955078125,
        100.0
      ],
      "bbox_max": [
        1490.0,
        530.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        -0.923878014087677,
        0.0
      ],
      "plane_d": -30.527587890625,
      "bbox_min": [
        1480.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        595.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1150.7928466796875,
      "bbox_min": [
        1487.071044921875,
        582.928955078125,
        100.0
      ],
      "bbox_max": [
        1490.0,
        595.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": -1602.3636474609375,
      "bbox_min": [
        1487.928955078125,
        590.0,
        100.0
      ],
      "bbox_max": [
        1490.0,
        595.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1476.2122802734375,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -680.46337890625,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.965927004814148,
        -0.25881466269493103,
        -0.0
      ],
      "plane_d": 1606.4207763671875,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881466269493103,
        -0.965927004814148,
        -0.0
      ],
      "plane_d": 945.270751953125,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881466269493103,
        -0.965927004814148,
        0.0
      ],
      "plane_d": 155.88601684570312,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        -0.25881466269493103,
        0.0
      ],
      "plane_d": -1339.656494140625,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        1505.0,
        570.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9659277200698853,
        0.258811891078949,
        0.0
      ],
      "plane_d": 1336.6593017578125,
      "bbox_min": [
        1505.0,
        573.105712890625,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        1541.8941650390625,
        590.0,
        100.0
      ],
      "bbox_max": [
        1545.0,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659277200698853,
        0.258811891078949,
        0.0
      ],
      "plane_d": -1609.4202880859375,
      "bbox_min": [
        1505.0,
        573.105712890625,
        100.0
      ],
      "bbox_max": [
        1539.630859375,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        1505.0,
        590.0,
        100.0
      ],
      "bbox_max": [
        1508.1058349609375,
        590.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071137428283691,
        0.7070997953414917,
        0.0
      ],
      "plane_d": 677.4780883789062,
      "bbox_min": [
        1510.369140625,
        573.105712890625,
        100.0
      ],
      "bbox_max": [
        1539.630859375,
        581.552978515625,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071137428283691,
        0.7070997953414917,
        0.0
      ],
      "plane_d": -1479.21875,
      "bbox_min": [
        1510.369140625,
        573.105712890625,
        100.0
      ],
      "bbox_max": [
        1533.4471435546875,
        581.552978515625,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882142782211304,
        0.9659251570701599,
        0.0
      ],
      "plane_d": -158.87457275390625,
      "bbox_min": [
        1516.5528564453125,
        573.105712890625,
        100.0
      ],
      "bbox_max": [
        1533.4471435546875,
        575.369140625,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882142782211304,
        0.9659251570701599,
        0.0
      ],
      "plane_d": -948.2799072265625,
      "bbox_min": [
        1516.5528564453125,
        573.105712890625,
        100.0
      ],
      "bbox_max": [
        1525.0,
        575.369140625,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        -0.0
      ],
      "plane_d": 1644.0738525390625,
      "bbox_min": [
        1499.97265625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        536.27685546875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1238.425537109375,
      "bbox_min": [
        1560.0,
        530.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        536.27685546875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -103.0,
      "bbox_min": [
        1499.97265625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1550.02734375,
        525.8154296875,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8542450070381165,
        -0.49318787455558777,
        -0.16441157460212708
      ],
      "plane_d": 1595.3929443359375,
      "bbox_min": [
        1499.97265625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1550.02734375,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542515635490417,
        -0.4931761622428894,
        -0.16441282629966736
      ],
      "plane_d": -1048.85302734375,
      "bbox_min": [
        1545.37255859375,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1550.02734375,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -501.7280578613281,
      "bbox_min": [
        1545.37255859375,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1550.02734375,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": 531.6180419921875,
      "bbox_min": [
        1545.37255859375,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1550.02734375,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542198538780212,
        0.4932330548763275,
        -0.16440673172473907
      ],
      "plane_d": -1565.4857177734375,
      "bbox_min": [
        1545.37255859375,
        523.800048828125,
        100.0
      ],
      "bbox_max": [
        1550.02734375,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542195558547974,
        0.4932328760623932,
        -0.1644088178873062
      ],
      "plane_d": 1078.666259765625,
      "bbox_min": [
        1545.37255859375,
        523.800048828125,
        100.0
      ],
      "bbox_max": [
        1546.824951171875,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8542529940605164,
        -0.49317699670791626,
        -0.16440272331237793
      ],
      "plane_d": -1010.0728149414062,
      "bbox_min": [
        1499.97265625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1504.62744140625,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542530536651611,
        -0.49317699670791626,
        -0.16440273821353912
      ],
      "plane_d": 1556.6158447265625,
      "bbox_min": [
        1499.97265625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1504.62744140625,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": -501.7280578613281,
      "bbox_min": [
        1499.97265625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1504.62744140625,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.986393928527832,
        -0.16439899802207947
      ],
      "plane_d": 531.6180419921875,
      "bbox_min": [
        1499.97265625,
        521.784423828125,
        100.0
      ],
      "bbox_max": [
        1504.62744140625,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.854218065738678,
        0.4932362735271454,
        -0.16440637409687042
      ],
      "plane_d": -1526.7032470703125,
      "bbox_min": [
        1499.97265625,
        523.800048828125,
        100.0
      ],
      "bbox_max": [
        1504.62744140625,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8542176485061646,
        0.49323606491088867,
        -0.16440916061401367
      ],
      "plane_d": 1039.8802490234375,
      "bbox_min": [
        1499.97265625,
        523.800048828125,
        100.0
      ],
      "bbox_max": [
        1501.425048828125,
        525.8154296875,
        103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071195244789124,
        -0.7070940732955933,
        0.0
      ],
      "plane_d": -691.9622192382812,
      "bbox_min": [
        1500.62060546875,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -1432.7115478515625,
      "bbox_min": [
        1500.62060546875,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1504.0853271484375,
        525.53955078125,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": 678.8614501953125,
      "bbox_min": [
        1500.62060546875,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1502.3529052734375,
        525.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        5.489622978416264e-09,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -351.9329528808594,
      "bbox_min": [
        1500.62060546875,
        523.80712890625,
        103.0
      ],
      "bbox_max": [
        1504.0853271484375,
        525.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -1432.7115478515625,
      "bbox_min": [
        1500.691162109375,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 180.91671752929688,
      "bbox_min": [
        1500.691162109375,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1504.0146484375,
        523.80712890625,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5078026056289673,
        -0.01057465560734272,
        0.861408531665802
      ],
      "plane_d": -846.9461669921875,
      "bbox_min": [
        1502.3529052734375,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        112.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071195244789124,
        -0.7070940732955933,
        -0.0
      ],
      "plane_d": 1464.75244140625,
      "bbox_min": [
        1545.9146728515625,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 723.964111328125,
      "bbox_min": [
        1545.9146728515625,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.507815420627594,
        -0.010555896908044815,
        0.8614012598991394
      ],
      "plane_d": -869.9755859375,
      "bbox_min": [
        1547.6470947265625,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.49991968274116516,
        0.8660717606544495
      ],
      "plane_d": -351.9329528808594,
      "bbox_min": [
        1545.9146728515625,
        523.80712890625,
        103.0
      ],
      "bbox_max": [
        1549.37939453125,
        525.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 723.964111328125,
      "bbox_min": [
        1545.9146728515625,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.308837890625,
        525.53955078125,
        112.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -3.7876685382798314e-05,
        -0.5156152844429016,
        0.8568202257156372
      ],
      "plane_d": 181.03225708007812,
      "bbox_min": [
        1545.9853515625,
        522.145263671875,
        103.0
      ],
      "bbox_max": [
        1549.308837890625,
        523.80712890625,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5078026056289673,
        -0.010574648156762123,
        0.861408531665802
      ],
      "plane_d": 701.8517456054688,
      "bbox_min": [
        1545.9146728515625,
        522.1455078125,
        103.0
      ],
      "bbox_max": [
        1547.6470947265625,
        525.53955078125,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        1480.0,
        600.0,
        310.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1480.0,
        600.0,
        317.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 338.0,
      "bbox_min": [
        1480.0,
        600.0,
        331.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6585046052932739,
        -0.7525767087936401
      ],
      "plane_d": -145.99986267089844,
      "bbox_min": [
        1480.0,
        600.0,
        331.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6585046052932739,
        -0.7525767087936401
      ],
      "plane_d": 663.9608154296875,
      "bbox_min": [
        1480.0,
        600.0,
        331.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        1480.0,
        600.0,
        331.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        1490.0,
        600.0,
        331.0
      ],
      "bbox_max": [
        1560.0,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        1560.0,
        600.0,
        331.0
      ],
      "bbox_max": [
        1560.0,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5734623670578003,
        0.0,
        -0.8192319273948669
      ],
      "plane_d": -594.7623901367188,
      "bbox_min": [
        1480.0,
        600.0,
        310.0
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5734623670578003,
        -0.0,
        -0.8192319273948669
      ],
      "plane_d": 1154.2978515625,
      "bbox_min": [
        1560.0,
        600.0,
        315.1800231933594
      ],
      "bbox_max": [
        1562.5999755859375,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1480.0,
        630.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2316918820142746,
        0.9727892875671387,
        -0.0
      ],
      "plane_d": -1005.098876953125,
      "bbox_min": [
        1525.0,
        651.2188720703125,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        670.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6643652319908142,
        0.7474080920219421,
        0.0
      ],
      "plane_d": -1524.86328125,
      "bbox_min": [
        1547.5,
        651.2188720703125,
        120.0
      ],
      "bbox_max": [
        1562.5999755859375,
        664.64111328125,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6246249675750732,
        0.7558982372283936,
        0.19611550867557526
      ],
      "plane_d": -1261.1207275390625,
      "bbox_min": [
        1305.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1374.1917724609375,
        567.175537109375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        1310.0,
        510.0,
        88.0
      ],
      "bbox_max": [
        1310.0,
        556.557861328125,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        1290.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        390.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1371.052001953125,
        490.0,
        78.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        348.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1371.052001953125,
        490.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        510.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.0,
        0.7071067690849304
      ],
      "plane_d": -1285.5201416015625,
      "bbox_min": [
        1470.0,
        490.0,
        338.0
      ],
      "bbox_max": [
        1480.0,
        510.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1371.052001953125,
        490.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246249675750732,
        0.7558982372283936,
        0.19611550867557526
      ],
      "plane_d": -1261.1207275390625,
      "bbox_min": [
        1371.052001953125,
        505.0,
        88.0
      ],
      "bbox_max": [
        1380.2425537109375,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1480.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1485.22216796875,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1485.22216796875,
        490.0,
        138.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35558271408081055,
        -0.10718903690576553,
        0.9284780025482178
      ],
      "plane_d": 454.65576171875,
      "bbox_min": [
        1485.22216796875,
        490.0,
        138.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35558319091796875,
        -0.10718917846679688,
        0.9284778833389282
      ],
      "plane_d": -629.8721923828125,
      "bbox_min": [
        1490.4078369140625,
        490.0,
        138.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24674342572689056,
        -0.2775822579860687,
        0.9284749627113342
      ],
      "plane_d": -376.1568603515625,
      "bbox_min": [
        1490.4078369140625,
        490.0,
        138.0
      ],
      "bbox_max": [
        1559.5921630859375,
        495.5947265625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24673829972743988,
        -0.2775764763355255,
        0.9284781217575073
      ],
      "plane_d": 376.3996887207031,
      "bbox_min": [
        1490.4078369140625,
        490.0,
        138.0
      ],
      "bbox_max": [
        1501.0806884765625,
        495.5947265625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1485.22216796875,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        138.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1487.9036865234375,
        490.0,
        118.0
      ],
      "bbox_max": [
        1562.1053466796875,
        492.800048828125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": 782.11181640625,
      "bbox_min": [
        1487.9036865234375,
        490.0,
        118.0
      ],
      "bbox_max": [
        1490.4078369140625,
        492.79736328125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9574445486068726,
        0.28861749172210693,
        -0.0
      ],
      "plane_d": -1574.212890625,
      "bbox_min": [
        1490.4444580078125,
        495.0,
        120.0
      ],
      "bbox_max": [
        1559.5555419921875,
        510.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.60009765625,
      "bbox_min": [
        1494.4000244140625,
        495.60009765625,
        120.0
      ],
      "bbox_max": [
        1494.7852783203125,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9574445486068726,
        0.28861749172210693,
        0.0
      ],
      "plane_d": 1345.9930419921875,
      "bbox_min": [
        1494.7852783203125,
        495.0,
        120.0
      ],
      "bbox_max": [
        1559.5555419921875,
        510.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.60009765625,
      "bbox_min": [
        1555.2147216796875,
        495.60009765625,
        120.0
      ],
      "bbox_max": [
        1555.5999755859375,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1495.0,
      "bbox_min": [
        1494.7852783203125,
        495.0,
        120.0
      ],
      "bbox_max": [
        1555.2147216796875,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.60009765625,
      "bbox_min": [
        1494.7852783203125,
        495.60009765625,
        120.0
      ],
      "bbox_max": [
        1495.0,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1555.0,
        495.0,
        120.0
      ],
      "bbox_max": [
        1555.2147216796875,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.60009765625,
      "bbox_min": [
        1555.0,
        495.60009765625,
        120.0
      ],
      "bbox_max": [
        1555.2147216796875,
        495.60009765625,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1480.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1480.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        118.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.7241400480270386,
        0.0,
        -0.6896529793739319
      ],
      "plane_d": -1024.89990234375,
      "bbox_min": [
        1502.0,
        490.0,
        91.0
      ],
      "bbox_max": [
        1548.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7241400480270386,
        0.0,
        -0.6896529793739319
      ],
      "plane_d": 1183.7271728515625,
      "bbox_min": [
        1541.3333740234375,
        490.0,
        91.0
      ],
      "bbox_max": [
        1548.0,
        510.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9575520753860474,
        0.2882605195045471,
        -0.0
      ],
      "plane_d": -1569.1904296875,
      "bbox_min": [
        1485.22216796875,
        490.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        510.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9575520753860474,
        0.2882605195045471,
        0.0
      ],
      "plane_d": 1351.3433837890625,
      "bbox_min": [
        1490.4078369140625,
        490.0,
        100.0
      ],
      "bbox_max": [
        1562.5999755859375,
        502.7655334472656,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6646878123283386,
        0.747121274471283,
        0.0
      ],
      "plane_d": 668.4656982421875,
      "bbox_min": [
        1490.4078369140625,
        490.0,
        100.0
      ],
      "bbox_max": [
        1559.5999755859375,
        492.800048828125,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6646878123283386,
        0.747121274471283,
        -0.0
      ],
      "plane_d": -1358.8353271484375,
      "bbox_min": [
        1490.4078369140625,
        490.0,
        100.0
      ],
      "bbox_max": [
        1493.551025390625,
        492.79736328125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -420.0,
      "bbox_min": [
        1290.0,
        400.0,
        78.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        390.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        1490.0,
        400.0,
        140.0
      ],
      "bbox_max": [
        1560.0,
        400.0,
        390.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1290.0,
        420.0,
        78.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.09950371831655502,
        0.9950371980667114
      ],
      "plane_d": -126.36972045898438,
      "bbox_min": [
        1290.0,
        470.0,
        78.0
      ],
      "bbox_max": [
        1480.0,
        490.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1290.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1290.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        1386.0,
        460.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        1386.0,
        460.0,
        118.0
      ],
      "bbox_max": [
        1390.0,
        460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": 782.11181640625,
      "bbox_min": [
        1470.0,
        470.0,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1562.0963134765625,
        489.4373779296875,
        118.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1290.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        118.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        1290.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        490.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38461539149284363,
        0.0,
        0.9230769872665405
      ],
      "plane_d": 487.6922912597656,
      "bbox_min": [
        1350.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        1460.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1562.5999755859375,
        470.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.38461539149284363,
        0.0,
        -0.9230770468711853
      ],
      "plane_d": -489.5384521484375,
      "bbox_min": [
        1464.800048828125,
        450.0,
        80.0000228881836
      ],
      "bbox_max": [
        1562.5999755859375,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1508.0,
        450.0,
        89.760009765625
      ],
      "bbox_max": [
        1562.5999755859375,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": -665.5321044921875,
      "bbox_min": [
        1542.0,
        450.0,
        98.0
      ],
      "bbox_max": [
        1547.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 663.6751708984375,
      "bbox_min": [
        1542.0,
        450.0,
        89.760009765625
      ],
      "bbox_max": [
        1562.5999755859375,
        460.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": -665.5321044921875,
      "bbox_min": [
        1547.0,
        450.0,
        91.760009765625
      ],
      "bbox_max": [
        1562.5999755859375,
        460.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1508.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        1542.0,
        470.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -693.18115234375,
      "bbox_min": [
        1350.0,
        450.0,
        80.0
      ],
      "bbox_max": [
        1390.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -516.0845336914062,
      "bbox_min": [
        1350.0,
        450.0,
        98.0
      ],
      "bbox_max": [
        1352.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        1350.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        1352.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        1350.0,
        460.0,
        99.00001525878906
      ],
      "bbox_max": [
        1354.0,
        460.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1502.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1548.0,
      "bbox_min": [
        1502.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1502.0,
      "bbox_min": [
        1502.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7241400480270386,
        0.0,
        -0.6896529793739319
      ],
      "plane_d": -1024.89990234375,
      "bbox_min": [
        1502.0,
        470.0,
        91.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7241400480270386,
        0.0,
        -0.6896529793739319
      ],
      "plane_d": 1183.7271728515625,
      "bbox_min": [
        1541.3333740234375,
        470.0,
        91.0
      ],
      "bbox_max": [
        1548.0,
        490.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -516.0845336914062,
      "bbox_min": [
        1350.0,
        450.0,
        100.0
      ],
      "bbox_max": [
        1556.4527587890625,
        490.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -459.9999694824219,
      "bbox_min": [
        1350.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        1390.0,
        460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6646878123283386,
        0.747121274471283,
        0.0
      ],
      "plane_d": 668.4656982421875,
      "bbox_min": [
        1493.551025390625,
        478.0,
        100.0
      ],
      "bbox_max": [
        1556.4527587890625,
        490.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6646878123283386,
        0.747121274471283,
        -0.0
      ],
      "plane_d": -1358.8353271484375,
      "bbox_min": [
        1493.551025390625,
        478.0,
        100.0
      ],
      "bbox_max": [
        1545.0999755859375,
        490.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22360631823539734,
        0.9746794104576111,
        -0.0006081170286051929
      ],
      "plane_d": -122.1936264038086,
      "bbox_min": [
        1504.9000244140625,
        478.0,
        100.0
      ],
      "bbox_max": [
        1545.0999755859375,
        479.89990234375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22024792432785034,
        0.9754440188407898,
        0.0
      ],
      "plane_d": -127.8104248046875,
      "bbox_min": [
        1541.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1545.0999755859375,
        479.89990234375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23156701028347015,
        0.9728189706802368,
        0.0
      ],
      "plane_d": -109.08755493164062,
      "bbox_min": [
        1541.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1542.0,
        479.199951171875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1541.0,
      "bbox_min": [
        1541.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1541.0,
        478.95068359375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24186664819717407,
        0.970309317111969,
        -0.0006053904653526843
      ],
      "plane_d": -91.9423599243164,
      "bbox_min": [
        1541.0,
        478.95068359375,
        100.0
      ],
      "bbox_max": [
        1542.0,
        479.199951171875,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22360636293888092,
        0.9746795892715454,
        -0.0
      ],
      "plane_d": -804.2538452148438,
      "bbox_min": [
        1504.9000244140625,
        478.0,
        100.0
      ],
      "bbox_max": [
        1509.0,
        479.89990234375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23156701028347015,
        0.9728189706802368,
        -0.0
      ],
      "plane_d": -815.366943359375,
      "bbox_min": [
        1508.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1509.0,
        479.188720703125,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1509.0,
      "bbox_min": [
        1509.0,
        478.0,
        100.0
      ],
      "bbox_max": [
        1509.0,
        478.95068359375,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1493.5548095703125,
        475.139892578125,
        120.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1493.5548095703125,
        475.139892578125,
        138.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08604604750871658,
        -0.36128291487693787,
        0.9284776449203491
      ],
      "plane_d": -87.69021606445312,
      "bbox_min": [
        1493.5548095703125,
        475.139892578125,
        138.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08604757487773895,
        -0.3612893223762512,
        0.9284750819206238
      ],
      "plane_d": 174.7559356689453,
      "bbox_min": [
        1493.5548095703125,
        475.139892578125,
        138.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24674342572689056,
        -0.2775822579860687,
        0.9284749627113342
      ],
      "plane_d": -376.1568603515625,
      "bbox_min": [
        1493.5548095703125,
        479.931396484375,
        138.0
      ],
      "bbox_max": [
        1556.4451904296875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24673829972743988,
        -0.2775764763355255,
        0.9284781217575073
      ],
      "plane_d": 376.3996887207031,
      "bbox_min": [
        1493.5548095703125,
        479.931396484375,
        138.0
      ],
      "bbox_max": [
        1507.263671875,
        490.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23168207705020905,
        0.9727915525436401,
        0.0
      ],
      "plane_d": -113.89697265625,
      "bbox_min": [
        1506.6640625,
        480.27978515625,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.800048828125,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1542.7359619140625,
      "bbox_min": [
        1542.7359619140625,
        484.199951171875,
        120.0
      ],
      "bbox_max": [
        1542.7359619140625,
        484.50384521484375,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23168207705020905,
        0.9727915525436401,
        0.0
      ],
      "plane_d": -820.5272827148438,
      "bbox_min": [
        1506.6640625,
        480.27978515625,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.800048828125,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1507.2640380859375,
      "bbox_min": [
        1507.2640380859375,
        484.199951171875,
        120.0
      ],
      "bbox_max": [
        1507.2640380859375,
        484.5038146972656,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -484.800048828125,
      "bbox_min": [
        1506.6640625,
        484.5038146972656,
        120.0
      ],
      "bbox_max": [
        1543.3359375,
        484.800048828125,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1507.2640380859375,
      "bbox_min": [
        1507.2640380859375,
        484.5038146972656,
        120.0
      ],
      "bbox_max": [
        1542.7359619140625,
        484.800048828125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1542.7359619140625,
      "bbox_min": [
        1542.7359619140625,
        484.50384521484375,
        120.0
      ],
      "bbox_max": [
        1542.7359619140625,
        484.800048828125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 510.0,
      "bbox_min": [
        1562.5999755859375,
        -80.0,
        63.31221389770508
      ],
      "bbox_max": [
        1770.0,
        670.0,
        370.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.6305926442146301,
        -0.7761140465736389,
        0.0
      ],
      "plane_d": -628.65234375,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        63.31221389770508
      ],
      "bbox_max": [
        1770.0,
        670.0,
        363.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        63.31221389770508
      ],
      "bbox_max": [
        1770.0,
        670.0,
        363.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        80.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        85.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1562.5999755859375,
        610.0,
        80.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        85.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1570.0,
        630.0,
        80.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1580.0,
        630.0,
        80.0
      ],
      "bbox_max": [
        1637.5,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 652.5,
      "bbox_min": [
        1580.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1600.0,
        667.5,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1580.0,
        652.5,
        80.0
      ],
      "bbox_max": [
        1600.0,
        667.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -655.0,
      "bbox_min": [
        1595.0,
        652.5,
        80.0
      ],
      "bbox_max": [
        1600.0,
        667.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        652.5,
        80.0
      ],
      "bbox_max": [
        1595.0,
        655.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        665.0,
        80.0
      ],
      "bbox_max": [
        1595.0,
        667.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -637.5,
      "bbox_min": [
        1580.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1600.0,
        652.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1580.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1600.0,
        652.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1595.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1600.0,
        652.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1595.0,
        652.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1595.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1600.0,
        640.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1595.0,
        640.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1620.0,
        630.0,
        80.0
      ],
      "bbox_max": [
        1637.5,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1637.5,
      "bbox_min": [
        1620.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1637.5,
        652.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 652.5,
      "bbox_min": [
        1620.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1637.5,
        652.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -637.5,
      "bbox_min": [
        1620.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1637.5,
        652.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1620.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        1625.0,
        650.0,
        80.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1620.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1625.0,
        640.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        1625.0,
        637.5,
        80.0
      ],
      "bbox_max": [
        1625.0,
        640.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 628.0,
      "bbox_min": [
        1562.5999755859375,
        628.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1580.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        363.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1580.0,
        670.0,
        348.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 871.155517578125,
      "bbox_min": [
        1570.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1580.0,
        670.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1570.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1580.0,
        630.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1208.9754638671875,
      "bbox_min": [
        1570.0,
        520.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        630.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1570.0,
        540.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1570.0,
        540.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8137335181236267,
        0.5812381505966187
      ],
      "plane_d": -512.0708618164062,
      "bbox_min": [
        1570.0,
        540.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137335181236267,
        0.5812381505966187
      ],
      "plane_d": 383.0360107421875,
      "bbox_min": [
        1570.0,
        540.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137335181236267,
        -0.5812381505966187
      ],
      "plane_d": -366.7613525390625,
      "bbox_min": [
        1575.0,
        540.0,
        125.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137335181236267,
        -0.5812381505966187
      ],
      "plane_d": 528.3455200195312,
      "bbox_min": [
        1575.0,
        555.0,
        125.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1570.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -549.0789184570312,
      "bbox_min": [
        1570.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.847998321056366,
        -0.5299989581108093
      ],
      "plane_d": -434.59912109375,
      "bbox_min": [
        1570.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 455.799072265625,
      "bbox_min": [
        1570.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        -0.5299989581108093
      ],
      "plane_d": 570.2788696289062,
      "bbox_min": [
        1570.0,
        600.0,
        108.0
      ],
      "bbox_max": [
        1580.0,
        605.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        -0.0,
        -0.5812382102012634
      ],
      "plane_d": 1354.2850341796875,
      "bbox_min": [
        1570.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        630.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -317.0,
      "bbox_min": [
        1570.0,
        540.0,
        125.0
      ],
      "bbox_max": [
        1580.0,
        630.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1570.0,
        540.0,
        125.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137335181236267,
        -0.5812381505966187
      ],
      "plane_d": 528.3455200195312,
      "bbox_min": [
        1570.0,
        555.0,
        125.0
      ],
      "bbox_max": [
        1580.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1570.0,
        630.0,
        317.0
      ],
      "bbox_max": [
        1580.0,
        630.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1570.0,
        520.0,
        118.0
      ],
      "bbox_max": [
        1575.0,
        605.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1570.0,
        630.0,
        85.0
      ],
      "bbox_max": [
        1580.0,
        630.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        116.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        116.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9574458599090576,
        0.28861290216445923,
        0.0
      ],
      "plane_d": -1685.01611328125,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        132.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6643652319908142,
        0.7474080920219421,
        0.0
      ],
      "plane_d": -1524.86328125,
      "bbox_min": [
        1562.5999755859375,
        650.0,
        132.0
      ],
      "bbox_max": [
        1563.97119140625,
        651.2188720703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6643652319908142,
        0.7474080920219421,
        0.0
      ],
      "plane_d": -1524.86328125,
      "bbox_min": [
        1562.5999755859375,
        650.0,
        120.0
      ],
      "bbox_max": [
        1563.97119140625,
        651.2188720703125,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        520.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1562.5999755859375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        98.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        98.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        -0.0
      ],
      "plane_d": 1644.0738525390625,
      "bbox_min": [
        1562.5999755859375,
        522.928955078125,
        100.0
      ],
      "bbox_max": [
        1562.928955078125,
        537.071044921875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        0.3826870322227478,
        0.0
      ],
      "plane_d": 1238.425537109375,
      "bbox_min": [
        1562.5999755859375,
        536.27685546875,
        100.0
      ],
      "bbox_max": [
        1562.928955078125,
        537.071044921875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -520.0,
      "bbox_min": [
        1562.5999755859375,
        520.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        520.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1562.5999755859375,
        612.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -618.0,
      "bbox_min": [
        1562.5999755859375,
        612.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1564.800048828125,
      "bbox_min": [
        1564.800048828125,
        612.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        618.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 612.0,
      "bbox_min": [
        1564.800048828125,
        612.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        618.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1564.800048828125,
        612.0,
        110.0
      ],
      "bbox_max": [
        1570.0,
        618.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -104.5,
      "bbox_min": [
        1562.5999755859375,
        618.0,
        104.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        104.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 104.0,
      "bbox_min": [
        1562.5999755859375,
        618.0,
        104.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        104.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1567.0,
      "bbox_min": [
        1562.5999755859375,
        618.0,
        104.0
      ],
      "bbox_max": [
        1567.0,
        627.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1549.27099609375,
      "bbox_min": [
        1562.5999755859375,
        624.0,
        104.0
      ],
      "bbox_max": [
        1567.0,
        627.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 627.0,
      "bbox_min": [
        1562.5999755859375,
        627.0,
        104.0
      ],
      "bbox_max": [
        1564.0,
        627.0,
        104.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 628.0,
      "bbox_min": [
        1562.5999755859375,
        610.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1562.5999755859375,
        610.0,
        85.0
      ],
      "bbox_max": [
        1570.0,
        610.0,
        98.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        1562.5999755859375,
        600.0,
        317.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        331.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1562.5999755859375,
        600.0,
        317.0
      ],
      "bbox_max": [
        1570.0,
        600.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9574458599090576,
        0.28861290216445923,
        0.0
      ],
      "plane_d": -1685.01611328125,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        140.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1562.5999755859375,
        630.0,
        140.0
      ],
      "bbox_max": [
        1570.0,
        651.2188720703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6643652319908142,
        0.7474080920219421,
        -0.0
      ],
      "plane_d": -1524.8634033203125,
      "bbox_min": [
        1562.5999755859375,
        650.0,
        140.0
      ],
      "bbox_max": [
        1563.97119140625,
        651.2188720703125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1637.5,
      "bbox_min": [
        1580.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1640.0,
        670.0,
        363.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -348.0,
      "bbox_min": [
        1637.5,
        520.46875,
        85.0
      ],
      "bbox_max": [
        1640.0,
        660.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1637.5,
        590.0,
        118.0
      ],
      "bbox_max": [
        1640.0,
        600.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1637.5,
        590.0,
        118.0
      ],
      "bbox_max": [
        1640.0,
        600.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        1637.5,
        590.0,
        118.0
      ],
      "bbox_max": [
        1640.0,
        600.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1637.5,
        600.0,
        118.0
      ],
      "bbox_max": [
        1640.0,
        600.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1637.5,
        640.0,
        118.0
      ],
      "bbox_max": [
        1640.0,
        650.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1637.5,
        640.0,
        118.0
      ],
      "bbox_max": [
        1640.0,
        650.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1637.5,
        640.0,
        118.0
      ],
      "bbox_max": [
        1640.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1637.5,
        630.0,
        85.0
      ],
      "bbox_max": [
        1640.0,
        630.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -637.5,
      "bbox_min": [
        1580.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1637.5,
        670.0,
        363.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -348.0,
      "bbox_min": [
        1580.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1637.5,
        637.5,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1580.0,
        510.0,
        85.0
      ],
      "bbox_max": [
        1637.5,
        637.5,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1580.0,
        540.0,
        100.0
      ],
      "bbox_max": [
        1637.5,
        637.5,
        331.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        1580.0,
        600.0,
        180.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -317.0,
      "bbox_min": [
        1580.0,
        600.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        635.0,
        331.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        1580.0,
        600.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        635.0,
        331.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1133.99560546875,
      "bbox_min": [
        1580.0,
        600.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        635.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        -0.0,
        -0.5812382102012634
      ],
      "plane_d": 1510.6380615234375,
      "bbox_min": [
        1580.0,
        600.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        635.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1580.0,
        600.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        635.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1113.65234375,
      "bbox_min": [
        1600.0,
        630.0,
        317.0
      ],
      "bbox_max": [
        1605.0,
        635.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -1490.294677734375,
      "bbox_min": [
        1600.0,
        630.0,
        317.0
      ],
      "bbox_max": [
        1605.0,
        635.0,
        324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1580.0,
        600.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        600.0,
        331.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1595.0,
        635.0,
        180.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        1600.0,
        635.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1113.65234375,
      "bbox_min": [
        1600.0,
        635.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -1490.294677734375,
      "bbox_min": [
        1600.0,
        635.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 1510.6380615234375,
      "bbox_min": [
        1620.0,
        635.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1133.9957275390625,
      "bbox_min": [
        1620.0,
        635.0,
        317.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1595.0,
        635.0,
        180.0
      ],
      "bbox_max": [
        1624.0,
        637.5,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1624.0,
      "bbox_min": [
        1624.0,
        635.0,
        180.0
      ],
      "bbox_max": [
        1624.0,
        637.5,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1580.0,
        540.0,
        100.0
      ],
      "bbox_max": [
        1637.5,
        637.5,
        132.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        116.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        116.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.33140257000923157,
        0.8000723123550415,
        -0.5000565648078918
      ],
      "plane_d": 116.89434814453125,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3313995599746704,
        0.8000739812850952,
        0.5000559687614441
      ],
      "plane_d": 8.876361846923828,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8000776171684265,
        0.3314020335674286,
        -0.5000485181808472
      ],
      "plane_d": 1150.319091796875,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8000778555870056,
        0.33140116930007935,
        0.5000486373901367
      ],
      "plane_d": 1042.3094482421875,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.847998321056366,
        0.0,
        -0.5299989581108093
      ],
      "plane_d": 1435.2371826171875,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.847998321056366,
        0.0,
        0.5299989581108093
      ],
      "plane_d": 1320.7574462890625,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847998321056366,
        0.0,
        0.5299989581108093
      ],
      "plane_d": -1414.0372314453125,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1605.0,
        637.5,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": -549.0789184570312,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1605.0,
        615.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.847998321056366,
        -0.5299989581108093
      ],
      "plane_d": -434.59912109375,
      "bbox_min": [
        1580.0,
        580.0,
        100.0
      ],
      "bbox_max": [
        1605.0,
        615.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        0.5299989581108093
      ],
      "plane_d": 455.799072265625,
      "bbox_min": [
        1580.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1605.0,
        615.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000774383544922,
        -0.3314027488231659,
        0.5000483393669128
      ],
      "plane_d": -1130.3165283203125,
      "bbox_min": [
        1590.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1605.0,
        615.0,
        110.7452392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33139660954475403,
        -0.8000755906105042,
        0.5000553727149963
      ],
      "plane_d": -96.88076782226562,
      "bbox_min": [
        1590.0,
        600.0,
        100.0
      ],
      "bbox_max": [
        1600.6065673828125,
        607.928955078125,
        109.73117065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3314041197299957,
        -0.8000714778900146,
        -0.5000569224357605
      ],
      "plane_d": 11.116832733154297,
      "bbox_min": [
        1590.0,
        605.0,
        108.0
      ],
      "bbox_max": [
        1597.071044921875,
        607.928955078125,
        109.73117065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000763058662415,
        -0.3314061462879181,
        -0.5000477433204651
      ],
      "plane_d": -1022.3020629882812,
      "bbox_min": [
        1595.22412109375,
        606.0819091796875,
        108.0
      ],
      "bbox_max": [
        1600.0,
        615.0,
        110.7452392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3314041197299957,
        -0.8000714778900146,
        -0.5000569224357605
      ],
      "plane_d": 11.116832733154297,
      "bbox_min": [
        1595.22412109375,
        606.0819091796875,
        108.0
      ],
      "bbox_max": [
        1598.2843017578125,
        607.928955078125,
        110.7452392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.847998321056366,
        -0.5299989581108093
      ],
      "plane_d": 570.2788696289062,
      "bbox_min": [
        1580.0,
        600.0,
        108.0
      ],
      "bbox_max": [
        1598.2843017578125,
        606.7156982421875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3314041197299957,
        -0.8000714778900146,
        -0.5000569224357605
      ],
      "plane_d": 11.116832733154297,
      "bbox_min": [
        1590.0,
        600.0,
        108.0
      ],
      "bbox_max": [
        1598.2843017578125,
        606.7156982421875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847998321056366,
        0.0,
        -0.5299989581108093
      ],
      "plane_d": -1299.5574951171875,
      "bbox_min": [
        1595.0,
        602.071044921875,
        108.0
      ],
      "bbox_max": [
        1605.0,
        637.5,
        116.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8000763058662415,
        -0.3314061462879181,
        -0.5000477433204651
      ],
      "plane_d": -1022.3020629882812,
      "bbox_min": [
        1595.0,
        602.071044921875,
        108.0
      ],
      "bbox_max": [
        1605.0,
        615.0,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3314041197299957,
        -0.8000714778900146,
        -0.5000569224357605
      ],
      "plane_d": 11.116832733154297,
      "bbox_min": [
        1595.0,
        602.071044921875,
        110.7452392578125
      ],
      "bbox_max": [
        1600.6065673828125,
        606.7156982421875,
        116.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1249.662109375,
      "bbox_min": [
        1580.0,
        540.0,
        118.0
      ],
      "bbox_max": [
        1637.5,
        637.5,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        1620.0,
        590.0,
        118.0
      ],
      "bbox_max": [
        1637.5,
        600.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1620.0,
        600.0,
        118.0
      ],
      "bbox_max": [
        1637.5,
        600.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 1394.9715576171875,
      "bbox_min": [
        1580.0,
        540.0,
        118.0
      ],
      "bbox_max": [
        1630.0,
        637.5,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        1620.0,
        590.0,
        125.0
      ],
      "bbox_max": [
        1630.0,
        600.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        1620.0,
        600.0,
        125.0
      ],
      "bbox_max": [
        1630.0,
        600.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -1374.6282958984375,
      "bbox_min": [
        1580.0,
        540.0,
        118.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.8137335181236267,
        0.5812381505966187
      ],
      "plane_d": -512.0708618164062,
      "bbox_min": [
        1580.0,
        540.0,
        118.0
      ],
      "bbox_max": [
        1605.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137335181236267,
        0.5812381505966187
      ],
      "plane_d": 383.0360107421875,
      "bbox_min": [
        1580.0,
        540.0,
        118.0
      ],
      "bbox_max": [
        1605.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137335181236267,
        -0.5812381505966187
      ],
      "plane_d": -366.7613525390625,
      "bbox_min": [
        1580.0,
        540.0,
        125.0
      ],
      "bbox_max": [
        1600.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8137335181236267,
        -0.5812381505966187
      ],
      "plane_d": 528.3455200195312,
      "bbox_min": [
        1580.0,
        555.0,
        125.0
      ],
      "bbox_max": [
        1600.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1229.31884765625,
      "bbox_min": [
        1595.0,
        540.0,
        118.0
      ],
      "bbox_max": [
        1625.0,
        637.5,
        132.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8137335181236267,
        -0.5812381505966187
      ],
      "plane_d": -366.7613525390625,
      "bbox_min": [
        1595.0,
        540.0,
        125.0
      ],
      "bbox_max": [
        1605.0,
        560.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8137335181236267,
        -0.5812381505966187
      ],
      "plane_d": -366.7613525390625,
      "bbox_min": [
        1600.0,
        540.0,
        125.0
      ],
      "bbox_max": [
        1625.0,
        545.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        1580.0,
        630.0,
        85.0
      ],
      "bbox_max": [
        1637.5,
        637.5,
        98.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1600.0,
        630.0,
        85.0
      ],
      "bbox_max": [
        1620.0,
        637.5,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1600.0,
        630.0,
        85.0
      ],
      "bbox_max": [
        1600.0,
        637.5,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        1580.0,
        637.5,
        85.0
      ],
      "bbox_max": [
        1637.5,
        670.0,
        363.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 652.5,
      "bbox_min": [
        1580.0,
        637.5,
        85.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        348.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -348.0,
      "bbox_min": [
        1580.0,
        652.5,
        85.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1580.0,
        652.5,
        85.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1595.0,
        652.5,
        98.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1595.0,
        652.5,
        98.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        652.5,
        98.0
      ],
      "bbox_max": [
        1595.0,
        667.5,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.847998321056366,
        0.0,
        0.5299989581108093
      ],
      "plane_d": 1320.7574462890625,
      "bbox_min": [
        1595.0,
        652.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1229.31884765625,
      "bbox_min": [
        1595.0,
        652.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1595.0,
        652.5,
        118.0
      ],
      "bbox_max": [
        1605.0,
        667.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        665.0,
        118.0
      ],
      "bbox_max": [
        1595.0,
        667.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        652.5,
        118.0
      ],
      "bbox_max": [
        1595.0,
        655.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 1394.9715576171875,
      "bbox_min": [
        1595.0,
        652.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847998321056366,
        0.0,
        0.5299989581108093
      ],
      "plane_d": -1414.0372314453125,
      "bbox_min": [
        1595.0,
        652.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        652.5,
        100.0
      ],
      "bbox_max": [
        1595.0,
        667.5,
        115.99988555908203
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.847998321056366,
        0.0,
        -0.5299989581108093
      ],
      "plane_d": -1299.5574951171875,
      "bbox_min": [
        1595.0,
        652.5,
        108.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -1374.6282958984375,
      "bbox_min": [
        1595.0,
        652.5,
        115.99988555908203
      ],
      "bbox_max": [
        1606.2501220703125,
        670.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        652.5,
        115.99988555908203
      ],
      "bbox_max": [
        1605.0,
        667.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1595.0,
        655.0,
        118.0
      ],
      "bbox_max": [
        1605.0,
        665.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1605.0,
        652.5,
        118.0
      ],
      "bbox_max": [
        1606.2501220703125,
        670.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1249.662109375,
      "bbox_min": [
        1618.7498779296875,
        652.5,
        118.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1618.7498779296875,
        652.5,
        118.0
      ],
      "bbox_max": [
        1620.0,
        670.0,
        118.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1605.0,
        652.5,
        116.0
      ],
      "bbox_max": [
        1620.0,
        670.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1606.2501220703125,
        652.5,
        116.0
      ],
      "bbox_max": [
        1618.75,
        670.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1617.0,
      "bbox_min": [
        1608.0,
        655.0,
        116.0
      ],
      "bbox_max": [
        1617.0,
        665.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1608.0,
      "bbox_min": [
        1608.0,
        655.0,
        116.0
      ],
      "bbox_max": [
        1617.0,
        665.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -655.0,
      "bbox_min": [
        1608.0,
        655.0,
        116.0
      ],
      "bbox_max": [
        1617.0,
        665.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1608.0,
        665.0,
        116.0
      ],
      "bbox_max": [
        1617.0,
        665.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1595.0,
        652.5,
        85.0
      ],
      "bbox_max": [
        1620.0,
        670.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        652.5,
        85.0
      ],
      "bbox_max": [
        1600.0,
        667.5,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        1595.0,
        655.0,
        85.0
      ],
      "bbox_max": [
        1600.0,
        665.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -655.0,
      "bbox_min": [
        1595.0,
        655.0,
        85.0
      ],
      "bbox_max": [
        1600.0,
        655.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1620.0,
        652.5,
        85.0
      ],
      "bbox_max": [
        1620.0,
        670.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1580.0,
        652.5,
        180.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        1580.0,
        652.5,
        317.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        331.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -317.0,
      "bbox_min": [
        1580.0,
        652.5,
        317.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 1510.6380615234375,
      "bbox_min": [
        1580.0,
        652.5,
        317.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1133.9957275390625,
      "bbox_min": [
        1580.0,
        652.5,
        317.0
      ],
      "bbox_max": [
        1625.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 667.5,
      "bbox_min": [
        1580.0,
        652.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        670.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1113.65234375,
      "bbox_min": [
        1600.0,
        667.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        670.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -1490.294677734375,
      "bbox_min": [
        1600.0,
        667.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        670.0,
        324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        652.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        667.5,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -655.0,
      "bbox_min": [
        1595.0,
        652.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        667.5,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1113.65234375,
      "bbox_min": [
        1600.0,
        652.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        655.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8137334585189819,
        -0.0,
        0.5812382102012634
      ],
      "plane_d": -1490.2947998046875,
      "bbox_min": [
        1600.0,
        652.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        655.0,
        324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1113.65234375,
      "bbox_min": [
        1595.0,
        655.0,
        317.0
      ],
      "bbox_max": [
        1605.0,
        667.5,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1595.0,
        665.0,
        317.0
      ],
      "bbox_max": [
        1605.0,
        665.0,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1595.0,
        665.0,
        317.0
      ],
      "bbox_max": [
        1605.0,
        665.0,
        324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 669.0,
      "bbox_min": [
        1580.0,
        652.5,
        180.0
      ],
      "bbox_max": [
        1624.0,
        670.0,
        195.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1585.0,
      "bbox_min": [
        1585.0,
        669.0,
        184.0
      ],
      "bbox_max": [
        1595.0,
        670.0,
        194.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        1585.0,
        669.0,
        184.0
      ],
      "bbox_max": [
        1595.0,
        670.0,
        194.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1595.0,
        669.0,
        184.0
      ],
      "bbox_max": [
        1595.0,
        670.0,
        194.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1624.0,
      "bbox_min": [
        1580.0,
        652.5,
        180.0
      ],
      "bbox_max": [
        1624.0,
        669.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -655.0,
      "bbox_min": [
        1580.0,
        652.5,
        180.0
      ],
      "bbox_max": [
        1595.0,
        655.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1595.0,
      "bbox_min": [
        1595.0,
        652.5,
        180.0
      ],
      "bbox_max": [
        1595.0,
        655.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.0,
      "bbox_min": [
        1580.0,
        637.5,
        85.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        348.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -348.0,
      "bbox_min": [
        1595.0,
        637.5,
        85.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1595.0,
        637.5,
        85.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1595.0,
        637.5,
        85.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 132.0,
      "bbox_min": [
        1595.0,
        637.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1595.0,
        637.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.847998321056366,
        0.0,
        0.5299989581108093
      ],
      "plane_d": 1320.7574462890625,
      "bbox_min": [
        1595.0,
        637.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 1394.9715576171875,
      "bbox_min": [
        1595.0,
        637.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1595.0,
        637.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        132.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.847998321056366,
        0.0,
        -0.5299989581108093
      ],
      "plane_d": 1435.2371826171875,
      "bbox_min": [
        1595.0,
        637.5,
        100.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 116.0,
      "bbox_min": [
        1595.0,
        637.5,
        100.0
      ],
      "bbox_max": [
        1620.0,
        652.5,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1617.0,
      "bbox_min": [
        1608.0,
        640.0,
        116.0
      ],
      "bbox_max": [
        1617.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1608.0,
      "bbox_min": [
        1608.0,
        640.0,
        116.0
      ],
      "bbox_max": [
        1617.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1608.0,
        640.0,
        116.0
      ],
      "bbox_max": [
        1617.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1608.0,
        650.0,
        116.0
      ],
      "bbox_max": [
        1617.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847998321056366,
        0.0,
        -0.5299989581108093
      ],
      "plane_d": -1299.5574951171875,
      "bbox_min": [
        1595.0,
        637.5,
        100.0
      ],
      "bbox_max": [
        1605.0,
        652.5,
        116.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 114.0,
      "bbox_min": [
        1595.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1603.75,
        650.0,
        114.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1595.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1603.75,
        650.0,
        114.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1595.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1603.75,
        640.0,
        114.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.847998321056366,
        0.0,
        0.5299989581108093
      ],
      "plane_d": -1414.0372314453125,
      "bbox_min": [
        1595.0,
        637.5,
        100.0
      ],
      "bbox_max": [
        1605.0,
        652.5,
        108.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1595.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1605.0,
        650.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1595.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1605.0,
        640.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1249.662109375,
      "bbox_min": [
        1595.0,
        637.5,
        118.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1595.0,
        637.5,
        118.0
      ],
      "bbox_max": [
        1605.0,
        652.5,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -1374.6282958984375,
      "bbox_min": [
        1600.0,
        650.0,
        118.0
      ],
      "bbox_max": [
        1605.0,
        652.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1229.31884765625,
      "bbox_min": [
        1600.0,
        650.0,
        125.0
      ],
      "bbox_max": [
        1605.0,
        652.5,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1595.0,
        637.5,
        118.0
      ],
      "bbox_max": [
        1605.0,
        640.0,
        132.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -1374.6282958984375,
      "bbox_min": [
        1600.0,
        637.5,
        118.0
      ],
      "bbox_max": [
        1605.0,
        640.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1229.31884765625,
      "bbox_min": [
        1600.0,
        637.5,
        125.0
      ],
      "bbox_max": [
        1605.0,
        640.0,
        132.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1595.0,
        637.5,
        85.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1620.0,
        640.0,
        85.0
      ],
      "bbox_max": [
        1625.0,
        640.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1595.0,
        637.5,
        85.0
      ],
      "bbox_max": [
        1600.0,
        652.5,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1595.0,
        640.0,
        85.0
      ],
      "bbox_max": [
        1600.0,
        640.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1595.0,
        637.5,
        180.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        1595.0,
        637.5,
        317.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -317.0,
      "bbox_min": [
        1595.0,
        637.5,
        317.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": 1510.6380615234375,
      "bbox_min": [
        1595.0,
        637.5,
        317.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": 1133.9957275390625,
      "bbox_min": [
        1595.0,
        637.5,
        317.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1595.0,
        637.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        652.5,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1113.65234375,
      "bbox_min": [
        1600.0,
        650.0,
        317.0
      ],
      "bbox_max": [
        1605.0,
        652.5,
        331.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8137334585189819,
        -0.0,
        0.5812382102012634
      ],
      "plane_d": -1490.2947998046875,
      "bbox_min": [
        1600.0,
        650.0,
        317.0
      ],
      "bbox_max": [
        1605.0,
        652.5,
        324.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1595.0,
        637.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        640.0,
        331.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        -0.5812382102012634
      ],
      "plane_d": -1113.65234375,
      "bbox_min": [
        1600.0,
        637.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        640.0,
        331.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8137334585189819,
        0.0,
        0.5812382102012634
      ],
      "plane_d": -1490.294677734375,
      "bbox_min": [
        1600.0,
        637.5,
        317.0
      ],
      "bbox_max": [
        1605.0,
        640.0,
        324.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1624.0,
      "bbox_min": [
        1624.0,
        637.5,
        180.0
      ],
      "bbox_max": [
        1625.0,
        652.5,
        195.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1624.0,
        640.0,
        180.0
      ],
      "bbox_max": [
        1625.0,
        650.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1624.0,
        640.0,
        180.0
      ],
      "bbox_max": [
        1625.0,
        650.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1624.0,
        640.0,
        190.0
      ],
      "bbox_max": [
        1625.0,
        650.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 331.0,
      "bbox_min": [
        1580.0,
        637.5,
        331.0
      ],
      "bbox_max": [
        1595.0,
        652.5,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -348.0,
      "bbox_min": [
        1580.0,
        637.5,
        348.0
      ],
      "bbox_max": [
        1595.0,
        652.5,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 652.5,
      "bbox_min": [
        1625.0,
        637.5,
        85.0
      ],
      "bbox_max": [
        1637.5,
        660.0,
        363.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -348.0,
      "bbox_min": [
        1625.0,
        652.5,
        348.0
      ],
      "bbox_max": [
        1637.5,
        660.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 363.0,
      "bbox_min": [
        1625.0,
        637.5,
        195.0
      ],
      "bbox_max": [
        1637.5,
        652.5,
        363.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1625.0,
        637.5,
        195.0
      ],
      "bbox_max": [
        1637.5,
        652.5,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        1640.0,
        538.75,
        63.31221389770508
      ],
      "bbox_max": [
        1770.0,
        670.0,
        85.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.001050728838890791,
        0.09950366616249084,
        0.9950367212295532
      ],
      "plane_d": -124.48885345458984,
      "bbox_min": [
        1760.0,
        620.0,
        63.31221389770508
      ],
      "bbox_max": [
        1770.0,
        636.6666870117188,
        64.96832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1760.0,
      "bbox_min": [
        1640.0,
        538.75,
        80.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1660.0,
      "bbox_min": [
        1640.0,
        538.75,
        80.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        85.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1640.0,
        560.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        650.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1640.0,
        560.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        560.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1640.0,
        538.75,
        84.9999771118164
      ],
      "bbox_max": [
        1770.0,
        670.0,
        348.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1640.0,
        538.75,
        84.9999771118164
      ],
      "bbox_max": [
        1770.0,
        650.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1640.0,
        538.75,
        98.0
      ],
      "bbox_max": [
        1770.0,
        650.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1660.0,
        560.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        650.0,
        258.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1760.0,
        620.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        650.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1760.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1770.0,
        650.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31455087661743164,
        0.0,
        -0.9492406249046326
      ],
      "plane_d": -387.60418701171875,
      "bbox_min": [
        1660.0,
        560.0,
        118.0
      ],
      "bbox_max": [
        1710.0,
        650.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 142.0,
      "bbox_min": [
        1660.0,
        560.0,
        141.74517822265625
      ],
      "bbox_max": [
        1660.7689208984375,
        650.0,
        142.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1660.0,
        560.0,
        141.74517822265625
      ],
      "bbox_max": [
        1660.7689208984375,
        560.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 142.0,
      "bbox_min": [
        1660.0,
        560.0,
        118.0
      ],
      "bbox_max": [
        1687.4111328125,
        650.0,
        142.0
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1660.0,
        560.0,
        118.0
      ],
      "bbox_max": [
        1687.4111328125,
        650.0,
        142.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -615.5,
      "bbox_min": [
        1680.0,
        585.5,
        127.68624877929688
      ],
      "bbox_max": [
        1687.4111328125,
        624.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -585.5,
      "bbox_min": [
        1680.0,
        585.5,
        127.68624877929688
      ],
      "bbox_max": [
        1687.4111328125,
        594.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 594.5,
      "bbox_min": [
        1680.0,
        594.5,
        127.68624877929688
      ],
      "bbox_max": [
        1687.4111328125,
        594.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 624.5,
      "bbox_min": [
        1680.0,
        624.5,
        127.68624877929688
      ],
      "bbox_max": [
        1687.4111328125,
        624.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1660.0,
        560.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        645.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -490.22869873046875,
      "bbox_min": [
        1660.0,
        564.5,
        118.0
      ],
      "bbox_max": [
        1677.8184814453125,
        645.5,
        142.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -547.3377075195312,
      "bbox_min": [
        1660.0,
        564.5,
        118.0
      ],
      "bbox_max": [
        1677.8184814453125,
        641.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -464.50390625,
      "bbox_min": [
        1660.0,
        568.917724609375,
        118.0
      ],
      "bbox_max": [
        1677.8184814453125,
        641.082275390625,
        142.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8574929237365723,
        -0.5144957900047302
      ],
      "plane_d": 573.0625610351562,
      "bbox_min": [
        1660.0,
        568.917724609375,
        118.0
      ],
      "bbox_max": [
        1677.8184814453125,
        615.7837524414062,
        142.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9238832592964172,
        0.3826744556427002,
        -0.0
      ],
      "plane_d": -1777.7127685546875,
      "bbox_min": [
        1661.4176025390625,
        594.21630859375,
        122.99998474121094
      ],
      "bbox_max": [
        1677.8184814453125,
        615.7837524414062,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238832592964172,
        -0.3826744556427002,
        0.0
      ],
      "plane_d": -1314.6766357421875,
      "bbox_min": [
        1661.4176025390625,
        594.21630859375,
        123.00005340576172
      ],
      "bbox_max": [
        1677.8184814453125,
        611.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238832592964172,
        -0.3826744556427002,
        0.0
      ],
      "plane_d": 1766.4739990234375,
      "bbox_min": [
        1661.4176025390625,
        598.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        611.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238832592964172,
        0.3826744556427002,
        0.0
      ],
      "plane_d": 1303.4378662109375,
      "bbox_min": [
        1661.4176025390625,
        598.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        611.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38263896107673645,
        0.923897922039032,
        -0.0
      ],
      "plane_d": -1202.628173828125,
      "bbox_min": [
        1661.4176025390625,
        598.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        611.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38263896107673645,
        0.923897922039032,
        0.0
      ],
      "plane_d": 73.47283935546875,
      "bbox_min": [
        1661.4176025390625,
        598.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        611.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38263896107673645,
        -0.923897922039032,
        0.0
      ],
      "plane_d": -84.71160888671875,
      "bbox_min": [
        1661.4176025390625,
        598.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        611.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38263896107673645,
        -0.923897922039032,
        0.0
      ],
      "plane_d": 1191.389404296875,
      "bbox_min": [
        1661.4176025390625,
        598.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        611.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1661.4176025390625,
        598.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        611.082275390625,
        142.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.9238827228546143,
        -0.38267576694488525,
        -0.0
      ],
      "plane_d": 1776.712646484375,
      "bbox_min": [
        1662.5,
        600.0,
        135.0
      ],
      "bbox_max": [
        1672.5,
        610.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238827228546143,
        0.38267576694488525,
        0.0
      ],
      "plane_d": 1313.675048828125,
      "bbox_min": [
        1662.5,
        600.0,
        135.0
      ],
      "bbox_max": [
        1672.5,
        610.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238827228546143,
        0.38267576694488525,
        0.0
      ],
      "plane_d": -1767.473876953125,
      "bbox_min": [
        1662.5,
        600.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        610.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238827228546143,
        -0.38267576694488525,
        0.0
      ],
      "plane_d": -1304.436279296875,
      "bbox_min": [
        1662.5,
        600.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        610.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 83.75164794921875,
      "bbox_min": [
        1663.9644775390625,
        600.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        610.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": -1192.4189453125,
      "bbox_min": [
        1663.9644775390625,
        600.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        610.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        -0.0
      ],
      "plane_d": 1201.65771484375,
      "bbox_min": [
        1663.9644775390625,
        608.53564453125,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        610.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -74.51275634765625,
      "bbox_min": [
        1663.9644775390625,
        608.53564453125,
        135.0
      ],
      "bbox_max": [
        1667.5,
        610.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5734623670578003,
        0.0,
        0.8192319273948669
      ],
      "plane_d": 861.0127563476562,
      "bbox_min": [
        1677.1429443359375,
        594.21630859375,
        123.00005340576172
      ],
      "bbox_max": [
        1677.8184814453125,
        594.5,
        123.47291564941406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 615.5,
      "bbox_min": [
        1677.142822265625,
        615.5,
        122.99998474121094
      ],
      "bbox_max": [
        1677.8184814453125,
        615.5,
        123.47291564941406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238832592964172,
        0.3826744556427002,
        -0.0
      ],
      "plane_d": -1766.2325439453125,
      "bbox_min": [
        1661.4176025390625,
        568.917724609375,
        123.00005340576172
      ],
      "bbox_max": [
        1677.8184814453125,
        585.78369140625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238832592964172,
        0.3826744556427002,
        0.0
      ],
      "plane_d": 1314.9180908203125,
      "bbox_min": [
        1661.4176025390625,
        568.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        581.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238832592964172,
        -0.3826744556427002,
        0.0
      ],
      "plane_d": -1326.1568603515625,
      "bbox_min": [
        1661.4176025390625,
        568.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        581.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238832592964172,
        -0.3826744556427002,
        0.0
      ],
      "plane_d": 1754.9937744140625,
      "bbox_min": [
        1661.4176025390625,
        568.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        581.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38263896107673645,
        0.923897922039032,
        -0.0
      ],
      "plane_d": -1174.9111328125,
      "bbox_min": [
        1661.4176025390625,
        568.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        581.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38263896107673645,
        0.923897922039032,
        0.0
      ],
      "plane_d": 101.18975830078125,
      "bbox_min": [
        1661.4176025390625,
        568.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        581.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38263896107673645,
        -0.923897922039032,
        0.0
      ],
      "plane_d": -112.4285888671875,
      "bbox_min": [
        1661.4176025390625,
        568.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        581.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38263896107673645,
        -0.923897922039032,
        0.0
      ],
      "plane_d": 1163.67236328125,
      "bbox_min": [
        1661.4176025390625,
        568.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        581.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1661.4176025390625,
        568.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        581.082275390625,
        142.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.9238827228546143,
        0.38267576694488525,
        0.0
      ],
      "plane_d": 1325.1552734375,
      "bbox_min": [
        1662.5,
        570.0,
        135.0
      ],
      "bbox_max": [
        1672.5,
        580.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238827228546143,
        0.38267576694488525,
        0.0
      ],
      "plane_d": -1755.9935302734375,
      "bbox_min": [
        1662.5,
        570.0,
        135.0
      ],
      "bbox_max": [
        1672.5,
        580.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238827228546143,
        -0.38267576694488525,
        -0.0
      ],
      "plane_d": 1765.232421875,
      "bbox_min": [
        1662.5,
        570.0,
        135.0
      ],
      "bbox_max": [
        1672.5,
        580.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238827228546143,
        -0.38267576694488525,
        0.0
      ],
      "plane_d": -1315.91650390625,
      "bbox_min": [
        1662.5,
        570.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        580.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 111.46832275390625,
      "bbox_min": [
        1663.9644775390625,
        570.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        580.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": -1164.7021484375,
      "bbox_min": [
        1663.9644775390625,
        570.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        580.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        -0.0
      ],
      "plane_d": 1173.941162109375,
      "bbox_min": [
        1663.9644775390625,
        578.53564453125,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        580.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -102.22943115234375,
      "bbox_min": [
        1663.9644775390625,
        578.53564453125,
        135.0
      ],
      "bbox_max": [
        1667.5,
        580.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5734623670578003,
        0.0,
        0.8192319273948669
      ],
      "plane_d": 861.0127563476562,
      "bbox_min": [
        1670.0,
        585.5,
        118.0
      ],
      "bbox_max": [
        1677.8184814453125,
        594.5,
        123.47291564941406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 585.5,
      "bbox_min": [
        1670.0,
        585.5,
        118.0
      ],
      "bbox_max": [
        1677.5736083984375,
        594.5,
        123.00005340576172
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238832592964172,
        -0.3826744556427002,
        0.0
      ],
      "plane_d": -1303.1964111328125,
      "bbox_min": [
        1661.4176025390625,
        624.2161865234375,
        122.99993133544922
      ],
      "bbox_max": [
        1677.8184814453125,
        641.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238832592964172,
        -0.3826744556427002,
        0.0
      ],
      "plane_d": 1777.9542236328125,
      "bbox_min": [
        1661.4176025390625,
        628.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        641.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238832592964172,
        0.3826744556427002,
        0.0
      ],
      "plane_d": 1291.9576416015625,
      "bbox_min": [
        1661.4176025390625,
        628.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        641.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238832592964172,
        0.3826744556427002,
        -0.0
      ],
      "plane_d": -1789.1929931640625,
      "bbox_min": [
        1661.4176025390625,
        628.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        641.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38263896107673645,
        0.923897922039032,
        0.0
      ],
      "plane_d": 45.75592041015625,
      "bbox_min": [
        1661.4176025390625,
        628.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        641.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38263896107673645,
        0.923897922039032,
        -0.0
      ],
      "plane_d": -1230.344970703125,
      "bbox_min": [
        1661.4176025390625,
        628.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        641.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38263896107673645,
        -0.923897922039032,
        0.0
      ],
      "plane_d": -56.99468994140625,
      "bbox_min": [
        1661.4176025390625,
        628.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        641.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38263896107673645,
        -0.923897922039032,
        0.0
      ],
      "plane_d": 1219.106201171875,
      "bbox_min": [
        1661.4176025390625,
        628.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        641.082275390625,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1661.4176025390625,
        628.917724609375,
        135.0
      ],
      "bbox_max": [
        1673.5823974609375,
        641.082275390625,
        142.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.9238827228546143,
        -0.38267576694488525,
        -0.0
      ],
      "plane_d": 1788.19287109375,
      "bbox_min": [
        1662.5,
        630.0,
        135.0
      ],
      "bbox_max": [
        1672.5,
        640.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238827228546143,
        0.38267576694488525,
        0.0
      ],
      "plane_d": 1302.1947021484375,
      "bbox_min": [
        1662.5,
        630.0,
        135.0
      ],
      "bbox_max": [
        1672.5,
        640.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238827228546143,
        0.38267576694488525,
        0.0
      ],
      "plane_d": -1778.9541015625,
      "bbox_min": [
        1662.5,
        630.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        640.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238827228546143,
        -0.38267576694488525,
        0.0
      ],
      "plane_d": -1292.9559326171875,
      "bbox_min": [
        1662.5,
        630.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        640.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        -0.9238893389701843,
        -0.0
      ],
      "plane_d": 1229.37451171875,
      "bbox_min": [
        1663.9644775390625,
        630.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        640.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": 56.03497314453125,
      "bbox_min": [
        1663.9644775390625,
        630.0,
        135.0
      ],
      "bbox_max": [
        1671.0355224609375,
        640.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        0.9238893389701843,
        0.0
      ],
      "plane_d": -1220.135498046875,
      "bbox_min": [
        1663.9644775390625,
        630.0,
        135.0
      ],
      "bbox_max": [
        1667.5,
        640.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38265982270240784,
        -0.9238893389701843,
        0.0
      ],
      "plane_d": -46.79608154296875,
      "bbox_min": [
        1663.9644775390625,
        638.53564453125,
        135.0
      ],
      "bbox_max": [
        1667.5,
        640.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5734623670578003,
        0.0,
        0.8192319273948669
      ],
      "plane_d": 861.0127563476562,
      "bbox_min": [
        1670.0,
        615.5,
        118.0
      ],
      "bbox_max": [
        1677.8184814453125,
        624.5,
        123.47291564941406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -624.5,
      "bbox_min": [
        1670.0,
        624.5,
        118.0
      ],
      "bbox_max": [
        1677.5736083984375,
        624.5,
        122.99993133544922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1710.0,
      "bbox_min": [
        1674.984619140625,
        560.0,
        118.0
      ],
      "bbox_max": [
        1710.0,
        650.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1674.984619140625,
        560.0,
        118.0
      ],
      "bbox_max": [
        1710.0,
        650.0,
        155.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1674.984619140625,
        560.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        650.0,
        125.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 615.5,
      "bbox_min": [
        1674.984619140625,
        564.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        645.5,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -624.5,
      "bbox_min": [
        1674.984619140625,
        624.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        645.5,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -490.22869873046875,
      "bbox_min": [
        1674.9847412109375,
        624.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        645.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -598.7872924804688,
      "bbox_min": [
        1674.9847412109375,
        624.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        627.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -594.5,
      "bbox_min": [
        1674.984619140625,
        564.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        615.5,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 585.5,
      "bbox_min": [
        1674.984619140625,
        564.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        585.5,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -438.77911376953125,
      "bbox_min": [
        1674.9847412109375,
        564.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        585.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -547.3377075195312,
      "bbox_min": [
        1674.9847412109375,
        564.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        567.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -464.50390625,
      "bbox_min": [
        1674.9847412109375,
        594.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        615.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -573.0625610351562,
      "bbox_min": [
        1674.9847412109375,
        594.5,
        118.0
      ],
      "bbox_max": [
        1680.0,
        597.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1690.0,
      "bbox_min": [
        1678.609130859375,
        560.0,
        125.0
      ],
      "bbox_max": [
        1710.0,
        650.0,
        155.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1678.609130859375,
        560.0,
        125.0
      ],
      "bbox_max": [
        1690.0,
        650.0,
        142.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -615.5,
      "bbox_min": [
        1680.0,
        615.5,
        125.0
      ],
      "bbox_max": [
        1690.0,
        624.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 142.0,
      "bbox_min": [
        1687.4111328125,
        615.5,
        142.0
      ],
      "bbox_max": [
        1690.0,
        624.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -585.5,
      "bbox_min": [
        1680.0,
        585.5,
        125.0
      ],
      "bbox_max": [
        1690.0,
        594.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 142.0,
      "bbox_min": [
        1687.4111328125,
        585.5,
        142.0
      ],
      "bbox_max": [
        1690.0,
        594.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1678.609130859375,
        560.0,
        125.0
      ],
      "bbox_max": [
        1680.0,
        560.0,
        127.68639373779297
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -580.0,
      "bbox_min": [
        1690.0,
        580.0,
        125.0
      ],
      "bbox_max": [
        1710.0,
        650.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1700.5,
      "bbox_min": [
        1690.0,
        649.0,
        130.0
      ],
      "bbox_max": [
        1702.0,
        650.0,
        154.83432006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 649.5,
      "bbox_min": [
        1700.5,
        649.0,
        130.0
      ],
      "bbox_max": [
        1702.0,
        650.0,
        154.83432006835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1701.5,
      "bbox_min": [
        1700.5,
        649.5,
        130.0
      ],
      "bbox_max": [
        1702.0,
        650.0,
        154.50294494628906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -133.0,
      "bbox_min": [
        1700.5,
        649.5,
        130.0
      ],
      "bbox_max": [
        1701.5,
        650.0,
        133.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1700.5,
        649.5,
        130.0
      ],
      "bbox_max": [
        1701.5,
        650.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1702.0,
      "bbox_min": [
        1701.5,
        649.5,
        130.0
      ],
      "bbox_max": [
        1702.0,
        650.0,
        133.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -133.0,
      "bbox_min": [
        1701.5,
        649.5,
        130.0
      ],
      "bbox_max": [
        1702.0,
        650.0,
        133.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1702.0,
      "bbox_min": [
        1700.5,
        649.0,
        130.0
      ],
      "bbox_max": [
        1702.0,
        649.5,
        133.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1700.5,
        649.0,
        130.0
      ],
      "bbox_max": [
        1702.0,
        649.5,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1698.0,
      "bbox_min": [
        1698.0,
        649.0,
        130.0
      ],
      "bbox_max": [
        1700.5,
        650.0,
        133.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1698.0,
        649.0,
        130.0
      ],
      "bbox_max": [
        1700.5,
        650.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 649.5,
      "bbox_min": [
        1690.0,
        649.5,
        133.0
      ],
      "bbox_max": [
        1699.5,
        650.0,
        143.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1699.5,
      "bbox_min": [
        1690.0,
        649.5,
        133.0
      ],
      "bbox_max": [
        1699.5,
        650.0,
        143.03109741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659211039543152,
        0.0,
        -0.25883665680885315
      ],
      "plane_d": 1676.8541259765625,
      "bbox_min": [
        1690.0,
        649.5,
        133.0
      ],
      "bbox_max": [
        1699.5,
        650.0,
        143.03109741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707094132900238,
        0.0,
        0.7071194052696228
      ],
      "plane_d": -1301.609130859375,
      "bbox_min": [
        1697.75,
        649.5,
        140.00001525878906
      ],
      "bbox_max": [
        1699.5,
        650.0,
        143.03109741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965931236743927,
        0.0,
        0.2587989568710327
      ],
      "plane_d": -1677.83203125,
      "bbox_min": [
        1699.0311279296875,
        649.5,
        140.00001525878906
      ],
      "bbox_max": [
        1699.5,
        650.0,
        141.75001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1698.5,
      "bbox_min": [
        1690.0,
        649.5,
        133.0
      ],
      "bbox_max": [
        1698.5,
        650.0,
        142.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 142.5,
      "bbox_min": [
        1690.0,
        649.5,
        141.25001525878906
      ],
      "bbox_max": [
        1698.1650390625,
        650.0,
        142.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881466269493103,
        0.0,
        -0.965927004814148
      ],
      "plane_d": 576.59423828125,
      "bbox_min": [
        1696.0,
        649.5,
        141.25001525878906
      ],
      "bbox_max": [
        1698.1650390625,
        650.0,
        142.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071126699447632,
        0.0,
        -0.7071008682250977
      ],
      "plane_d": 1300.6719970703125,
      "bbox_min": [
        1697.25,
        649.5,
        141.25001525878906
      ],
      "bbox_max": [
        1698.1650390625,
        650.0,
        142.16506958007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238800406455994,
        0.0,
        -0.3826822340488434
      ],
      "plane_d": -1468.2135009765625,
      "bbox_min": [
        1640.0,
        560.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        650.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826822340488434,
        0.0,
        -0.9238800406455994
      ],
      "plane_d": -503.7989501953125,
      "bbox_min": [
        1640.0,
        560.0,
        122.68580627441406
      ],
      "bbox_max": [
        1648.0,
        650.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1640.0,
        560.0,
        134.0
      ],
      "bbox_max": [
        1648.0,
        560.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1640.0,
        560.0,
        122.68580627441406
      ],
      "bbox_max": [
        1645.6568603515625,
        560.0,
        136.34315490722656
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        1640.0,
        560.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        650.0,
        142.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 142.0,
      "bbox_min": [
        1640.0,
        560.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        650.0,
        142.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1640.0,
        560.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        645.5,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 1479.8612060546875,
      "bbox_min": [
        1652.0,
        564.5,
        118.0
      ],
      "bbox_max": [
        1660.0,
        645.5,
        123.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -464.50390625,
      "bbox_min": [
        1652.0,
        564.5,
        118.0
      ],
      "bbox_max": [
        1660.0,
        645.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -438.77911376953125,
      "bbox_min": [
        1652.0,
        564.5,
        118.0
      ],
      "bbox_max": [
        1660.0,
        597.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -547.3377075195312,
      "bbox_min": [
        1652.0,
        564.5,
        118.0
      ],
      "bbox_max": [
        1660.0,
        567.5,
        123.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -573.0625610351562,
      "bbox_min": [
        1652.0,
        594.5,
        118.0
      ],
      "bbox_max": [
        1660.0,
        597.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        -0.5144957304000854
      ],
      "plane_d": -490.22869873046875,
      "bbox_min": [
        1652.0,
        624.5,
        118.0
      ],
      "bbox_max": [
        1660.0,
        645.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8574929237365723,
        0.5144957304000854
      ],
      "plane_d": -598.7872924804688,
      "bbox_min": [
        1652.0,
        624.5,
        118.0
      ],
      "bbox_max": [
        1660.0,
        627.5,
        123.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1760.0,
      "bbox_min": [
        1640.0,
        538.75,
        84.9999771118164
      ],
      "bbox_max": [
        1760.0,
        650.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1660.0,
      "bbox_min": [
        1640.0,
        538.75,
        85.0
      ],
      "bbox_max": [
        1660.0,
        560.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        1640.0,
        560.0,
        85.0
      ],
      "bbox_max": [
        1660.0,
        560.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1660.0,
        650.0,
        85.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        348.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1760.0,
        650.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1760.0,
        650.0,
        258.0
      ],
      "bbox_max": [
        1770.0,
        670.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1760.0,
      "bbox_min": [
        1760.0,
        650.0,
        85.0
      ],
      "bbox_max": [
        1760.0,
        670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1652.2601318359375,
        510.0,
        64.16638946533203
      ],
      "bbox_max": [
        1770.0,
        628.1248779296875,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 1759.9998779296875,
      "bbox_min": [
        1760.0,
        610.0,
        78.0
      ],
      "bbox_max": [
        1760.0,
        619.9999389648438,
        84.9999771118164
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1652.2601318359375,
        510.0,
        85.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -88.0,
      "bbox_min": [
        1652.2601318359375,
        510.0,
        88.0
      ],
      "bbox_max": [
        1760.0,
        599.029052734375,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6246256828308105,
        0.7558990716934204,
        0.19611048698425293
      ],
      "plane_d": 643.9866333007812,
      "bbox_min": [
        1675.8082275390625,
        510.0,
        88.0
      ],
      "bbox_max": [
        1745.0,
        567.175537109375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -98.0,
      "bbox_min": [
        1678.947998046875,
        510.0,
        88.0
      ],
      "bbox_max": [
        1743.0,
        562.928466796875,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1760.0,
        620.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1760.0,
        620.0,
        258.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1760.0,
        620.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        628.125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -420.0,
      "bbox_min": [
        1562.5999755859375,
        -80.0,
        75.99349975585938
      ],
      "bbox_max": [
        1770.0,
        510.0,
        370.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        1608.2843017578125,
        -80.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        420.0,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1740.0,
      "bbox_min": [
        1740.0,
        355.0,
        140.0
      ],
      "bbox_max": [
        1760.0,
        420.0,
        180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1760.0,
      "bbox_min": [
        1740.0,
        360.0,
        145.0
      ],
      "bbox_max": [
        1760.0,
        390.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        1740.0,
        360.0,
        145.0
      ],
      "bbox_max": [
        1760.0,
        360.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        1562.5999755859375,
        420.0,
        75.99349975585938
      ],
      "bbox_max": [
        1770.0,
        510.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1562.5999755859375,
        420.0,
        80.0
      ],
      "bbox_max": [
        1760.0,
        470.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1562.5999755859375,
        430.0,
        80.0
      ],
      "bbox_max": [
        1760.0,
        470.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": -665.5321044921875,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        80.0
      ],
      "bbox_max": [
        1666.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        80.0
      ],
      "bbox_max": [
        1592.0,
        460.0,
        91.760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        -0.9284767508506775
      ],
      "plane_d": 663.6751708984375,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        80.0
      ],
      "bbox_max": [
        1587.0,
        460.0,
        89.760009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39872613549232483,
        0.0,
        -0.9170700907707214
      ],
      "plane_d": 754.150634765625,
      "bbox_min": [
        1661.4000244140625,
        460.0,
        98.0
      ],
      "bbox_max": [
        1666.0,
        470.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        100.0
      ],
      "bbox_max": [
        1661.4000244140625,
        470.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1562.5999755859375,
        450.0,
        100.0
      ],
      "bbox_max": [
        1661.4000244140625,
        470.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.39872613549232483,
        0.0,
        -0.9170700907707214
      ],
      "plane_d": 754.150634765625,
      "bbox_min": [
        1620.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        1661.4000244140625,
        470.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1760.0,
        420.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        470.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.09950371831655502,
        0.9950371980667114
      ],
      "plane_d": -126.36972045898438,
      "bbox_min": [
        1562.5999755859375,
        470.0,
        75.99349975585938
      ],
      "bbox_max": [
        1770.0,
        510.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0001616392401047051,
        0.0997437834739685,
        0.9950131773948669
      ],
      "plane_d": -126.76995849609375,
      "bbox_min": [
        1760.0,
        483.3333435058594,
        75.99349975585938
      ],
      "bbox_max": [
        1770.0,
        510.0,
        78.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1562.5999755859375,
        470.0,
        75.9950942993164
      ],
      "bbox_max": [
        1760.0,
        510.0,
        348.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -88.0,
      "bbox_min": [
        1570.0,
        470.0,
        75.9950942993164
      ],
      "bbox_max": [
        1760.0,
        510.0,
        348.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1570.0,
        490.0,
        75.9950942993164
      ],
      "bbox_max": [
        1652.2601318359375,
        510.0,
        88.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6369945406913757,
        0.7708683013916016,
        0.0
      ],
      "plane_d": 659.3378295898438,
      "bbox_min": [
        1628.056884765625,
        490.0,
        80.0
      ],
      "bbox_max": [
        1652.2601318359375,
        510.0,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        1570.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        490.0,
        88.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -97.99999237060547,
      "bbox_min": [
        1570.0,
        470.0,
        88.0
      ],
      "bbox_max": [
        1743.0,
        510.0,
        348.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        0.7071067690849304
      ],
      "plane_d": 871.155517578125,
      "bbox_min": [
        1570.0,
        470.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        510.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1570.0,
        470.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        481.1764831542969,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1570.0,
        470.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        481.1764831542969,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1570.0,
        470.0,
        118.0
      ],
      "bbox_max": [
        1580.0,
        481.1764831542969,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1562.5999755859375,
        470.0,
        100.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        138.8340606689453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1562.5999755859375,
        470.0,
        118.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        138.8340606689453
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.745241641998291,
        0.6667945384979248,
        0.0
      ],
      "plane_d": -1490.875244140625,
      "bbox_min": [
        1562.5999755859375,
        481.1708984375,
        118.0
      ],
      "bbox_max": [
        1570.0,
        489.4471130371094,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35558319091796875,
        -0.10718917846679688,
        0.9284778833389282
      ],
      "plane_d": -629.8721923828125,
      "bbox_min": [
        1562.5999755859375,
        502.7752990722656,
        138.0
      ],
      "bbox_max": [
        1564.77783203125,
        510.0,
        138.8340606689453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1562.5999755859375,
        502.7752990722656,
        138.0
      ],
      "bbox_max": [
        1564.77783203125,
        510.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9575520753860474,
        0.2882605195045471,
        0.0
      ],
      "plane_d": 1351.3433837890625,
      "bbox_min": [
        1562.5999755859375,
        488.7811279296875,
        100.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1562.5999755859375,
        488.7811279296875,
        100.0
      ],
      "bbox_max": [
        1570.0,
        510.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1562.5999755859375,
        502.7655029296875,
        100.0
      ],
      "bbox_max": [
        1564.77783203125,
        510.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -420.0,
      "bbox_min": [
        310.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        310.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        420.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        310.0,
        520.0,
        160.0
      ],
      "bbox_max": [
        310.0,
        670.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        258.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.06931208819150925,
        0.09031800925731659,
        0.9934980273246765
      ],
      "plane_d": -209.95565795898438,
      "bbox_min": [
        1250.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1250.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09839963912963867,
        0.09839963912963867,
        0.99027019739151
      ],
      "plane_d": -252.27951049804688,
      "bbox_min": [
        1289.6881103515625,
        620.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        64.96832275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1270.0,
        454.65155029296875,
        80.0
      ],
      "bbox_max": [
        1290.0,
        470.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        1270.0,
        420.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.06931208819150925,
        0.09031800925731659,
        0.9934980273246765
      ],
      "plane_d": -209.95565795898438,
      "bbox_min": [
        1270.0,
        470.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09839963912963867,
        0.09839963912963867,
        0.99027019739151
      ],
      "plane_d": -252.27951049804688,
      "bbox_min": [
        1275.7142333984375,
        621.091552734375,
        60.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        64.8908462524414
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        1270.0,
        470.0,
        98.0
      ],
      "bbox_max": [
        1290.0,
        470.0,
        100.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 7337,
      "centroid": [
        1419.0,
        615.0,
        99.62076568603516
      ],
      "bbox_min": [
        1416.0,
        612.0,
        99.62076568603516
      ],
      "bbox_max": [
        1422.0,
        618.0,
        99.62076568603516
      ],
      "dimensions_source": {
        "span_x": 6.0,
        "span_y": 6.0,
        "height_z": 0.0,
        "door_width": 6.0,
        "door_depth": 6.0,
        "leaf_depth": 6.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          1416.0,
          612.0,
          99.62076568603516
        ],
        [
          1422.0,
          618.0,
          99.62076568603516
        ],
        [
          1416.0,
          618.0,
          99.62076568603516
        ],
        [
          1422.0,
          612.0,
          99.62076568603516
        ]
      ],
      "plane_distance": 99.6208,
      "authentic_texture": "metalgrate1-t"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 23252,
      "centroid": [
        1409.800048828125,
        615.5,
        93.5
      ],
      "bbox_min": [
        1409.800048828125,
        612.5,
        91.0
      ],
      "bbox_max": [
        1409.800048828125,
        618.5,
        96.0
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 6.0,
        "height_z": 5.0,
        "door_width": 6.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          1409.800048828125,
          612.5,
          91.0
        ],
        [
          1409.800048828125,
          618.5,
          96.0
        ],
        [
          1409.800048828125,
          612.5,
          96.0
        ],
        [
          1409.800048828125,
          618.5,
          91.0
        ]
      ],
      "plane_distance": 1409.8,
      "authentic_texture": "metalgrate1-t"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 24069,
      "centroid": [
        1480.199951171875,
        615.5,
        93.5
      ],
      "bbox_min": [
        1480.199951171875,
        612.5,
        91.0
      ],
      "bbox_max": [
        1480.199951171875,
        618.5,
        96.0
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 6.0,
        "height_z": 5.0,
        "door_width": 6.0,
        "door_depth": 0.0,
        "leaf_depth": 0.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          1480.199951171875,
          612.5,
          91.0
        ],
        [
          1480.199951171875,
          618.5,
          96.0
        ],
        [
          1480.199951171875,
          612.5,
          96.0
        ],
        [
          1480.199951171875,
          618.5,
          91.0
        ]
      ],
      "plane_distance": 1480.2,
      "authentic_texture": "metalgrate1-t"
    },
    {
      "tag": "CSlidingDoor piece: 22door",
      "entity_class": "CSlidingDoor",
      "piece_name": "22door",
      "offset": 24932,
      "centroid": [
        1445.0,
        636.0,
        324.0
      ],
      "bbox_min": [
        1440.0,
        635.5,
        317.0
      ],
      "bbox_max": [
        1450.0,
        636.5,
        331.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 1.0,
        "height_z": 14.0,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          1440.0,
          635.5,
          317.0
        ],
        [
          1440.0,
          636.5,
          331.0
        ],
        [
          1440.0,
          635.5,
          331.0
        ],
        [
          1440.0,
          636.5,
          317.0
        ],
        [
          1450.0,
          635.5,
          317.0
        ],
        [
          1450.0,
          636.5,
          331.0
        ],
        [
          1450.0,
          635.5,
          331.0
        ],
        [
          1450.0,
          636.5,
          317.0
        ]
      ],
      "plane_distance": -1450.0,
      "authentic_texture": "airgums"
    },
    {
      "tag": "CSlidingDoor piece: 06door",
      "entity_class": "CSlidingDoor",
      "piece_name": "06door",
      "offset": 31191,
      "centroid": [
        1631.5,
        595.0,
        125.0
      ],
      "bbox_min": [
        1631.0,
        590.0,
        118.0
      ],
      "bbox_max": [
        1632.0,
        600.0,
        132.0
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 10.0,
        "height_z": 14.0,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          1631.0,
          590.0,
          118.0
        ],
        [
          1631.0,
          590.0,
          132.0
        ],
        [
          1632.0,
          590.0,
          118.0
        ],
        [
          1632.0,
          590.0,
          132.0
        ],
        [
          1631.0,
          600.0,
          132.0
        ],
        [
          1631.0,
          600.0,
          118.0
        ],
        [
          1632.0,
          600.0,
          132.0
        ],
        [
          1632.0,
          600.0,
          118.0
        ]
      ],
      "plane_distance": -600.0,
      "authentic_texture": "airgums"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 32455,
      "centroid": [
        1612.5,
        645.0,
        117.80000305175781
      ],
      "bbox_min": [
        1608.0,
        640.0,
        117.80000305175781
      ],
      "bbox_max": [
        1617.0,
        650.0,
        117.80000305175781
      ],
      "dimensions_source": {
        "span_x": 9.0,
        "span_y": 10.0,
        "height_z": 0.0,
        "door_width": 10.0,
        "door_depth": 9.0,
        "leaf_depth": 9.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          1608.0,
          650.0,
          117.80000305175781
        ],
        [
          1608.0,
          640.0,
          117.80000305175781
        ],
        [
          1617.0,
          640.0,
          117.80000305175781
        ],
        [
          1617.0,
          650.0,
          117.80000305175781
        ]
      ],
      "plane_distance": -117.8,
      "authentic_texture": "metalgrate1-t"
    },
    {
      "tag": "CElevator piece: 03elv",
      "entity_class": "CElevator",
      "piece_name": "03elv",
      "offset": 33266,
      "centroid": [
        1589.0,
        648.7449951171875,
        317.7249755859375
      ],
      "bbox_min": [
        1580.0,
        637.5,
        314.3499755859375
      ],
      "bbox_max": [
        1595.0,
        652.5,
        321.8499755859375
      ],
      "dimensions_source": {
        "span_x": 15.0,
        "span_y": 15.0,
        "height_z": 7.5,
        "door_width": 15.0,
        "door_depth": 15.0,
        "leaf_depth": 15.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          1590.5,
          652.489990234375,
          317.3499755859375
        ],
        [
          1592.5,
          652.489990234375,
          321.8499755859375
        ],
        [
          1592.5,
          652.489990234375,
          317.3499755859375
        ],
        [
          1590.5,
          652.489990234375,
          321.8499755859375
        ],
        [
          1590.5,
          652.489990234375,
          317.3499755859375
        ],
        [
          1588.5,
          652.489990234375,
          317.3499755859375
        ],
        [
          1588.5,
          652.489990234375,
          321.8499755859375
        ],
        [
          1590.5,
          652.489990234375,
          321.8499755859375
        ],
        [
          1580.0,
          652.5,
          314.3499755859375
        ],
        [
          1580.0,
          637.5,
          314.3499755859375
        ],
        [
          1580.0,
          637.5,
          317.3499755859375
        ],
        [
          1580.0,
          652.5,
          317.3499755859375
        ],
        [
          1595.0,
          652.5,
          314.3499755859375
        ],
        [
          1595.0,
          652.5,
          317.3499755859375
        ],
        [
          1595.0,
          637.5,
          317.3499755859375
        ],
        [
          1595.0,
          637.5,
          314.3499755859375
        ]
      ],
      "plane_distance": 652.49,
      "authentic_texture": "cbaseelevpaneldown"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 40570,
      "centroid": [
        1612.5,
        660.0,
        117.80000305175781
      ],
      "bbox_min": [
        1608.0,
        655.0,
        117.80000305175781
      ],
      "bbox_max": [
        1617.0,
        665.0,
        117.80000305175781
      ],
      "dimensions_source": {
        "span_x": 9.0,
        "span_y": 10.0,
        "height_z": 0.0,
        "door_width": 10.0,
        "door_depth": 9.0,
        "leaf_depth": 9.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          1617.0,
          665.0,
          117.80000305175781
        ],
        [
          1608.0,
          665.0,
          117.80000305175781
        ],
        [
          1608.0,
          655.0,
          117.80000305175781
        ],
        [
          1617.0,
          655.0,
          117.80000305175781
        ]
      ],
      "plane_distance": -117.8,
      "authentic_texture": "metalgrate1-t"
    }
  ],
  "tutorial_messages": []
}